/* eslint-disable */
// File generated by i18n-js
import { I18n } from "i18n-js";
const i18n = new I18n({
  "en": {
    "actions": "Actions",
    "activemodel": {
      "attributes": {
        "manual_article": {
          "article_kind": "Type d’article",
          "colors_text": "Couleurs",
          "name": "Dénomination",
          "purchase_price": "Prix d’achat HT",
          "reference": "Code article",
          "sale_price": "Prix de vente HT",
          "size_ids": "Tailles",
          "supplier_name": "Fournisseur"
        }
      }
    },
    "activerecord": {
      "attributes": {
        "address": {
          "address_type": "Type",
          "address_types": {
            "billing": "Facturation",
            "shipping": "Livraison"
          },
          "addressable_id": "Identifiant",
          "addressable_type": "Type",
          "city": "Ville",
          "company": "Entreprise",
          "country": "Pays",
          "default": "Adresse par défaut",
          "email": "Email",
          "first_name": "Prénom",
          "id": "ID",
          "last_name": "Nom",
          "latitude": "Latitude",
          "longitude": "Longitude",
          "name": "Nom de l'adresse",
          "phone": "Téléphone",
          "siren": "SIREN",
          "state": "Region",
          "street": "Rue",
          "street_information": "Informations",
          "vat_number": "Numéro de TVA",
          "zipcode": "Code postal"
        },
        "cart": {
          "id": "ID",
          "promo_code": "Code promo",
          "store": "Boutique",
          "user": "Client"
        },
        "cart_item": {
          "cart_id": "Panier",
          "customization_keys": {
            "back": "Dos",
            "chest": "Poitrine",
            "heart": "Cœur",
            "left_sleeve": "Manche gauche",
            "right_sleeve": "Manche droite"
          },
          "customizations": "Personnalisations",
          "id": "ID",
          "product_variant_id": "Produit",
          "quantity": "Quantité"
        },
        "commission": {
          "delivery_price": "Frais de livraison",
          "ends_on": "Fin",
          "id": "ID",
          "sofidial_part": "Part Sofidial",
          "starts_on": "Début",
          "store_part": "Part Club",
          "stripe_fee": "Frais Stripe",
          "total": "Total",
          "vat": "TVA"
        },
        "customer": {
          "default_global_discount_percentage": "Remise globale par défaut",
          "textile_margin_rate": "Coefficient textile"
        },
        "customer_product_price": {
          "product": "Produit",
          "product_id": "Produit",
          "unit_price": "Prix unitaire HT",
          "unit_price_cents": "Prix unitaire HT"
        },
        "estimate": {
          "customer": "Client",
          "global_discount_amount": "Remise globale (€)",
          "global_discount_amount_cents": "Remise globale (€)",
          "global_discount_percentage": "Remise globale (%)",
          "global_discount_type": "Type de remise globale",
          "items": "Lignes",
          "markings": "Marquages",
          "payment_delay_days": "Délai de paiement",
          "payment_method": "Mode de règlement",
          "payment_terms": "Modalités de règlement",
          "reference": "Référence",
          "responsible": "Responsable",
          "status": "Statut",
          "title": "Titre du devis",
          "validity_date": "Date de validité"
        },
        "estimate/items": {
          "description": "Description",
          "printing_technique": "Technique de marquage",
          "quantity": "Quantité",
          "textile_margin_rate": "Coefficient textile",
          "unit": "Unité",
          "unit_price": "Prix unitaire HT",
          "unit_price_cents": "Prix unitaire HT",
          "vat_rate": "Taux TVA"
        },
        "estimate/markings": {
          "personalized_pieces_count": "Pièces personnalisées",
          "vat_rate": "Taux TVA"
        },
        "estimate_item": {
          "customer_assets": "Fichiers du client",
          "customization_notes": "Notes personnalisation",
          "customization_price": "Prix personnalisation",
          "customization_price_cents": "Prix personnalisation",
          "description": "Description",
          "discount_amount": "Remise (€)",
          "discount_amount_cents": "Remise (€)",
          "discount_percentage": "Remise (%)",
          "discount_type": "Type de remise",
          "garment_type": "Type de vêtement",
          "line_type": "Type de ligne",
          "position": "Position",
          "pricing_status": "Statut du tarif",
          "printing_dimension_1": "Dimension",
          "printing_dimension_2": "Textile",
          "printing_price_cents": "Prix marquage",
          "printing_sub_technique": "Sous-technique",
          "printing_technique": "Technique de marquage",
          "product": "Produit",
          "product_colorway": "Coloris",
          "product_type": "Type de produit",
          "product_variant": "Variante",
          "quantity": "Quantité",
          "reference": "Référence",
          "section": "Section",
          "supplier_price_cents": "Prix fournisseur",
          "textile_margin_rate": "Coefficient textile",
          "textile_price_cents": "Prix textile",
          "unit": "Unité",
          "unit_price": "Prix unitaire HT",
          "unit_price_cents": "Prix unitaire HT",
          "vat_rate": "Taux TVA"
        },
        "estimate_item_variant": {
          "canonical_size": "Taille",
          "product_variant": "Variante",
          "quantity": "Quantité",
          "size_label": "Taille"
        },
        "estimate_marking": {
          "artwork_text": "Texte à marquer",
          "artwork_version": "Révision du fichier de marquage",
          "custom_marking_zone_name": "Zone personnalisée",
          "discount_amount_cents": "Remise (€)",
          "discount_percentage": "Remise (%)",
          "files": "Fichiers",
          "marking_zone": "Zone de marquage",
          "personalization_config": "Personnalisation",
          "personalized_pieces_count": "Pièces personnalisées",
          "pricing_status": "Statut du tarif",
          "quantity": "Quantité marquée",
          "series_key": "Série de marquage",
          "unit_price": "Prix unitaire HT",
          "unit_price_cents": "Prix unitaire HT",
          "vat_rate": "Taux TVA"
        },
        "estimate_marking_allocation": {
          "estimate_item_variant_id": "Taille",
          "item_variant": "Taille",
          "quantity": "Quantité marquée",
          "textile_type": "Type de textile"
        },
        "estimate_marking_extra": {
          "printing_extra": "Option ERP",
          "printing_extra_id": "Option ERP"
        },
        "estimate_marking_item": {
          "item": "Textile",
          "quantity": "Quantité"
        },
        "estimate_revision_delivery": {
          "recipient_email": "Adresse email du destinataire",
          "revision": "Révision"
        },
        "estimate_section": {
          "name": "Nom"
        },
        "favorite": {
          "id": "ID",
          "product_variant_id": "Produit",
          "store_id": "Boutique",
          "user_id": "Client"
        },
        "order": {
          "delivery_method": "Mode de livraison",
          "delivery_methods": {
            "delivery": "Livraison",
            "pickup": "Retrait chez %{store}"
          },
          "delivery_price": "Prix de livraison",
          "delivery_price_with_vat": "Prix de livraison TTC",
          "discount": "Remise",
          "id": "ID",
          "multiple_deliveries": "Expédition multiple",
          "paid_at": "Payée le",
          "promo_code": "Code promo",
          "reference": "Référence",
          "state": "État",
          "states": {
            "awaiting_payment": "En attente de paiement",
            "cancelled": "Annulée",
            "delivered": "Livrée",
            "paid": "Payée",
            "partially_shipped": "Partiellement expédiée",
            "pending": "En attente",
            "shipped": "Expédiée"
          },
          "store": "Boutique",
          "subtotal": "Sous-total HT",
          "subtotal_with_vat": "Sous-total TTC",
          "total": "Total HT",
          "total_with_vat": "Total TTC",
          "user": "Client",
          "vat": "TVA"
        },
        "order_item": {
          "customization_keys": {
            "back": "Dos",
            "chest": "Poitrine",
            "heart": "Cœur",
            "left_sleeve": "Manche gauche",
            "right_sleeve": "Manche droite"
          },
          "customizations": "Personnalisations",
          "id": "ID",
          "order_id": "Commande",
          "product_variant_id": "Produit",
          "quantity": "Quantité"
        },
        "parcel": {
          "carrier": "Transporteur",
          "carriers": {
            "dpd": "DPD"
          },
          "delivered_on": "Date de livraison",
          "id": "ID",
          "order_id": "Commande",
          "order_items": "Articles",
          "order_items_count": "Nombre d'articles",
          "state": "État",
          "states": {
            "delivered": "Livré",
            "pending": "En préparation",
            "returned": "Retourné",
            "shipped": "Expédié"
          },
          "tracking_number": "Numéro de suivi",
          "weight": "Poids"
        },
        "product": {
          "brand": "Marque",
          "description": "Description",
          "enabled": "Activé",
          "id": "ID",
          "images": "Images",
          "mode": "Mode",
          "modes": {
            "children": "Enfant",
            "men": "Homme",
            "mixed": "Mixte",
            "women": "Femme"
          },
          "name": "Nom",
          "product_category": "Catégorie",
          "product_category_id": "Catégorie",
          "reference": "Référence",
          "should_update_other_products_with_same_reference": "Mettre à jour les produits avec la même référence",
          "sizes_guide": "Guide des tailles",
          "sofidial_price": "Prix SOFIDIAL",
          "store": "Boutique",
          "store_id": "Boutique",
          "supplier": "Fournisseur",
          "supplier_price": "Prix fournisseur",
          "suppliers": {
            "imbretex": "Imbretex",
            "other": "Autre"
          },
          "tag_list": "Tags",
          "vat_rate": "Taux de TVA",
          "vat_rates": {
            "vat_20": "20%"
          },
          "weight": "Poids (en grammes)"
        },
        "product_category": {
          "group": "Groupe",
          "groups": {
            "accessories": "Accessoires",
            "clothing": "Vêtements"
          },
          "id": "ID",
          "name": "Nom",
          "products_count": "Nombre de produits"
        },
        "product_color": {
          "group": "Groupe de couleurs",
          "groups": {
            "ash": "Cendre",
            "black": "Noir",
            "blue": "Bleu",
            "brown": "Marron",
            "burgundy": "Bordeaux",
            "dark_grey": "Gris foncé",
            "green": "Vert",
            "grey": "Gris",
            "heather": "Herbe",
            "khaki": "Kaki",
            "misc": "Divers",
            "natural": "Naturelle",
            "navy": "Navy",
            "orange": "Orange",
            "pink": "Rose",
            "purple": "Mauve",
            "red": "Rouge",
            "sand": "Sable",
            "white": "Blanc",
            "yellow": "Jaune"
          },
          "hex": "Code hexadecimal",
          "id": "ID",
          "image": "Image",
          "name": "Nom",
          "products_count": "Nombre de produits"
        },
        "product_variant": {
          "back_image": "Image arrière",
          "description": "Description",
          "enabled": "Activée",
          "front": "Mis en avant",
          "front_image": "Image avant",
          "id": "ID",
          "images": "Images",
          "name": "Nom",
          "price": "Prix HT",
          "price_with_vat": "Prix TTC",
          "primary_image": "Image principale",
          "product_color_ids": "Couleurs",
          "product_id": "Produit",
          "reference": "Référence",
          "should_create_other_product_variants": "Créer les autres variantes de même couleur du produit",
          "should_update_other_colorless_variants": "Mettre à jour les autres variantes sans couleur du produit",
          "should_update_other_product_variants": "Mettre à jour les autres variantes du produit",
          "size": "Taille",
          "sofidial_price": "Prix SOFIDIAL HT",
          "store_id": "Boutique",
          "supplier_price": "Prix fournisseur HT",
          "weight": "Poids"
        },
        "product_variant_customization": {
          "cart_id": "Panier",
          "created_at": "Créé le",
          "id": "ID",
          "image": "Image",
          "product_variant_id": "Variante de produit",
          "updated_at": "Modifié le"
        },
        "promo_code": {
          "code_type": "Type",
          "code_types": {
            "fixed": "Fixe",
            "percentage": "Pourcentage"
          },
          "enabled": "Activé",
          "expires_at": "Expire le",
          "id": "ID",
          "name": "Nom",
          "store": "Boutique",
          "store_id": "Boutique",
          "value": "Valeur"
        },
        "proof_delivery": {
          "proof": "BAT",
          "recipient_email": "Adresse email du destinataire"
        },
        "store": {
          "accent_color": "Couleur d'accentuation",
          "account_number": "Numéro de compte comptable",
          "advanced_customization_enabled": "Activer la personnalisation avancée",
          "allow_search_engines": "Autoriser les moteurs de recherche",
          "banner": "Bannière",
          "banner_message": "Message de la bannière",
          "billing_address": "Adresse facturation",
          "billing_email": "Adresse email de facturation",
          "customization_enabled": "Activer la personnalisation",
          "delivery_enabled": "Activer la livraison",
          "description": "Description",
          "domain": "Domaine",
          "enabled": "Activé",
          "id": "ID",
          "mobile_banner": "Bannière mobile",
          "name": "Nom",
          "order_prefix": "Préfixe de commande",
          "pickup_location_name": "Nom du lieu de retrait",
          "shipping_address": "Adresse de livraison",
          "subdomain": "Sous-domaine",
          "supplier_orders_enabled": "Activer les commandes fournisseur"
        },
        "store_custom_field": {
          "description": "Description",
          "field_type": "Field type",
          "field_types": {
            "boolean": "Case à cocher",
            "date": "Date",
            "email": "Email",
            "float": "Nombre flottant",
            "integer": "Nombre entier",
            "number": "Nombre",
            "phone": "Téléphone",
            "string": "Texte",
            "text": "Texte long",
            "url": "URL"
          },
          "name": "Nom",
          "position": "Position",
          "required": "Obligatoire"
        },
        "supplier_order": {
          "external_id": "ID externe",
          "id": "ID",
          "metadata": "Métadonnées",
          "order_id": "Commande",
          "state": "État",
          "states": {
            "created": "Créée",
            "failed": "Échouée"
          },
          "supplier": "Fournisseur",
          "suppliers": {
            "imbretex": "Imbretex",
            "other": "Autre"
          }
        },
        "supply_order": {
          "suppliers": {
            "imbretex": "Imbretex",
            "other": "Autre fournisseur"
          }
        },
        "supply_order_item": {
          "quantity_ordered": "Quantité commandée",
          "quantity_received": "Quantité reçue",
          "size_label": "Taille",
          "supplier_reference": "Référence fournisseur"
        },
        "user": {
          "current_password": "Mot de passe actuel",
          "email": "Email",
          "first_name": "Prénom",
          "full_name": "Nom complet",
          "gender": "Genre",
          "genders": {
            "female": "Femme",
            "male": "Homme",
            "other": "Autre"
          },
          "id": "ID",
          "last_name": "Nom de famille",
          "password": "Mot de passe",
          "password_confirmation": "Confirmation du mot de passe",
          "user_type": "Type",
          "user_types": {
            "admin": "Admin",
            "customer": "Client",
            "store_admin": "Admin magasin"
          }
        }
      },
      "enums": {
        "customer": {
          "family": {
            "administration": "Administration",
            "individual": "Particulier",
            "professional": "Professionnel",
            "reseller": "Revendeur"
          },
          "legal_form": {
            "association": "Association",
            "autre": "Autre",
            "ei": "Entreprise Individuelle",
            "eurl": "EURL",
            "sa": "SA",
            "sarl": "SARL",
            "sas": "SAS",
            "sasu": "SASU",
            "sci": "SCI"
          }
        },
        "customer_asset": {
          "category": {
            "brand_guidelines": "Charte graphique",
            "logo": "Logo",
            "mockup": "Maquette",
            "other": "Autre",
            "photo": "Photo"
          }
        },
        "estimate": {
          "payment_method": {
            "bank_transfer": "Virement bancaire",
            "cash": "Espèces",
            "check": "Chèque",
            "credit_card": "Carte bancaire"
          },
          "status": {
            "completed": "Affaire validée",
            "draft": "Brouillon",
            "in_design": "En conception",
            "in_production": "Passé en affaire",
            "lost": "Perdu",
            "sent": "Non validé",
            "validated": "En cours"
          }
        },
        "estimate_item": {
          "discount_type": {
            "fixed": "Montant fixe",
            "percentage": "Pourcentage"
          }
        },
        "proof": {
          "status": {
            "approved": "Approuvé",
            "draft": "Brouillon",
            "pending_approval": "En attente d'approbation commerciale",
            "revision_requested": "Révision demandée",
            "sent": "Envoyé au client"
          }
        },
        "supply_order": {
          "status": {
            "failed": "En échec",
            "ordered": "Commandée",
            "pending": "Brouillon",
            "received": "Reçue"
          }
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Validation failed: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Cannot delete record because dependent %{record} exist",
            "has_one": "Cannot delete record because a dependent %{record} exists"
          }
        },
        "models": {
          "address": {
            "company_or_name_missing": "Vous devez indiquer vos nom et prénom ou votre entreprise."
          },
          "customer_product_price": {
            "attributes": {
              "product_id": {
                "taken": "a déjà un tarif pour ce client"
              }
            }
          },
          "product_variant": {
            "attributes": {
              "price": {
                "price_lower_than_sofidial_price": "doit être supérieur ou égal au prix SOFIDIAL"
              },
              "sofidial_price": {
                "sofidial_price_lower_than_supplier_price": "doit être supérieur ou égal au prix fournisseur"
              }
            }
          }
        }
      },
      "models": {
        "address": "Adresse",
        "billing_address": "Adresse de facturation",
        "cart": "Panier",
        "cart_item": "Article",
        "commission": "Commission",
        "customer_product_price": "Tarif client",
        "estimate_revision_delivery": "Envoi du devis",
        "favorite": "Favori",
        "invoice": "Facture",
        "order": "Commande",
        "order_item": "Article",
        "parcel": "Colis",
        "product": "Produit",
        "product_category": "Catégorie de produit",
        "product_color": "Couleur de produit",
        "product_variant": "Variante de produit",
        "product_variant_customization": "Personnalisation de produit",
        "production_order": "Ordre de production",
        "promo_code": "Code promo",
        "proof_delivery": "Envoi du BAT",
        "shipping_address": "Adresse de livraison",
        "store": "Boutique",
        "store_custom_field": "Champ personnalisé",
        "supplier_order": "Commande fournisseur",
        "supply_order": "Commande d'approvisionnement",
        "supply_order_item": "Ligne d'approvisionnement",
        "user": "Utilisateur"
      }
    },
    "add": "Ajouter",
    "addresses": {
      "address": {
        "type": "Type : %{type}"
      },
      "edit": {
        "edit_address": "Modifier l'adresse %{address}",
        "save": "Sauvegarder",
        "title": "Modifier une adresse"
      },
      "form": {
        "address_default_help": "Si activé, cette adresse sera utilisée comme adresse par défaut pour %{type}."
      },
      "index": {
        "my_addresses": "Mes adresses",
        "signout": "Déconnexion",
        "title": "Adresses"
      }
    },
    "admin": {
      "commissions": {
        "commission": {
          "discount": "Remise : %{amount}",
          "gross_sofidial_part": "Part Sofidial Brute : %{amount}",
          "net_sofidial_part": "Part Sofidial Nette : %{amount}",
          "store_part": "Part Club : %{amount}",
          "supplier_part": "Part Fournisseur : %{amount}",
          "total": "Total : %{amount}"
        },
        "index": {
          "title": "Commissions"
        }
      },
      "controllers": {
        "addresses": {
          "create": {
            "notice": "Adresse créée."
          },
          "destroy": {
            "notice": "Adresse supprimée."
          },
          "update": {
            "notice": "Adresse mise à jour."
          }
        }
      },
      "dashboard": {
        "index": {
          "last_month_orders": "Commandes du mois dernier par jour",
          "title": "Statistiques"
        }
      },
      "invoices": {
        "invoice": {
          "archived_version": "Version archivée"
        }
      },
      "order_items": {
        "order_item": {
          "color": "Couleur",
          "fonts": "Polices",
          "quantity": "Quantité",
          "size": "Taille"
        }
      },
      "orders": {
        "charge": {
          "receipt": "Reçu"
        },
        "index": {
          "title": "Commandes"
        },
        "order": {
          "created_at": "Créée le : %{date}",
          "delivery": "Expédition : %{type}",
          "paid_at": "Payée le : %{date}",
          "store": "Boutique : %{store}",
          "total": "Total : %{amount}"
        },
        "show": {
          "actions": "Actions disponibles",
          "add_parcel": "Ajouter un colis",
          "assets": "Ressources",
          "available_for_pickup": "Disponible pour le retrait",
          "billing_address": "Adresse de facturation",
          "billing_identifiers_not_editable": "Les identifiants de cette commande ne peuvent plus être modifiés ici.",
          "billing_identifiers_review_required": "Vérifiez le SIREN et le numéro de TVA du client avant d'émettre sa facture.",
          "billing_identifiers_saved": "Identifiants du client enregistrés.",
          "cancel": "Annuler",
          "cancel_confirmation": "Annuler la commande %{order} ?",
          "charges": "Paiements",
          "customer": "Client",
          "delivery_to_store": "📦 Livraison à la boutique %{store}",
          "invoiced_order_cannot_be_deleted": "Une commande facturée ne peut pas être supprimée.",
          "invoices": "Factures",
          "items": "Articles",
          "multiple_deliveries": "Expédition multiple",
          "no_customer": "Aucun client",
          "order": "Commande",
          "parcels": "Colis",
          "save_billing_identifiers": "Enregistrer les identifiants",
          "ship_confirmation": "Marquer la commande %{order} comme disponible pour le retrait ?",
          "shipping_address": "Adresse de livraison",
          "siren_invalid": "SIREN invalide.",
          "siren_missing": "Renseignez le SIREN du client avant d'émettre sa facture.",
          "summary": "Résumé",
          "supplier_orders": "Commandes fournisseur",
          "title": "Commande %{order} du %{date}",
          "vat_number_invalid": "Numéro de TVA invalide.",
          "vat_review_required": "Le traitement de TVA de cette commande doit être vérifié avant l'expédition.",
          "with_vat": "(assujetti à la TVA)",
          "without_vat": "(non assujetti à la TVA)"
        },
        "supplier_order": {
          "state": "État : %{state}"
        }
      },
      "parcels": {
        "form": {
          "add": "Ajouter"
        },
        "index": {
          "title": "Colis"
        }
      },
      "product_categories": {
        "edit": {
          "title": "Modification de la catégorie %{product_category}"
        },
        "form": {
          "information": "Informations générales"
        },
        "index": {
          "title": "Catégories"
        },
        "new": {
          "title": "Nouvelle catégorie"
        },
        "product_category": {
          "created_at": "Créée le : %{date}",
          "delete_confirmation": "Supprimer la catégorie %{product_category} ?",
          "group": "Groupe : %{group}"
        },
        "show": {
          "title": "Catégorie %{product_category}"
        }
      },
      "product_colors": {
        "edit": {
          "title": "Modification de la couleur %{product_color}"
        },
        "form": {
          "current_hex_value_html": "Valeur actuelle : <code>%{hex}</code>",
          "delete_image": "Supprimer l'image",
          "delete_image_confirmation": "Etes-vous sûr de vouloir supprimer l'image de la couleur ?",
          "information": "Informations générales"
        },
        "index": {
          "title": "Couleurs"
        },
        "new": {
          "title": "Nouvelle couleur"
        },
        "product_color": {
          "created_at": "Créée le : %{date}",
          "delete_confirmation": "Supprimer la couleur %{product_color} ?",
          "group": "Groupe : %{group}",
          "hex": "Code hexadécimal : %{hex}"
        },
        "show": {
          "title": "Couleur %{product_color}"
        }
      },
      "product_variant_customizations": {
        "index": {
          "title": "Personnalisations"
        },
        "product_variant_customization": {
          "created_at": "Créée le %{date}",
          "delete_confirmation": "Supprimer la personnalisation du variant %{product_variant} ?"
        }
      },
      "product_variants": {
        "edit": {
          "title": "Modification de la variante %{product_variant}"
        },
        "form": {
          "base_variant": "Il s'agit de la variante de base importée depuis le fournisseur et n'étant pas liée à une boutique.",
          "batch_create": "Création en lot",
          "batch_update": "Mise à jour en lot",
          "create_other_product_variants_help": "Si activé, le variant sera dupliqué pour toutes les tailles du produit.",
          "customization": "Personnalisation",
          "images": "Images",
          "information": "Informations générales",
          "no_back_image": "Aucune image arrière",
          "no_front_image": "Aucune image avant",
          "no_images": "Aucune image",
          "no_primary_image": "Aucune image principale",
          "pricing": "Tarification",
          "product_variant_enabled_help": "Les variantes de produits inactives ne sont pas achetables et restent cachés.",
          "store": "Boutique",
          "store_variant": "Il s'agit d'une variante liée à la boutique %{store}.",
          "supplier": "Informations fournisseur (%{supplier})",
          "update_other_colorless_variants_help": "Si activé, les couleurs de cette variante seront appliquées aux autres variantes de ce produit sans couleur.",
          "update_other_product_variants_help": "Si activé, le nom et le prix de cette variante seront appliqués aux autres variantes de ce produit. Les images des variantes de taille différente, mais avec les mêmes couleurs, seront également mises à jour."
        },
        "image": {
          "delete": "Supprimer",
          "delete_confirmation": "Supprimer cette image ?"
        },
        "index": {
          "title": "Variantes de %{product}"
        },
        "new": {
          "title": "Nouvelle variante pour %{product}"
        },
        "product_variant": {
          "delete_confirmation": "Supprimer la variante %{product_variant} ?",
          "global": "Commun à toutes les boutiques",
          "price": "Prix : %{price}",
          "size": "Taille : %{size}",
          "specific_to_store": "Spécifique à %{store}"
        },
        "show": {
          "title": "Variante %{product_variant}"
        },
        "update": {
          "title": "Modification de la variante %{product_variant}"
        }
      },
      "products": {
        "edit": {
          "title": "Modification du produit %{product}"
        },
        "form": {
          "base_product": "Il s'agit du produit de base importé depuis le fournisseur et n'étant pas liée à une boutique.",
          "images": "Images",
          "information": "Informations générales",
          "no_images": "Aucune image",
          "no_sizes_guide": "Aucun guide de tailles disponible",
          "open_sizes_guide": "Voir le guide",
          "pricing": "Tarification",
          "product_enabled_help": "Les produits inactifs ne sont pas achetables et restent cachés.",
          "should_update_other_products_with_same_reference_help": "Cocher cette case pour mettre à jour le prix SOFIDIAL de tous les produits de ce magasin avec la même référence.",
          "store": "Boutique",
          "store_product": "Il s'agit d'un produit lié à la boutique %{store}.",
          "supplier": "Fournisseur",
          "tags_placeholder": "Séparez vos tags par un espace"
        },
        "image": {
          "delete": "Supprimer",
          "delete_confirmation": "Supprimer cette image ?"
        },
        "index": {
          "title": "Produits"
        },
        "new": {
          "title": "Nouveau produit"
        },
        "product": {
          "created_at": "Créé le : %{date}",
          "delete_confirmation": "Supprimer le produit %{product} ?",
          "global": "Commun à toutes les boutiques",
          "reference": "Référence : %{reference}",
          "specific_to_store": "Spécifique à %{store}",
          "supplier": "Fournisseur : %{supplier}"
        },
        "show": {
          "add_product_variant": "Ajouter un variant",
          "colorless_variants": "Variantes sans couleur",
          "disable_all": "Désactiver tout",
          "disable_color_confirmation": "Désactiver toutes les variantes de la couleur %{color} ?",
          "duplicate_for_store": "Dupliquer pour %{store}",
          "duplicate_for_store_confirmation": "Dupliquer le produit et tous ses variants pour la boutique %{store} ?",
          "enable_all": "Activer tout",
          "enable_color_confirmation": "Activer toutes les variantes de la couleur %{color} ?",
          "title": "Produit %{product}",
          "variants": "Variantes"
        },
        "update": {
          "title": "Modification du produit %{product}"
        }
      },
      "promo_codes": {
        "edit": {
          "title": "Modification du code promo %{promo_code}"
        },
        "form": {
          "information": "Informations générales",
          "promo_code_enabled_help": "Les codes promo inactifs ne sont pas utilisables sur les boutiques.",
          "select_a_store": "Sélectionnez une boutique"
        },
        "index": {
          "title": "Codes promo"
        },
        "new": {
          "title": "Nouveau code promo"
        },
        "promo_code": {
          "code_type": "Type : %{type}",
          "created_at": "Créé le : %{date}",
          "delete_confirmation": "Supprimer le code promo %{promo_code} ?",
          "utilizations": "Utilisations : %{value}",
          "value": "Valeur : %{value}"
        },
        "show": {
          "title": "Code promo %{promo_code}"
        }
      },
      "search": {
        "index": {
          "search_results": "Résultats de recherche pour %{query}",
          "title": "Résultats de recherche pour %{query}"
        }
      },
      "stores": {
        "edit": {
          "title": "Modification de la boutique %{store}"
        },
        "form": {
          "add_field": "Ajouter un champ",
          "advanced_customization_enabled_help": "Affiche l'outil de personnalisation avancée sur la boutique.",
          "allow_search_engines_help": "Autoriser les moteurs de recherche à indexer cette boutique.",
          "billing_address": "Adresse facturation",
          "custom_fields": "Champs personnalisés",
          "customization": {
            "advanced_customization_price": "Advanced customization price",
            "advanced_customization_price_per_element": "Advanced per-element price",
            "back": "Enable back",
            "back_price": "Back price",
            "both_sleeves_price": "Both sleeves price",
            "chest": "Enable chest",
            "chest_and_back_price": "Chest + back price",
            "chest_price": "Chest price",
            "heart": "Enable heart",
            "heart_and_back_price": "Heart + back price",
            "heart_price": "Heart price",
            "left_sleeve": "Enable left sleeve",
            "prices_help": "Prices in euros, excluding VAT (e.g. 4.58)",
            "right_sleeve": "Enable right sleeve",
            "sleeve_price": "Single sleeve price",
            "title": "Per-location customization"
          },
          "customization_enabled_help": "Affiche l'outil de personnalisation sur la boutique.",
          "delete_banner": "Supprimer la bannière",
          "delete_banner_confirmation": "Supprimer la bannière de la boutique ?",
          "delete_mobile_banner": "Supprimer la bannière mobile",
          "delete_mobile_banner_confirmation": "Supprimer la bannière mobile de la boutique ?",
          "delivery_enabled_help": "Active l'option de livraison pour les commandes.",
          "dns_setup_documentation_html": "Créez un enregistrement <code>CNAME</code> pointant vers <code>%{target}<c/ode> dans la zone DNS de votre domaine.",
          "information": "Informations générales",
          "mobile_banner_help": "Image affichée uniquement sur mobile, remplaçant le message texte de la bannière.",
          "payment_and_billing": "Paiement et facturation",
          "remove_field": "Retirer",
          "shipping_address": "Adresse de livraison",
          "store_enabled_help": "Les boutiques inactives restent cachées.",
          "supplier_orders_enabled_help": "Active l'envoie automatique des commandes au fournisseur.",
          "urls": "URLs",
          "use_shipping_address": "Identique livraison"
        },
        "index": {
          "title": "Boutiques"
        },
        "new": {
          "title": "Nouvelle boutique"
        },
        "product": {
          "delete_confirmation": "Désactiver le produit %{product} de la boutique ?",
          "deleting": "Désactivation en cours...",
          "product_since": "Depuis le %{date}",
          "store_product": "Spécifique à %{store}",
          "variants": {
            "one": "1 variante",
            "other": "%{count} variantes",
            "zero": "Aucune variante"
          }
        },
        "show": {
          "add_admin": "Ajouter",
          "add_product": "Ajouter",
          "no_matching_products": "Aucun produit ne correspond à votre recherche.",
          "products": "Produits",
          "search_products": "Rechercher un produit par nom ou référence",
          "select_a_new_admin": "Sélectionnez un nouvel administrateur",
          "select_a_new_product": "Sélectionnez un nouveau produit",
          "sort": "Trier",
          "store_admins": "Administrateurs",
          "store_products": "Produits actifs",
          "title": "Boutique %{store}"
        },
        "sort_products": {
          "title": "Trier les produits"
        },
        "user": {
          "admin_since": "Depuis le %{date}",
          "delete_confirmation": "Supprimer l'administrateur %{user} de la boutique ?"
        }
      },
      "users": {
        "edit": {
          "title": "Modification de l'utilisateur %{user}"
        },
        "form": {
          "authentication": "Authentification",
          "information": "Informations générales"
        },
        "index": {
          "title": "Utilisateurs"
        },
        "new": {
          "title": "Nouvel utilisateur"
        },
        "show": {
          "title": "Utilisateur %{user}"
        },
        "user": {
          "created_at": "Créé(e) le : %{date}",
          "delete_confirmation": "Supprimer l'utilisateur %{user} ?",
          "email": "Email : %{email}",
          "user_type": "Type : %{type}"
        }
      }
    },
    "back": "Retour",
    "cancel": "Annuler",
    "cancelled_by_admin": "Annulée par l'administrateur",
    "cart_items": {
      "cart_item": {
        "color": "Couleur",
        "delete_confirmation": "Supprimer %{product_variant} de votre panier?",
        "no_stock_warning": "Nous n'avons plus cet article en stock.",
        "quantity": "Quantité",
        "size": "Taille",
        "stock_warning": "Nous n'avons que %{current_stock} articles en stock."
      }
    },
    "carts": {
      "show": {
        "delivery": "Livraison",
        "discount": "Remise",
        "my_cart": "Mon panier",
        "next": "Suivant",
        "ok": "OK",
        "processing": "Traitement...",
        "title": "Panier",
        "to_be_defined": "à définir",
        "total": "Total",
        "total_items": {
          "one": "1 article",
          "other": "%{count} articles",
          "zero": "Aucun article"
        },
        "vat_rounding_adjustment": "Arrondi TVA"
      }
    },
    "controllers": {
      "addresses": {
        "update": {
          "notice": "Adresse mise à jour."
        }
      },
      "admin": {
        "orders": {
          "cancel": {
            "notice": "Commande annulée."
          },
          "ship": {
            "notice": "Commande marquée comme disponible pour le retrait.",
            "payment_amount_mismatch": "Le montant encaissé sur Stripe ne correspond pas à la commande. L'expédition et la facture sont suspendues ; vérifiez le paiement avant de réessayer.",
            "payment_verification_unavailable": "La vérification du paiement Stripe est temporairement indisponible. La commande n'a pas été expédiée ni facturée ; réessayez plus tard."
          }
        },
        "parcels": {
          "create": {
            "notice": "Colis créé.",
            "payment_amount_mismatch": "Le montant encaissé sur Stripe ne correspond pas à la commande. Le colis et la facture sont suspendus ; vérifiez le paiement avant de réessayer.",
            "payment_verification_unavailable": "La vérification du paiement Stripe est temporairement indisponible. Le colis n'a pas été créé ni facturé ; réessayez plus tard."
          },
          "update": {
            "notice": "Colis mis à jour.",
            "payment_amount_mismatch": "Le montant encaissé sur Stripe ne correspond pas à la commande. Le colis et la facture sont suspendus ; vérifiez le paiement avant de réessayer.",
            "payment_verification_unavailable": "La vérification du paiement Stripe est temporairement indisponible. Le colis n'a pas été modifié ni facturé ; réessayez plus tard."
          }
        },
        "product_categories": {
          "create": {
            "alert": "Echec de création de la catégorie.",
            "notice": "Catégorie créée."
          },
          "destroy": {
            "notice": "Catégorie supprimée."
          },
          "update": {
            "alert": "Echec de mise à jourt de la catégorie.",
            "notice": "Catégorie mise à jour."
          }
        },
        "product_colors": {
          "create": {
            "alert": "Echec de création de la couleur.",
            "notice": "Couleur créée."
          },
          "destroy": {
            "notice": "Couleur supprimée."
          },
          "destroy_image": {
            "notice": "Image supprimée."
          },
          "update": {
            "alert": "Echec de mise à jourt de la couleur.",
            "notice": "Couleur mise à jour."
          }
        },
        "product_variant_customizations": {
          "destroy": {
            "notice": "Personnalisation supprimée."
          }
        },
        "product_variants": {
          "create": {
            "alert": "Echec de création de la variante.",
            "notice": "Variante créée."
          },
          "destroy": {
            "notice": "Variante supprimée."
          },
          "destroy_image": {
            "notice": "Image supprimée."
          },
          "front": {
            "notice": "Variante mise en avant."
          },
          "update": {
            "alert": "Echec de mise à jour de la variante.",
            "notice": "Variante mise à jour."
          }
        },
        "products": {
          "create": {
            "alert": "Echec de création du produit.",
            "notice": "Produit créé."
          },
          "destroy": {
            "notice": "Produit supprimé."
          },
          "destroy_image": {
            "notice": "Image supprimée."
          },
          "disable_color": {
            "notice": "Toutes les variantes de couleur %{color} ont été désactivées pour cette boutique."
          },
          "duplicate": {
            "notice": "Produit dupliqué."
          },
          "enable_color": {
            "notice": "Toutes les variantes de couleur %{color} ont été activées pour cette boutique."
          },
          "update": {
            "alert": "Echec de mise à jour du produit.",
            "notice": "Produit mis à jour."
          }
        },
        "promo_codes": {
          "create": {
            "alert": "Echec de création du code promo.",
            "notice": "Code promo créé."
          },
          "destroy": {
            "notice": "Code promo supprimé ou désactivé (si déjà utilisé au moins une fois)."
          },
          "update": {
            "notice": "Code promo mis à jour."
          }
        },
        "stores": {
          "add_admin": {
            "notice": "Administrateur boutique ajouté."
          },
          "add_product": {
            "notice": "Produit en cours d'ajouté sur la boutique."
          },
          "create": {
            "alert": "Echec de création de la boutique.",
            "notice": "Boutique créée."
          },
          "current": {
            "notice": "Boutique sélectionnée."
          },
          "destroy": {
            "alert": "Impossible de supprimer la boutique. Vérifiez ses commandes et factures.",
            "notice": "Boutique supprimée."
          },
          "destroy_banner": {
            "notice": "Bannière supprimée."
          },
          "destroy_mobile_banner": {
            "notice": "Bannière mobile supprimée."
          },
          "remove_admin": {
            "notice": "Administrateur boutique supprimé. 👋"
          },
          "remove_product": {
            "notice": "Produit en cours de désactivation sur la boutique."
          },
          "update": {
            "alert": "Echec de mise à jour de la boutique.",
            "notice": "Boutique mise à jour."
          }
        },
        "users": {
          "create": {
            "alert": "Echec de création de l'utilisateur.",
            "notice": "Utilisateur créé."
          },
          "destroy": {
            "notice": "Utilisateur supprimé."
          },
          "update": {
            "alert": "Echec de mise à jourt de l'utilisateur.",
            "notice": "Utilisateur mis à jour."
          }
        }
      },
      "application": {
        "user_not_authorized": "Vous n'êtes pas autorisé à effectuer cette action."
      },
      "cart_items": {
        "create": {
          "notice": "%{product} ajouté au panier."
        },
        "destroy": {
          "notice": "%{product} supprimé."
        },
        "update": {
          "notice": "%{product} mis à jour."
        }
      },
      "carts": {
        "checkout": {
          "alert": "Votre panier est vide.",
          "notice": "Commande créée."
        },
        "update": {
          "notice": "Panier mis à jour."
        }
      },
      "erp": {
        "access_denied": "Vous n'avez pas accès à ce module.",
        "design": {
          "proofs": {
            "destroy_file": {
              "file_removed": "Visuel supprimé",
              "not_editable": "Ce BAT n'est plus modifiable ; créez une révision pour le modifier."
            },
            "revision": {
              "revision_created": "Nouvelle version du BAT créée"
            },
            "send_to_customer": {
              "sent": "BAT envoyé au client pour validation"
            },
            "submit_for_approval": {
              "submitted": "BAT soumis au commercial pour approbation"
            },
            "update": {
              "not_editable": "Ce BAT n'est plus modifiable ; créez une révision pour le modifier.",
              "updated": "BAT enregistré"
            }
          }
        },
        "production": {
          "supply_orders": {
            "order": {
              "ordered": "Commande passée au fournisseur."
            },
            "receive": {
              "received": "Réception enregistrée."
            }
          }
        },
        "sales": {
          "customer_addresses": {
            "create": {
              "notice": "Adresse créée avec succès"
            },
            "destroy": {
              "notice": "Adresse supprimée avec succès"
            },
            "update": {
              "notice": "Adresse modifiée avec succès"
            }
          },
          "customer_assets": {
            "create": {
              "notice": "Fichier ajouté avec succès"
            },
            "destroy": {
              "notice": "Fichier supprimé avec succès"
            },
            "update": {
              "notice": "Fichier modifié avec succès"
            }
          },
          "customer_bank_accounts": {
            "create": {
              "notice": "Compte bancaire créé avec succès"
            },
            "destroy": {
              "notice": "Compte bancaire supprimé avec succès"
            },
            "update": {
              "notice": "Compte bancaire modifié avec succès"
            }
          },
          "customer_contacts": {
            "create": {
              "notice": "Contact créé avec succès"
            },
            "destroy": {
              "notice": "Contact supprimé avec succès"
            },
            "update": {
              "notice": "Contact modifié avec succès"
            }
          },
          "customer_product_prices": {
            "create": {
              "notice": "Tarif créé"
            },
            "destroy": {
              "notice": "Tarif supprimé"
            },
            "update": {
              "notice": "Tarif modifié"
            }
          },
          "customers": {
            "add_marking_position": {
              "label_required": "Le libellé est requis"
            },
            "create": {
              "notice": "Client créé avec succès"
            },
            "destroy": {
              "notice": "Client supprimé avec succès"
            },
            "update": {
              "notice": "Client modifié avec succès"
            }
          },
          "estimate_assets": {
            "create": {
              "notice": "Document(s) ajouté(s) au devis"
            },
            "destroy": {
              "notice": "Document retiré du devis"
            }
          },
          "estimate_proofs": {
            "approve": {
              "sent": "BAT approuvé et envoyé au client"
            },
            "requirement": {
              "not_required": "La PAO enverra le BAT directement au client",
              "required": "Le BAT de ce devis partira après votre approbation"
            },
            "return_to_studio": {
              "returned": "BAT renvoyé à la PAO"
            }
          },
          "estimate_templates": {
            "create": {
              "notice": "Modèle créé avec succès"
            },
            "destroy": {
              "notice": "Modèle supprimé avec succès"
            },
            "duplicate": {
              "notice": "Modèle dupliqué avec succès"
            },
            "update": {
              "notice": "Modèle modifié avec succès"
            }
          },
          "estimates": {
            "create": {
              "notice": "Devis créé avec succès"
            },
            "destroy": {
              "notice": "Devis supprimé avec succès"
            },
            "duplicate": {
              "duplicated": "Devis dupliqué avec succès"
            },
            "lose": {
              "lost": "Devis marqué comme perdu"
            },
            "revert": {
              "reverted": "Action annulée avec succès"
            },
            "send_estimate": {
              "no_email": "Impossible d'envoyer le devis sans destinataire. Cochez un contact ou saisissez une adresse.",
              "sent": "Devis envoyé au client"
            },
            "send_to_pao": {
              "sent_to_pao": "Devis envoyé en conception"
            },
            "start_production": {
              "production_started": "Affaire passée en production"
            },
            "update": {
              "notice": "Devis modifié avec succès"
            },
            "validate_estimate": {
              "validated": "Devis validé avec succès"
            },
            "validate_production": {
              "production_validated": "Production validée avec succès"
            }
          },
          "marking_catalogues": {
            "update": {
              "notice": "Référentiel mis à jour avec succès"
            }
          },
          "printing_price_grids": {
            "add_extra": {
              "notice": "Supplément ajouté"
            },
            "add_row": {
              "notice": "Ligne ajoutée à la grille"
            },
            "destroy_extra": {
              "notice": "Supplément supprimé"
            },
            "destroy_row": {
              "notice": "Ligne supprimée de la grille"
            },
            "entries_updated": {
              "notice": "Tarifs mis à jour avec succès"
            }
          },
          "product_variants": {
            "refresh_price": {
              "failed": "Échec de la mise à jour du prix Imbretex",
              "no_price": "Aucun prix retourné par Imbretex pour cette référence",
              "not_imbretex": "La référence n'est pas un produit Imbretex"
            }
          },
          "products": {
            "update": {
              "notice": "Produit modifié avec succès"
            },
            "update_marking_capabilities": {
              "notice": "Compatibilités mises à jour avec succès"
            },
            "update_size_aliases": {
              "notice": "Correspondances de tailles mises à jour avec succès"
            }
          }
        }
      },
      "order_items": {
        "create": {
          "notice": "%{product} ajouté au panier."
        }
      },
      "orders": {
        "checkout": {
          "notice": "Commande créée, choisissez un mode de livraison."
        },
        "payment": {
          "alert": "Veuillez remplir vos informations de livraison et de facturation avant de passer à la paiement.",
          "discount_exceeds_items": "La remise dépasse le montant des articles. Retirez ce code promo pour continuer.",
          "invalid_billing_siren": "Vérifiez le SIREN de facturation avant de payer, ou laissez ce champ vide.",
          "invalid_billing_vat_number": "Vérifiez le numéro de TVA de facturation avant de payer, ou laissez ce champ vide.",
          "missing_billing_siren": "Renseignez le SIREN de votre société française ou un numéro de TVA français valide avant de payer.",
          "stock_unavailable": "Le stock disponible a changé. Veuillez ajuster votre panier avant de réessayer.",
          "stripe_error": "Une erreur est survenue lors de la création du paiement. Veuillez réessayer.",
          "too_many_checkout_line_items": "Ce panier contient trop de lignes pour le paiement en ligne. Répartissez les articles sur plusieurs commandes.",
          "unsupported_vat_exemption": "Le mode de livraison et l'adresse de facturation ne permettent pas de confirmer l'exonération de TVA. Contactez-nous avant de payer."
        },
        "update": {
          "notice": "Commande mise à jour."
        }
      },
      "store_admin": {
        "orders": {
          "cancel": {
            "notice": "Commande annulée."
          }
        },
        "product_variants": {
          "create": {
            "alert": "Echec de création de la variante.",
            "notice": "Variante créée."
          },
          "destroy": {
            "notice": "Variante supprimée."
          },
          "destroy_image": {
            "notice": "Image supprimée."
          },
          "front": {
            "notice": "Variante mise en avant."
          },
          "update": {
            "alert": "Echec de mise à jour de la variante.",
            "notice": "Variante mise à jour."
          }
        },
        "products": {
          "create": {
            "alert": "Echec de création du produit.",
            "notice": "Produit créé."
          },
          "destroy": {
            "notice": "Produit supprimé."
          },
          "destroy_image": {
            "notice": "Image supprimée."
          },
          "disable_color": {
            "notice": "Toutes les variantes de couleur %{color} ont été désactivées pour cette boutique."
          },
          "duplicate": {
            "notice": "Produit dupliqué."
          },
          "enable_color": {
            "notice": "Toutes les variantes de couleur %{color} ont été activées pour cette boutique."
          },
          "update": {
            "alert": "Echec de mise à jour du produit.",
            "notice": "Produit mis à jour."
          }
        },
        "promo_codes": {
          "create": {
            "alert": "Echec de création du code promo.",
            "notice": "Code promo créé."
          },
          "destroy": {
            "notice": "Code promo supprimé ou désactivé (si déjà utilisé au moins une fois)."
          },
          "update": {
            "notice": "Code promo mis à jour."
          }
        },
        "stores": {
          "add_product": {
            "notice": "Produit en cours d'ajouté sur la boutique."
          },
          "current": {
            "notice": "Boutique sélectionnée."
          },
          "destroy_banner": {
            "notice": "Bannière supprimée."
          },
          "destroy_mobile_banner": {
            "notice": "Bannière mobile supprimée."
          },
          "remove_product": {
            "notice": "Produit en cours de désactivation sur la boutique."
          },
          "update": {
            "alert": "Echec de mise à jour de la boutique.",
            "notice": "Boutique mise à jour."
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%B %d, %Y",
        "short": "%b %d"
      },
      "month_names": [
        null,
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "about %{count} hour",
          "other": "about %{count} hours"
        },
        "about_x_months": {
          "one": "about %{count} month",
          "other": "about %{count} months"
        },
        "about_x_years": {
          "one": "about %{count} year",
          "other": "about %{count} years"
        },
        "almost_x_years": {
          "one": "almost %{count} year",
          "other": "almost %{count} years"
        },
        "half_a_minute": "half a minute",
        "less_than_x_minutes": {
          "one": "less than a minute",
          "other": "less than %{count} minutes"
        },
        "less_than_x_seconds": {
          "one": "less than %{count} second",
          "other": "less than %{count} seconds"
        },
        "over_x_years": {
          "one": "over %{count} year",
          "other": "over %{count} years"
        },
        "x_days": {
          "one": "%{count} day",
          "other": "%{count} days"
        },
        "x_minutes": {
          "one": "%{count} minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "%{count} month",
          "other": "%{count} months"
        },
        "x_seconds": {
          "one": "%{count} second",
          "other": "%{count} seconds"
        },
        "x_years": {
          "one": "%{count} year",
          "other": "%{count} years"
        }
      },
      "prompts": {
        "day": "Day",
        "hour": "Hour",
        "minute": "Minute",
        "month": "Month",
        "second": "Seconds",
        "year": "Year"
      },
      "relative": {
        "future": "in %{time}",
        "past": "%{time} ago"
      }
    },
    "delete": "Supprimer",
    "devise": {
      "confirmations": {
        "confirmed": "Your email address has been successfully confirmed.",
        "new": {
          "or_continue_with": "ou continuer avec",
          "resend_confirmation_info": "Envoyer les instructions",
          "title": "Compte non confirmé ?"
        },
        "send_instructions": "You will receive an email with instructions for how to confirm your email address in a few minutes.",
        "send_paranoid_instructions": "If your email address exists in our database, you will receive an email with instructions for how to confirm your email address in a few minutes."
      },
      "failure": {
        "already_authenticated": "You are already signed in.",
        "inactive": "Your account is not activated yet.",
        "invalid": "Invalid %{authentication_keys} or password.",
        "last_attempt": "You have one more attempt before your account is locked.",
        "locked": "Your account is locked.",
        "not_found_in_database": "Invalid %{authentication_keys} or password.",
        "timeout": "Your session expired. Please sign in again to continue.",
        "unauthenticated": "You need to sign in or sign up before continuing.",
        "unconfirmed": "You have to confirm your email address before continuing."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirmer mon email",
          "greeting": "Bienvenue %{recipient} !",
          "instruction": "Vous pouvez confirmer votre email grâce au lien ci-dessous :",
          "subject": "Confirmation instructions"
        },
        "email_changed": {
          "greeting": "Bonjour %{recipient} !",
          "message": "Nous vous contactons pour vous informer que votre email a été changé en %{email}.",
          "message_unconfirmed": "Nous vous contactons pour vous informer que votre email est en train d'être changé par %{email}.",
          "subject": "Email Changed"
        },
        "password_change": {
          "greeting": "Bonjour %{recipient} !",
          "message": "Nous vous contactons pour vous notifier que votre mot de passe a été modifié.",
          "subject": "Password Changed"
        },
        "reset_password_instructions": {
          "action": "Changer mon mot de passe",
          "greeting": "Bonjour %{recipient} !",
          "instruction": "Quelqu'un a demandé un lien pour changer votre mot de passe, le voici :",
          "instruction_2": "Si vous n'avez pas émis cette demande, merci d'ignorer cet email.",
          "instruction_3": "Votre mot de passe ne changera pas tant que vous n'aurez pas cliqué sur ce lien et renseigné un nouveau mot de passe.",
          "subject": "Reset password instructions"
        },
        "unlock_instructions": {
          "action": "Débloquer mon compte",
          "greeting": "Bonjour %{recipient} !",
          "instruction": "Suivez ce lien pour débloquer votre compte :",
          "message": "Votre compte a été bloqué suite à un nombre d'essais de connexions manquées trop important.",
          "subject": "Unlock instructions"
        }
      },
      "omniauth_callbacks": {
        "failure": "Could not authenticate you from %{kind} because \"%{reason}\".",
        "success": "Successfully authenticated from %{kind} account."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Modifier mon mot de passe",
          "confirm_new_password": "Confirmer le nouveau mot de passe",
          "minimum_password_length": "Minimum de %{count} caractères",
          "new_password": "Nouveau mot de passe",
          "or_continue_with": "ou continuer avec",
          "title": "Modifier mon mot de passe"
        },
        "new": {
          "or_continue_with": "ou continuer avec",
          "send_password_reset_info": "Envoyer les instructions",
          "title": "Mot de passe oublié ?"
        },
        "no_token": "You can't access this page without coming from a password reset email. If you do come from a password reset email, please make sure you used the full URL provided.",
        "send_instructions": "You will receive an email with instructions on how to reset your password in a few minutes.",
        "send_paranoid_instructions": "If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes.",
        "updated": "Your password has been changed successfully. You are now signed in.",
        "updated_not_active": "Your password has been changed successfully."
      },
      "registrations": {
        "destroyed": "Bye! Your account has been successfully cancelled. We hope to see you again soon.",
        "new": {
          "already_a_member": "Déjà inscrit ?",
          "minimum_password_length": "Minimum de %{count} caractères",
          "or_continue_with": "ou continuer avec",
          "sign_up": "Inscription",
          "signin_to_your_account": "Connectez vous.",
          "title": "Inscription"
        },
        "signed_up": "Welcome! You have signed up successfully.",
        "signed_up_but_inactive": "You have signed up successfully. However, we could not sign you in because your account is not yet activated.",
        "signed_up_but_locked": "You have signed up successfully. However, we could not sign you in because your account is locked.",
        "signed_up_but_unconfirmed": "A message with a confirmation link has been sent to your email address. Please follow the link to activate your account.",
        "update_needs_confirmation": "You updated your account successfully, but we need to verify your new email address. Please check your email and follow the confirmation link to confirm your new email address.",
        "updated": "Your account has been updated successfully.",
        "updated_but_not_signed_in": "Your account has been updated successfully, but since your password was changed, you need to sign in again."
      },
      "sessions": {
        "already_signed_out": "Signed out successfully.",
        "new": {
          "not_a_member": "Pas encore inscrit ?",
          "or": "ou",
          "or_continue_with": "ou continuer avec",
          "remember_me": "Rester connecté",
          "sign_in": "Connexion",
          "signup": "Inscrivez-vous",
          "title": "Connexion"
        },
        "signed_in": "Signed in successfully.",
        "signed_out": "Signed out successfully."
      },
      "shared": {
        "links": {
          "didnt_receive_confirm_info": "Informations de confirmation non reçues ?",
          "didnt_receive_unlock_info": "Informations de déverrouillage non reçues ?",
          "forgot_password": "Mot de passe oublié ?",
          "signin": "Connexion",
          "signup": "Inscription"
        }
      },
      "unlocks": {
        "new": {
          "or_continue_with": "ou continuer avec",
          "resend_unlock_instructions": "Envoyer les instructions",
          "title": "Compte verrouillé ?"
        },
        "send_instructions": "You will receive an email with instructions for how to unlock your account in a few minutes.",
        "send_paranoid_instructions": "If your account exists, you will receive an email with instructions for how to unlock it in a few minutes.",
        "unlocked": "Your account has been unlocked successfully. Please sign in to continue."
      }
    },
    "display_period": "Période d'affichage",
    "edit": "Modifier",
    "erp": {
      "accounting": {
        "dashboard": {
          "index": {
            "title": "Pilotage Comptabilité"
          }
        }
      },
      "action_bar": {
        "add_button_component": {
          "add": "Ajouter"
        }
      },
      "administration": {
        "dashboard": {
          "index": {
            "title": "Pilotage Administration"
          }
        }
      },
      "alert": {
        "component": {
          "info": "Information :",
          "warn": "Attention :"
        }
      },
      "badge": {
        "chip_component": {
          "more": {
            "one": "1 autre",
            "other": "%{count} autres"
          }
        },
        "status_component": {
          "design": "En conception",
          "draft": "Brouillon",
          "lost": "Perdu",
          "pending": "Non validé",
          "sent": "En cours",
          "won": "Affaire validée"
        }
      },
      "confirm_dialog": {
        "component": {
          "cancel": "Annuler"
        }
      },
      "dashboard": {
        "index": {
          "title": "Tableau de bord"
        }
      },
      "deliveries": {
        "reminder": "Relance n°%{number}",
        "role": {
          "approver": "Approbateur",
          "information": "Pour information"
        },
        "status": {
          "dead": "Échec définitif",
          "delivered": "Envoyé",
          "delivering": "En cours d'envoi",
          "failed": "Échec, nouvel essai prévu",
          "queued": "En attente"
        }
      },
      "design": {
        "dashboard": {
          "index": {
            "title": "Pilotage Graphisme"
          }
        },
        "proofs": {
          "errors": {
            "approval_not_required": "Ce devis ne demande pas d'approbation commerciale : envoyez le BAT directement au client.",
            "approval_required": "Ce devis demande l'approbation du commercial avant l'envoi : soumettez le BAT au commercial.",
            "no_files": "Impossible d'envoyer le BAT sans visuel. Ajoutez au moins un fichier.",
            "no_recipient": "Impossible d'envoyer le BAT : aucune adresse email renseignée pour ce client.",
            "not_in_design": "Le BAT n'est disponible que pour une affaire en conception.",
            "return_comment_required": "Indiquez à la PAO ce qu'il faut reprendre."
          },
          "sales_approval": {
            "approved": "Approuvé et envoyé au client par %{name} le %{date}.",
            "pending": "BAT soumis par %{submitter} le %{date}, en attente de l'approbation de %{name}.",
            "required": "Ce BAT doit être approuvé par %{name} avant de partir : soumettez-le, %{name} l'enverra au client.",
            "returned": "Renvoyé à la PAO par %{name} le %{date}"
          },
          "send_dialog": {
            "approver": "Approbateur du BAT",
            "confirm": "Envoyer le BAT",
            "from_primary_contact": "Contact principal : %{name}",
            "information": "Pour information",
            "information_hint": "Ces destinataires reçoivent le BAT sans validation à donner ; seul l'approbateur le valide, et il ne reçoit qu'un email même s'il est coché ici.",
            "intro": "Le BAT de l'affaire %{reference} va être envoyé pour validation.",
            "no_email": "Aucun email n'est renseigné pour ce client — saisissez-en un pour envoyer.",
            "submission": {
              "confirm": "Soumettre au commercial",
              "intro": "Le BAT de l'affaire %{reference} attend l'approbation de %{name}, qui l'enverra à ces destinataires.",
              "title": "Soumettre le BAT au commercial"
            },
            "title": "Envoyer le BAT au client"
          },
          "show": {
            "attached_visuals": "Visuels joints",
            "back_to_estimate": "Retour au devis",
            "browse": "Parcourir",
            "confirm_remove_file": "Supprimer ce visuel du BAT ?",
            "create_revision": "Créer une révision",
            "deliveries": "Envois et relances du BAT v%{version}",
            "download": "Télécharger le fichier",
            "dropzone_hint": "Glissez-déposez vos fichiers ici ou",
            "files": "Visuels (images / PDF)",
            "history": "Historique des versions",
            "internal_note": "Note interne",
            "locked": "Ce BAT n'est plus modifiable (déjà envoyé ou approuvé). Créez une révision pour le modifier.",
            "locked_pending_approval": "Ce BAT attend l'approbation du commercial : il n'est plus modifiable tant qu'il ne vous est pas renvoyé.",
            "remove_file": "Supprimer le visuel",
            "save": "Enregistrer",
            "send_to_customer": "Envoyer au client",
            "submit_for_approval": "Soumettre au commercial",
            "title": "Bon À Tirer (BAT)"
          }
        },
        "public_proofs": {
          "action_impossible": "Cette action n'est plus possible pour ce BAT.",
          "approved": "Merci ! Le BAT a été approuvé. La production peut démarrer.",
          "revision_requested": "Votre demande de révision a bien été transmise au studio.",
          "show": {
            "already_responded": "Vous avez déjà répondu à ce BAT.",
            "approval_label": "Commentaire (optionnel)",
            "approve": "Approuver le BAT",
            "for_information": "Ce BAT vous est transmis pour information : sa validation est demandée à l'approbateur désigné.",
            "request_revision": "Demander une révision",
            "revision_label": "Votre demande de modification",
            "title": "Bon À Tirer à valider",
            "version": "Version %{number}"
          }
        }
      },
      "design_system": {
        "chrome": {
          "footer": "Footer",
          "modules": "Header et footer, couleur du module",
          "page_head": "En-tête de page",
          "sample_alert": "L’enregistrement a échoué",
          "sample_notice": "Modification enregistrée",
          "sample_status": "Statut de la page",
          "sample_subtitle": "Une phrase qui dit ce que l’on fait sur cette page.",
          "sample_title": "Titre de page",
          "title": "Chrome",
          "toasts": "Toasts"
        },
        "colors": {
          "accents": "Noir, accent et danger",
          "lines": "Filets",
          "modules": "Modules",
          "statuses": {
            "design": "En conception",
            "draft": "Brouillon",
            "lost": "Perdu",
            "pending": "Non validé",
            "sent": "En cours",
            "title": "Statuts",
            "won": "Affaire validée"
          },
          "surfaces": "Surfaces",
          "text": "Texte",
          "title": "Couleurs"
        },
        "data": {
          "add": "Ajouter",
          "all_periods": "Toutes les périodes",
          "badges": "Badges",
          "chip": "Coloris %{index}",
          "column_actions": "Actions",
          "column_amount": "Montant",
          "column_name": "Nom",
          "column_status": "Statut",
          "confirm_accept": "Confirmer l’action",
          "confirm_dialog": "Fenêtre de confirmation",
          "confirm_text": "Une phrase qui dit ce qui va se passer.",
          "confirm_title": "Confirmer cette action ?",
          "empty_message": "Les éléments créés apparaîtront ici.",
          "empty_title": "Aucun élément",
          "filters": "Barre d’actions et filtres",
          "kpi_dark": "Indicateur sombre",
          "kpi_hint": "Une précision sur le chiffre",
          "kpi_label": "Indicateur %{index}",
          "kpis": "Indicateurs",
          "marking_chip": "Marquage",
          "menu_advance": "Faire avancer",
          "menu_delete": "Supprimer",
          "menu_download": "Télécharger",
          "menu_duplicate": "Dupliquer",
          "menu_label": "Plus d’actions pour l’élément 1",
          "menu_open": "Ouvrir",
          "menu_view": "Consulter",
          "modal": "Fenêtre",
          "modal_intro": "Une phrase qui dit ce que l’on fait dans cette fenêtre.",
          "modal_save": "Enregistrer",
          "modal_title": "Titre de la fenêtre",
          "modal_xl": "Grande fenêtre",
          "modal_xl_title": "Grande fenêtre",
          "overlays": "Menu, confirmation et fenêtres",
          "panel_tabs": "Onglets à panneaux",
          "person": "Alex Durand",
          "reset": "Réinitialiser",
          "row": "Élément %{index}",
          "search_placeholder": "Rechercher…",
          "section_meta": "3 éléments",
          "section_title": "Titre de section",
          "status_tabs": "Statuts",
          "tab": "Onglet %{index}",
          "tab_panel": "Contenu de l’onglet %{index}.",
          "table": "Tableau",
          "tabs": "Onglets",
          "tags": {
            "alert": "En retard",
            "b2b": "Professionnel",
            "b2c": "Particulier",
            "info": "Chorus",
            "new": "Nouveau",
            "warn": "À compléter"
          },
          "title": "Navigation, données et surcouches",
          "toggle": "Mes éléments",
          "turbo_confirm": "Confirmation Turbo"
        },
        "forms": {
          "alert_text": "Le message explique la situation et ce que l’on peut faire.",
          "alert_title": "Titre en gras.",
          "alerts": "Alertes",
          "buttons": "Boutons",
          "card": "Carte de consultation",
          "card_field": "Libellé",
          "card_section": "Groupe de cartes",
          "check_card": "Carte à cocher",
          "check_card_description": "Une phrase qui précise la conséquence du choix.",
          "checklist": "Checklist",
          "choices": "Choix",
          "close": "Fermer",
          "days": "%{count} j",
          "disabled": "Désactivé",
          "disabled_value": "Valeur non modifiable",
          "edit": "Modifier",
          "error": "Saisissez une adresse email valide.",
          "fields": "Champs",
          "file_field": "Fichier",
          "form_section": "Section de formulaire",
          "form_section_text": "ERP::Form::SectionComponent, son icône dans la pastille, et ses actions.",
          "hint": "Une précision sous le champ.",
          "info_note": "Note d’information, sans icône.",
          "invalid": "Champ en erreur",
          "link": "Lien",
          "more_actions": "Plus d’actions",
          "option": "Option %{index}",
          "panel_help": "Une phrase qui dit ce que l’on renseigne dans ce bloc.",
          "panel_locked": "Bloc verrouillé",
          "panel_locked_help": "Validez d’abord le bloc précédent.",
          "panel_optional": "Bloc facultatif",
          "panel_summary_html": "<b>Résumé</b> du bloc une fois validé",
          "panel_title": "Titre du bloc",
          "panel_validate": "Valider et continuer",
          "panels": "Panneaux",
          "pill_radio": "Pilules (emplacement)",
          "pill_radio_sm": "Pilules (type)",
          "placeholder": "Texte d’aide dans le champ",
          "recap": "Récapitulatif",
          "recap_pieces": "%{count} pcs",
          "recap_settings": "Paramètres",
          "recap_subtotal": "Total HT",
          "recap_term": "Ligne %{index}",
          "recap_title": "Récapitulatif",
          "recap_total": "Total TTC",
          "search_placeholder": "Rechercher…",
          "searchable_select": "Liste avec recherche",
          "segmented": "Contrôle segmenté",
          "select": "Liste déroulante",
          "small": "Petite taille",
          "text_area": "Zone de texte",
          "text_field": "Champ texte",
          "title": "Formulaires et actions",
          "variants": {
            "accent": "Accent",
            "danger": "Danger",
            "ghost": "Secondaire",
            "primary": "Principal"
          },
          "with_icon": "Avec icône"
        },
        "radii": {
          "pill": "Pilule",
          "title": "Rayons"
        },
        "shadows": {
          "card": "cartes et panneaux",
          "hover": "survol des cartes",
          "title": "Ombres"
        },
        "show": {
          "intro": "Référence visuelle de l'ERP : chaque token et chaque composant, rendus avec les utilitaires Tailwind du design system. Réservée aux administrateurs.",
          "title": "Design system"
        },
        "typography": {
          "block_title": "Titre de bloc",
          "body": "Corps",
          "label": "Label majuscule",
          "meta": "Méta",
          "page_title": "Titre de page",
          "sample": "Portez les couleurs de votre équipe",
          "title": "Typographie"
        }
      },
      "footer_bar": {
        "container_component": {
          "created_at_by": "Créé le %{date} par %{user}",
          "updated_at_by": "Dernière modification le %{date} par %{user}"
        },
        "icon_button_component": {
          "add": "Ajouter",
          "close": "Retour",
          "delete": "Supprimer",
          "duplicate": "Dupliquer",
          "edit": "Modifier",
          "history": "Historique",
          "pdf": "PDF"
        },
        "save": "Enregistrer",
        "system": "Système"
      },
      "form": {
        "actions": {
          "cancel": "Annuler",
          "submit": "Enregistrer"
        },
        "errors": {
          "title": {
            "one": "%{count} erreur a empêché l'enregistrement",
            "other": "%{count} erreurs ont empêché l'enregistrement"
          }
        }
      },
      "inventory": {
        "dashboard": {
          "index": {
            "title": "Pilotage Inventaire"
          }
        }
      },
      "js": {
        "confirm": {
          "accept": "Confirmer",
          "cancel": "Annuler"
        }
      },
      "logistics": {
        "dashboard": {
          "index": {
            "title": "Pilotage Logistique"
          }
        }
      },
      "modal": {
        "component": {
          "close": "Fermer"
        }
      },
      "panel": {
        "component": {
          "optional": "facultatif"
        }
      },
      "pdf_viewer": {
        "component": {
          "close": "Fermer l’aperçu",
          "download": "Télécharger",
          "error": "Le PDF n’a pas pu être généré. Vérifiez la tarification du devis.",
          "loading": "Chargement du PDF…",
          "new_tab": "Nouvel onglet",
          "send": "Envoyer au client"
        }
      },
      "production": {
        "dashboard": {
          "index": {
            "affaires": "Affaires en production",
            "columns": {
              "actions": "Actions",
              "customer": "Client",
              "outstanding": "Reste à recevoir",
              "reference": "Affaire",
              "status": "Statut",
              "supply_orders": "Commandes",
              "textiles": "Textiles"
            },
            "empty": "Aucune affaire n'est encore entrée en production.",
            "textiles_pending": "En attente",
            "textiles_received": "Reçus le %{date}",
            "title": "Pilotage Production"
          }
        },
        "supply_orders": {
          "committed": "Cette commande a été passée au fournisseur (%{status}) : elle ne peut plus être supprimée.",
          "frozen_line": "Cette commande a été passée au fournisseur : %{attributes} ne peut plus être modifié. Ouvrez une seconde commande pour le reliquat.",
          "frozen_line_create": "Cette commande a été passée au fournisseur : aucune ligne ne peut plus y être ajoutée. Ouvrez une seconde commande.",
          "frozen_line_destroy": "Cette commande a été passée au fournisseur : ses lignes ne peuvent plus être supprimées.",
          "frozen_order": "Cette commande a été passée au fournisseur : %{attributes} ne peut plus être modifié.",
          "index": {
            "columns": {
              "actions": "Actions",
              "expected_at": "Attendu le",
              "lines": "Lignes",
              "ordered": "Commandé",
              "outstanding": "Reste",
              "received": "Reçu",
              "status": "Statut",
              "supplier": "Fournisseur"
            },
            "empty": "Aucune commande d'approvisionnement pour cette affaire.",
            "stale": "(stock non rafraîchi)",
            "textiles_received": "Textiles reçus le %{date}",
            "title": "Approvisionnement"
          },
          "invalid_quantity": "« %{value} » n'est pas une quantité entière.",
          "invalid_transition": "Action impossible sur une commande au statut %{status}.",
          "negative_delta": "Une quantité reçue doit être positive. Pour corriger une saisie, reprenez la commande à zéro.",
          "negative_reception": "Une quantité reçue ne peut pas être négative.",
          "never_refreshed": "Cette commande a été rouverte sans consulter le fournisseur : les quantités en stock ci-dessous sont les dernières valeurs connues.",
          "no_lines": "Cette commande ne contient aucune ligne : il n'y a rien à commander.",
          "no_production_order": "Cette affaire n'est pas encore entrée en production.",
          "not_in_production": "Cette affaire n'est plus en production : sa commande ne peut plus être passée.",
          "over_reception": "%{reference} : %{received} reçus pour %{ordered} commandés. Corrigez la saisie.",
          "show": {
            "columns": {
              "color": "Couleur",
              "ordered": "Commandé",
              "outstanding": "Reste",
              "received": "Reçu",
              "reception": "Réception",
              "reference": "Référence",
              "size": "Taille",
              "supplier_stock": "Stock fournisseur"
            },
            "confirm_order": "Passer cette commande au fournisseur ? Les quantités ne seront plus modifiables.",
            "empty": "Cette commande ne contient aucune ligne.",
            "expected_at": "attendu le %{date}",
            "external_id": "Réf. fournisseur %{id}",
            "order": "Commander",
            "receive": "Enregistrer la réception",
            "reception_hint": "Laissez vide une ligne qui n'a rien reçu.",
            "reception_label": "Quantité reçue pour %{reference}",
            "stock_as_of": "au %{date}",
            "stock_manual": "Fournisseur non connecté",
            "stock_never_refreshed": "jamais rafraîchi",
            "stock_stale": "Le stock fournisseur n'a pas pu être rafraîchi à la création de cette commande : les quantités en stock ci-dessous sont les dernières valeurs connues.",
            "stock_unknown": "Référence hors catalogue",
            "title": "Commande fournisseur"
          },
          "unknown_lines": "Ces lignes n'appartiennent pas à cette commande (%{ids}). Rechargez la page."
        }
      },
      "recap": {
        "checklist_component": {
          "done": "(fait)"
        }
      },
      "recipient_choices": {
        "customer_record": "Fiche client",
        "other": "Autres adresses",
        "other_hint": "Séparez les adresses par une virgule."
      },
      "sales": {
        "common": {
          "actions": "Actions",
          "back": "Retour",
          "bat_not_approved": "Mise en production impossible : le BAT n'est pas encore approuvé par le client",
          "cancel": "Annuler",
          "close": "Fermer",
          "confirm_delete": "Êtes-vous sûr de vouloir supprimer cet élément ?",
          "created": "Créé avec succès",
          "delete": "Supprimer",
          "deleted": "Supprimé avec succès",
          "download_file": "Télécharger %{name}",
          "duplication_failed": "La duplication a échoué : %{error}",
          "edit": "Modifier",
          "files_expired": "Les fichiers ont expiré. Veuillez les renvoyer.",
          "invalid_file": "Format de fichier non autorisé ou taille supérieure à 20 Mo. Aucun document n’a été ajouté.",
          "invalid_transition": "Transition impossible depuis le statut « %{status} »",
          "move_down": "Descendre",
          "move_up": "Monter",
          "next_section": "Section suivante",
          "on_quote": "Sur devis",
          "open_image": "Agrandir l’image de %{name}",
          "pdf_generation_failed": "Le PDF n’a pas pu être généré : les totaux de ce devis sont incohérents. L’incident a été signalé.",
          "previous_section": "Section précédente",
          "quantity": "Quantité",
          "revert_impossible": "Annulation impossible après 1 heure",
          "save": "Enregistrer",
          "updated": "Modifié avec succès"
        },
        "csv": {
          "name": "Nom",
          "price_excl_tax": "Prix HT",
          "quantity": "Quantité",
          "reference": "Référence",
          "size": "Taille",
          "sofidial_price_excl_tax": "Prix SOFIDIAL HT",
          "supplier_price_excl_tax": "Prix fournisseur HT",
          "variant_id": "ID Variante",
          "version_id": "ID Version"
        },
        "customer_addresses": {
          "edit": {
            "title": "Modifier l'adresse"
          },
          "index": {
            "billing": "Facturation",
            "columns": {
              "actions": "Actions",
              "address": "Adresse",
              "city": "Ville",
              "country": "Pays",
              "denomination": "Dénomination",
              "type": "Type"
            },
            "confirm_delete": "Êtes-vous sûr de vouloir supprimer cette adresse ?",
            "new": "Nouvelle adresse",
            "no_addresses": "Aucune adresse enregistrée",
            "primary": "Principale",
            "shipping": "Livraison",
            "title": "Adresses"
          },
          "new": {
            "title": "Nouvelle adresse"
          }
        },
        "customer_assets": {
          "edit": {
            "title": "Modifier le fichier"
          },
          "form": {
            "autosubmit_hint": "Les fichiers seront enregistrés automatiquement une fois l'envoi terminé.",
            "browse": "Parcourir",
            "category": "Catégorie",
            "description": "Description",
            "dropzone_hint": "Glissez-déposez vos fichiers ici ou",
            "file": "Fichier",
            "file_hint": "Formats acceptés : AI, images, PDF, Word. Taille max : 20 Mo.",
            "information": "Informations du fichier",
            "name": "Nom"
          },
          "index": {
            "all_categories": "Toutes les catégories",
            "columns": {
              "actions": "Actions",
              "category": "Catégorie",
              "date": "Date",
              "name": "Nom",
              "preview": "Aperçu",
              "size": "Taille",
              "type": "Type"
            },
            "confirm_delete": "Êtes-vous sûr de vouloir supprimer ce fichier ?",
            "no_assets": "Aucun fichier dans la bibliothèque",
            "reset_filters": "Réinitialiser",
            "title": "Bibliothèque"
          },
          "new": {
            "title": "Ajouter un fichier"
          }
        },
        "customer_bank_accounts": {
          "edit": {
            "title": "Modifier le compte bancaire"
          },
          "form": {
            "account_number": "N° de compte",
            "bank_code": "Code banque",
            "bank_info": "Informations bancaires",
            "branch_code": "Code guichet",
            "domestic_section": "National (RIB)",
            "international_section": "International (IBAN/BIC)",
            "options": "Options",
            "rib_key": "Clé RIB"
          },
          "index": {
            "columns": {
              "actions": "Actions",
              "bank_name": "Banque",
              "bic": "BIC",
              "domiciliation": "Domiciliation",
              "iban": "IBAN",
              "type": "Type"
            },
            "confirm_delete": "Êtes-vous sûr de vouloir supprimer ce compte bancaire ?",
            "international": "International",
            "new": "Nouveau compte",
            "no_bank_accounts": "Aucun compte bancaire enregistré",
            "primary": "Principal",
            "title": "Comptes bancaires"
          },
          "new": {
            "title": "Nouveau compte bancaire"
          }
        },
        "customer_contacts": {
          "edit": {
            "title": "Modifier le contact"
          },
          "form": {
            "active": "Actif",
            "fax": "Fax",
            "invoice_default_hint": "Son email devient l’email de facturation de la fiche.",
            "options": "Options",
            "phone_1": "Téléphone 1",
            "phone_2": "Téléphone 2"
          },
          "index": {
            "columns": {
              "actions": "Actions",
              "email": "Email",
              "function": "Fonction",
              "name": "Nom",
              "phone": "Téléphone",
              "status": "Statut"
            },
            "confirm_delete": "Êtes-vous sûr de vouloir supprimer ce contact ?",
            "inactive": "Inactif",
            "invoice_default": "Facture par défaut",
            "new": "Nouveau contact",
            "no_contacts": "Aucun contact enregistré",
            "primary": "Principal",
            "title": "Contacts"
          },
          "new": {
            "title": "Nouveau contact"
          }
        },
        "customer_estimates": {
          "accept_impossible": "Ce devis ne peut plus être accepté.",
          "accepted": "Devis accepté avec succès.",
          "artwork_pending_from_customer": "Visuel à fournir par le client",
          "pdf_unavailable": "Le PDF de ce devis n’a pas pu être établi. Contactez votre commercial, qui vous le transmettra.",
          "pricing_subgroups": {
            "all": "Tous les textiles",
            "color": "Textiles couleur",
            "colored": "Textiles couleur",
            "white": "Textiles blancs"
          },
          "reject_impossible": "Ce devis ne peut plus être refusé.",
          "rejected": "Devis refusé."
        },
        "customer_product_prices": {
          "edit": {
            "title": "Modifier le tarif"
          },
          "form": {
            "product": "Produit du catalogue",
            "product_hint": "Tapez au moins deux caractères.",
            "product_placeholder": "Rechercher par nom ou référence",
            "section": "Tarif",
            "unit_price": "Prix unitaire HT (€)",
            "unit_price_hint": "Le même prix pour toutes les couleurs et toutes les tailles."
          },
          "index": {
            "columns": {
              "actions": "Actions",
              "product": "Produit",
              "reference": "Référence",
              "unit_price": "Prix unitaire HT"
            },
            "confirm_delete": "Supprimer ce tarif ?",
            "intro": "Un prix unitaire HT fixe par produit du catalogue, toutes couleurs et tailles. Sur un devis de ce client, il remplace coefficient × prix fournisseur ; il reste modifiable à la ligne.",
            "new": "Nouveau tarif",
            "no_product_prices": "Aucun tarif client",
            "title": "Tarifs"
          },
          "new": {
            "title": "Nouveau tarif"
          }
        },
        "customers": {
          "chorus": "Chorus",
          "edit": {
            "title": "Modifier le client"
          },
          "form": {
            "address_line": "Adresse",
            "administrative": "Administratif",
            "archived": "Archivé",
            "chorus_hint": "Facultatifs, pour une administration facturée sur Chorus Pro.",
            "city": "Ville",
            "civility": "Civilité",
            "comments": "Commentaires",
            "commitment_number": "N° d’engagement",
            "contact": "Contact",
            "country": "Pays",
            "default_global_discount_percentage": "Remise globale par défaut (%)",
            "default_global_discount_percentage_hint": "Reprise sur les nouveaux devis de ce client, sans approbation.",
            "denomination": "Dénomination",
            "email": "Email",
            "family": "Famille",
            "first_name": "Prénom",
            "information": "Informations",
            "last_name": "Nom",
            "legal_form": "Forme juridique",
            "naf_code": "Code NAF",
            "not_assigned": "Non assigné",
            "payment_delay_days": "Délai de paiement (jours)",
            "payment_delay_days_placeholder": "Ex : 30",
            "payment_method": "Mode de paiement",
            "payment_method_hint": "Repris par défaut sur les nouveaux devis de ce client.",
            "payment_section": "Conditions de paiement",
            "payment_terms": "Conditions de paiement",
            "payment_terms_placeholder": "Ex : paiement à 30 jours fin de mois…",
            "phone_fixed": "Fixe",
            "phone_mobile": "Portable",
            "pole": "Pôle",
            "postal_code": "Code postal",
            "pricing": "Tarification",
            "primary_address": "Adresse principale",
            "responsible": "Responsable",
            "select_payment_method": "Sélectionner...",
            "service_code": "Code service",
            "siret": "SIRET",
            "status": "Statut",
            "textile_margin_rate": "Coefficient textile",
            "textile_margin_rate_hint": "Coefficient appliqué au prix fournisseur. Par défaut : %{default_rate}",
            "vat_number": "N° TVA",
            "website": "Site web"
          },
          "incomplete_profile": "Fiche à compléter",
          "index": {
            "active": "Actif",
            "add_customer": "Ajouter un nouveau client",
            "all_families": "Toutes les familles",
            "city_placeholder": "Ville",
            "columns": {
              "account_number": "ID",
              "actions": "Actions",
              "city": "Ville",
              "contact": "Contact",
              "denomination": "Dénomination client",
              "family": "Famille",
              "status": "Statut"
            },
            "export_csv": "Exporter en CSV",
            "export_pdf": "Exporter en PDF",
            "footer": {
              "customers": {
                "one": "1 client",
                "other": "%{count} clients",
                "zero": "Aucun client"
              }
            },
            "hide_archived": "Masquer archivés",
            "new": "Nouveau client",
            "no_customers": "Aucun client trouvé",
            "reset": "Réinitialiser",
            "search": "Rechercher",
            "search_placeholder": "Rechercher un client",
            "title": "Clients"
          },
          "new": {
            "title": "Nouveau client"
          },
          "profile_fields": {
            "address": "adresse complète (adresse, code postal, ville et pays)",
            "denomination": "dénomination",
            "email": "email",
            "family": "famille",
            "phone": "téléphone (portable ou fixe)",
            "siret": "SIRET"
          },
          "profile_missing_fields": "À renseigner : %{fields}.",
          "show": {
            "back": "Retour",
            "confirm_delete": "Êtes-vous sûr de vouloir supprimer ce client ?",
            "created_at": "Créé le %{date}",
            "created_at_by": "Client créé le %{date} par %{user}",
            "delete": "Supprimer",
            "edit": "Modifier",
            "fields": {
              "address": "Adresse",
              "city": "Ville",
              "civility": "Civilité",
              "commitment_number": "N° d’engagement",
              "country": "Pays",
              "default_global_discount": "Remise globale par défaut",
              "denomination": "Dénomination",
              "email": "Email",
              "family": "Famille",
              "first_name": "Prénom",
              "invoice_email": "Email de facturation",
              "last_name": "Nom",
              "legal_form": "Forme juridique",
              "mobile": "Portable",
              "naf_code": "Code NAF",
              "phone": "Fixe",
              "pole": "Pôle",
              "postal_code": "CP",
              "responsible": "Responsable",
              "service_code": "Code service",
              "siret": "SIRET",
              "vat_number": "N° TVA",
              "website": "Site web"
            },
            "loading": "Chargement...",
            "no_comments": "Aucun commentaire",
            "no_default_global_discount": "Aucune",
            "not_assigned": "Non assigné",
            "save": "Enregistrer",
            "sections": {
              "administrative": "Administratif",
              "comments": "Commentaires",
              "contact": "Contact",
              "customer_details": "Coordonnées client",
              "identity": "Contact principal",
              "information": "Informations",
              "primary_address": "Adresse principale",
              "responsible": "Responsable"
            },
            "status": {
              "archived": "Archivé",
              "label": "Statut"
            },
            "tab_addresses": "Adresses",
            "tab_appointments": "RDV",
            "tab_assets": "Bibliothèque",
            "tab_bank_accounts": "Comptes bancaires",
            "tab_contacts": "Contacts",
            "tab_estimates": "Devis",
            "tab_management": "Gestion",
            "tab_pricing": "Tarification",
            "tab_product_prices": "Tarifs",
            "tab_record": "Fiche",
            "tabs_label": "Sections de la fiche client",
            "title": "Fiche client",
            "updated_at": "Modifié le %{date}",
            "updated_at_by": "Dernière modification le %{date} par %{user}"
          }
        },
        "dashboard": {
          "index": {
            "active_customers": "Clients Actifs",
            "average_margin": "Marge Moyenne",
            "estimates_in_progress": "Devis en Cours",
            "no_recent_estimates": "Aucun devis récent",
            "no_upcoming_appointments": "Aucun rendez-vous à venir",
            "on_validated": "Sur devis validés",
            "recent_estimates": "Devis Récents",
            "recent_estimates_subtitle": "Suivi des derniers devis en cours",
            "scheduled_appointments": "RDV Planifiés",
            "this_week": "Cette semaine",
            "title": "Tableau de bord",
            "total_of": "Sur un total de %{count} clients",
            "upcoming_appointments": "RDV à Venir",
            "upcoming_appointments_subtitle": "Suivi des rendez-vous à venir",
            "value": "Valeur: %{amount}",
            "view_more": "Voir plus"
          }
        },
        "estimate_assets": {
          "index": {
            "add_to_library": "Ajouter à la bibliothèque du client",
            "confirm_unlink": "Retirer ce document du devis ?",
            "from_library": "Depuis la bibliothèque",
            "library_badge": "Bibliothèque",
            "no_documents": "Aucun document joint",
            "title": "Documents du devis",
            "upload_category": "Catégorie",
            "upload_file": "Télécharger un fichier",
            "upload_file_label": "Fichier",
            "upload_name": "Nom du fichier",
            "upload_submit": "Ajouter"
          },
          "library": {
            "empty_library": "La bibliothèque du client est vide",
            "link_selected": "Lier les fichiers sélectionnés"
          },
          "save_first": "Enregistrez le devis pour ajouter des documents"
        },
        "estimate_templates": {
          "edit": {
            "title": "Modifier le modèle"
          },
          "form": {
            "active": "Actif",
            "cancel": "Annuler",
            "description": "Description",
            "name": "Nom",
            "save": "Enregistrer",
            "validity_days": "Durée de validité (jours)"
          },
          "index": {
            "active": "Actif",
            "columns": {
              "actions": "Actions",
              "description": "Description",
              "name": "Nom",
              "status": "Statut",
              "validity_days": "Validité"
            },
            "inactive": "Inactif",
            "new": "Nouveau modèle",
            "no_templates": "Aucun modèle trouvé",
            "title": "Modèles de devis",
            "validity": {
              "one": "%{count} j",
              "other": "%{count} j"
            }
          },
          "new": {
            "title": "Nouveau modèle"
          },
          "show": {
            "days": "jours",
            "delete": "Supprimer",
            "description": "Description",
            "duplicate": "Dupliquer",
            "edit": "Modifier",
            "items": "Lignes prédéfinies",
            "no_items": "Aucune ligne prédéfinie",
            "title": "Modèle %{name}",
            "use_template": "Utiliser ce modèle",
            "validity": {
              "one": "Validité : %{count} jour",
              "other": "Validité : %{count} jours"
            },
            "validity_days": "Durée de validité"
          }
        },
        "estimates": {
          "approvals": {
            "approve": "Approuver",
            "decision_reason": "Motif de décision",
            "history": {
              "one": "Historique (%{count})",
              "other": "Historique (%{count})"
            },
            "notices": {
              "approved": "Approbation accordée",
              "auto_approved": "Approbation enregistrée",
              "rejected": "Approbation refusée",
              "requested": "Approbation demandée"
            },
            "pending": {
              "one": "%{count} approbation à obtenir avant l’envoi",
              "other": "%{count} approbations à obtenir avant l’envoi"
            },
            "ready": "Toutes les approbations requises sont accordées.",
            "reason": "Motif",
            "reject": "Refuser",
            "request": "Demander",
            "request_and_approve": "Demander et auto-approuver",
            "statuses": {
              "approved": "Approuvée",
              "invalidated": "Invalidée",
              "pending": "En attente",
              "rejected": "Refusée"
            },
            "title": "Approbations",
            "types": {
              "compatibility_override": "Compatibilité forcée",
              "complimentary": "Gratuité",
              "custom_marking_zone": "Zone personnalisée",
              "customer_supplied_textile": "Textile client",
              "discount_over_threshold": "Remise exceptionnelle",
              "manual_price": "Prix manuel"
            }
          },
          "compatibility_warnings": {
            "line": "%{marking} · %{textile} : compatibilité non renseignée — à vérifier au BAT.",
            "title": "À vérifier au BAT"
          },
          "customer_history": {
            "columns": {
              "description": "Description",
              "image": "Image",
              "marking": "Marquage",
              "quantity": "Qté",
              "reference": "Réf.",
              "unit_price": "PU HT"
            },
            "items_count": {
              "one": "%{count} article",
              "other": "%{count} articles"
            },
            "no_history": "Aucun historique pour ce client.",
            "reimport": "Réimporter",
            "table_scroll_region": "Lignes du devis %{reference}. Faites défiler horizontalement pour voir toutes les colonnes.",
            "title": "Historique — %{customer}",
            "wait_for_save": "Attendez la fin de l’enregistrement avant de réimporter une ligne."
          },
          "delivery_history": {
            "revision": "Révision %{number}",
            "title": "Envois et relances"
          },
          "discount_types": {
            "fixed": "Montant fixe",
            "percentage": "Pourcentage"
          },
          "edit": {
            "autosave_active": "Sauvegarde automatique active",
            "customer_history_button": "Historique & Anciennes commandes",
            "title": "Modifier le devis"
          },
          "editor": {
            "checklist": {
              "blocking": {
                "one": "%{count} point à régler avant l’envoi",
                "other": "%{count} points à régler avant l’envoi"
              },
              "groups": {
                "estimate": "Devis"
              },
              "items": {
                "customer": "Client choisi",
                "information": "Titre et validité",
                "markings": "Marquages définis",
                "textiles": "Au moins un textile"
              },
              "no_size": "non renseignée",
              "pricing": {
                "extra": "Option %{code} : %{reason}",
                "extras": {
                  "inactive": "désactivée",
                  "invalid_price": "tarif négatif",
                  "missing": "absente des grilles",
                  "missing_percentage": "pourcentage manquant",
                  "missing_price": "sans tarif",
                  "wrong_customer_type": "indisponible pour ce client",
                  "wrong_technique": "incompatible avec la technique",
                  "zero_price_requires_complimentary": "prix nul"
                },
                "fallback": "Prix à vérifier",
                "reasons": {
                  "above_maximum": "Quantité au-dessus du dernier palier",
                  "ambiguous_grid": "Plusieurs grilles tarifaires possibles",
                  "below_minimum": "Quantité sous le premier palier",
                  "customer_supplied_requires_approval": "Textile client à faire approuver",
                  "inconsistent_subgroup_brackets": "Paliers blanc et couleur incohérents",
                  "invalid_margin_rate": "Coefficient inférieur à 1",
                  "invalid_price": "Prix négatif dans la grille",
                  "manual_price_requires_approval": "Prix forcé à faire approuver",
                  "missing_customer": "Client manquant",
                  "missing_dimensions": "Couleurs, format ou points à choisir",
                  "missing_margin_rate": "Coefficient client absent",
                  "missing_price": "Prix absent de la grille",
                  "missing_quantity": "Aucune pièce associée",
                  "missing_supplier_cost": "Coût fournisseur absent",
                  "missing_textile_classification": "Coloris ni blanc ni couleur",
                  "missing_tier": "Aucun palier pour cette quantité",
                  "mixed_supplier_costs": "Coûts fournisseur différents selon les tailles",
                  "no_grid": "Aucune grille tarifaire",
                  "pricing_not_calculated": "Prix pas encore calculé",
                  "quote_required": "Prix sur devis, à forcer",
                  "size_allocations_required": "Répartition par taille à faire",
                  "zero_net_requires_complimentary": "Total nul après remise",
                  "zero_price_requires_complimentary": "Prix nul, à déclarer offert"
                },
                "subgroups": {
                  "all": "tous textiles",
                  "colored": "textile couleur",
                  "white": "textile blanc"
                },
                "with_subgroup": "%{label} (%{subgroup})"
              },
              "ready": "Prêt à l’envoi.",
              "reasons": {
                "approval_missing": "Approbation « %{type} » à obtenir",
                "canonical_size_missing": "Taille %{size} inconnue du catalogue",
                "compatibility_blocked": "%{textile} : %{reason}",
                "dimensions_missing": "Format à choisir",
                "duplicate_marking_series": "Même série que %{markings} : regrouper ou distinguer",
                "empty_estimate": "Aucune ligne chiffrée ni offerte",
                "global_discount_exceeds_subtotal": "Remise supérieure au sous-total",
                "invalid_allocation": "%{textile}, taille %{size} : répartition à corriger",
                "marking_zone_ambiguous": "Deux zones renseignées, n’en garder qu’une",
                "marking_zone_missing": "Zone de marquage à choisir",
                "textile_sizes_missing": "Quantités par taille à saisir",
                "validity_expired": "Date de validité dépassée",
                "validity_missing": "Date de validité à renseigner"
              },
              "title": "Checklist d’envoi",
              "unknown_textile": "Textile inconnu"
            },
            "customer": {
              "change": "Changer",
              "create": "Créer un nouveau client",
              "create_hint": "Sans quitter le devis",
              "create_named": "Créer le client « %{name} »",
              "estimates_count": {
                "one": "%{count} devis",
                "other": "%{count} devis"
              },
              "first_estimate": "Premier devis",
              "grid_title": "Grille tarifaire appliquée à ce devis",
              "grids": {
                "direct": "Tarif direct",
                "reseller": "Tarif revendeur"
              },
              "new_tag": "Nouveau client",
              "no_match": "Aucun client ne correspond à « %{query} ».",
              "payment": "Paiement : %{method}",
              "recent": "Vos clients récents"
            },
            "footer": {
              "back": "Retour aux devis",
              "new_status": "Brouillon non enregistré"
            },
            "general": {
              "choose_customer_first": "Choisissez d’abord un client",
              "customer_create": "Créer un nouveau client",
              "customer_missing": "Client absent de la liste ?",
              "customer_placeholder": "Rechercher un client par nom ou ville…",
              "customer_results": "Clients",
              "days": {
                "one": "%{count} j",
                "other": "%{count} j"
              },
              "edit": "Modifier",
              "help": "Le client est obligatoire : ses tarifs préférentiels s’appliquent aux textiles et aux marquages.",
              "missing": "Il manque :",
              "missing_fields": {
                "customer": "le client",
                "title": "le titre",
                "validity": "la date de validité"
              },
              "ready": "Tout est bon.",
              "save": "Enregistrer les informations",
              "title": "Informations générales",
              "title_hint": "Visible par le client sur le devis.",
              "title_label": "Titre du devis",
              "title_placeholder": "Ex. Tenues saison 2026-2027",
              "valid_until": "valable jusqu’au",
              "validate": "Valider et passer aux textiles",
              "validity_shortcuts": "Durée de validité"
            },
            "head": {
              "new_subtitle": "Remplissez les blocs dans l’ordre. Le brouillon est créé à la validation des informations générales."
            },
            "markings": {
              "help": "Ajoutez un marquage puis choisissez les textiles concernés.",
              "locked": "Disponible une fois les informations générales validées : chaque marquage s’applique à un ou plusieurs textiles."
            },
            "new_customer": {
              "address": "Adresse",
              "address_placeholder": "N° et rue",
              "cancel": "Annuler",
              "city": "Ville",
              "denomination": "Nom ou raison sociale",
              "email": "Email",
              "failed": "Le client n’a pas pu être créé. Réessayez dans un instant.",
              "family": "Type de client",
              "family_hint": "Un revendeur reçoit la grille revendeur ; les professionnels, les particuliers et les administrations, la grille directe.",
              "first_name": "Prénom du contact",
              "intro": "Le strict nécessaire pour faire le devis. La fiche pourra être complétée ensuite dans Clients.",
              "last_name": "Nom du contact",
              "more": "Plus d’informations (facultatif)",
              "phone": "Téléphone",
              "postal_code": "Code postal",
              "siret": "SIRET",
              "submit": "Créer et sélectionner",
              "title": "Nouveau client"
            },
            "notes": {
              "customer_note": "Note pour le client",
              "customer_note_placeholder": "Apparaît sur le devis envoyé.",
              "help": "Une note pour le client, une note interne ou des documents.",
              "internal_note": "Note interne",
              "internal_note_placeholder": "Visible uniquement par l’équipe.",
              "locked": "Disponible une fois les informations générales validées."
            },
            "recap": {
              "customer": "Client",
              "grid": "Grille tarifaire",
              "label": "Récapitulatif du devis",
              "payment_hint": "Repris de la fiche client une fois le client choisi."
            },
            "save_errors": {
              "allocation_below_personalized_piece": "%{group} : la pièce %{piece} de la taille %{size} de %{textile} est personnalisée, gardez au moins %{piece} pièces",
              "allocation_exceeds_size": {
                "one": "%{group} : %{count} pièce sur la taille %{size} de %{textile}, qui n’en a que %{limit}",
                "other": "%{group} : %{count} pièces sur la taille %{size} de %{textile}, qui n’en a que %{limit}"
              },
              "estimate": "Devis",
              "fallback": "Devis : une donnée saisie ne peut pas être enregistrée",
              "generic": "%{group} : %{message}",
              "no_size": "non renseignée",
              "section": "Section %{number} · %{name}",
              "size_below_markings": {
                "one": "%{group} : %{count} pièce y est marquée, la quantité ne peut pas descendre en dessous",
                "other": "%{group} : %{count} pièces y sont marquées, la quantité ne peut pas descendre en dessous"
              },
              "size_of": "%{textile} · taille %{size}",
              "unknown_textile": "Textile inconnu",
              "unnamed": "sans nom"
            },
            "save_state": {
              "error": "Enregistrement impossible",
              "modified": "Modifications non enregistrées",
              "saved": "Enregistré",
              "saving": "Enregistrement…"
            },
            "textiles": {
              "help": "Ajoutez les textiles du devis. Les prix tiennent compte de la grille du client.",
              "locked": "Validez d’abord les informations générales : les prix dépendent du client."
            }
          },
          "form": {
            "add_section": "Ajouter une section",
            "add_textile": "Ajouter un textile",
            "already_marked": "Produit déjà marqué",
            "applied_tier": "Palier appliqué :",
            "artwork_missing": "Fichier non reçu",
            "artwork_pending_from_customer": "Visuel à fournir par le client",
            "artwork_pending_from_customer_hint": "Cochez cette case si le client doit encore transmettre le visuel après l’établissement du devis.",
            "artwork_version": "Révision du fichier de marquage",
            "artwork_version_hint": "Numéro interne du visuel reçu. Incrémentez-le lorsque le fichier client est remplacé afin de conserver la traçabilité du devis envoyé.",
            "billing_address": "Adresse de facturation",
            "cancel": "Annuler",
            "change_product": "changer",
            "columns": {
              "reference": "Référence",
              "sizes": "Tailles & qté"
            },
            "compatibility_check_pending": "À vérifier",
            "complimentary_marking": "Marquage offert",
            "complimentary_textile": "Textile offert",
            "custom_marking_zone_approval": "Une zone personnalisée nécessite une approbation avant envoi.",
            "custom_marking_zone_placeholder": "Ex. Bas du dos, côté droit",
            "customer": "Client",
            "customer_files": "Fichiers client",
            "customer_main_address": "Adresse principale du client",
            "delete_line": "Supprimer la ligne",
            "delete_section": "Supprimer la section",
            "description": "Description",
            "dimension": "Dimension",
            "discount_amount": "Remise (€)",
            "discount_amount_per_piece": "Remise par pièce (€)",
            "discount_applied": "Remise appliquée",
            "discount_percentage": "Remise (%)",
            "discount_type": "Type de remise",
            "documents": "Documents",
            "edit_line": "Modifier la ligne",
            "erp_extras_hint": "Sélectionnez les frais applicables ; ils seront calculés une seule fois selon leur règle ERP.",
            "erp_extras_title": "Frais et options de marquage",
            "erp_fee": "Frais ERP — %{code}",
            "erp_only_source": "Source ERP",
            "extra_inactive": "Option désactivée dans l’ERP",
            "extra_names": {
              "perso_coeur": "Personnalisation cœur",
              "perso_dos": "Personnalisation dos",
              "personnalisation": "Personnalisation",
              "personnalisation_piece": "Personnalisation par pièce, petit emplacement",
              "personnalisation_piece_grand": "Personnalisation par pièce, grand emplacement"
            },
            "extra_price_fixed": "%{price} par série",
            "extra_price_missing": "Tarif ERP manquant",
            "extra_price_per_piece": "%{price} par pièce",
            "extra_price_percentage": "%{percentage} % du marquage",
            "extra_wrong_customer_type": "Cette option ne correspond plus au type de client sélectionné ; retirez-la ou rétablissez le client.",
            "extra_wrong_technique": "Cette option ne correspond plus à la technique sélectionnée ; retirez-la ou rétablissez la technique.",
            "force_compatibility": "Forcer une incompatibilité",
            "force_compatibility_hint": "À utiliser uniquement après validation technique ; une approbation sera requise.",
            "force_price": "Forcer le prix",
            "global_discount": "Remise globale",
            "global_discount_fixed_legacy": "Remise fixe de %{amount} reprise d’un ancien devis. Saisissez un pourcentage pour la remplacer.",
            "global_discount_none": "Aucune",
            "global_discount_other": "Autre",
            "global_discount_other_hint": "Hors 5 et 10 %, la remise globale demande une approbation avant l’envoi.",
            "global_discount_other_input": "Remise globale (%)",
            "items_subtotal": "Sous-total articles",
            "legacy_allocations_hint": "Ces associations utilisent encore l'ancien format. Répartissez-les par taille pour débloquer la tarification ERP.",
            "linked_textiles_section": "Textiles concernés",
            "manual_price_approval": "Un prix manuel nécessite une approbation avant envoi.",
            "manual_price_reason": "Motif du prix manuel",
            "margin_rate": "Coefficient",
            "marking_discount": "Remise sur ce marquage",
            "marking_position": "Emplacement",
            "marking_quantity": "Quantité marquée",
            "marking_quantity_hint": "Calculée depuis les textiles associés.",
            "marking_untyped": "Marquage",
            "markings_need_textiles": "Ajoutez d'abord des textiles pour y appliquer un marquage.",
            "new_line": "Nouvelle ligne",
            "no_erp_extras": "Aucun frais ERP actif pour cette technique et ce type de client.",
            "no_marking_discount": "Aucune remise",
            "no_markings": "Aucun marquage",
            "over_attached": "Quantité supérieure à celle du textile",
            "override_reason": "Motif du forçage",
            "payment_method": "Mode de paiement",
            "payment_method_from_customer": "Par défaut sur la fiche client : %{method}",
            "piece_count": {
              "one": "1 pièce",
              "other": "%{count} pièces"
            },
            "pieces": {
              "one": "%{count} pce",
              "other": "%{count} pcs"
            },
            "pricing_adjustments": "Ajustements facultatifs · TVA, remise, exceptions",
            "pricing_blocked_marking_title": "Tarification bloquée pour %{marking}",
            "pricing_blocked_title": "Tarification bloquée",
            "pricing_blocking_reason_details": {
              "above_maximum": "ce marquage contient %{quantity} ; le dernier palier s’arrête à %{maximum}. Ajoutez un palier dans la grille ERP ou activez « Forcer le prix ».",
              "below_minimum": "ce marquage contient %{quantity} ; le premier palier commence à %{minimum}. Augmentez la quantité marquée à %{minimum} ou activez « Forcer le prix ».",
              "stale": "ce marquage contient %{quantity}. La grille ERP a changé depuis ce calcul ; enregistrez le devis pour vérifier le palier actuel ou activez « Forcer le prix »."
            },
            "pricing_blocking_reasons": {
              "above_maximum": "Quantité supérieure au dernier palier. Ajoutez un palier supérieur ou forcez le prix avec un motif.",
              "ambiguous_grid": "Plusieurs tarifs ERP actifs correspondent à cette combinaison. Désactivez les grilles en doublon avant de recalculer.",
              "below_minimum": "Quantité inférieure au premier palier. Augmentez la quantité ou forcez le prix avec un motif.",
              "customer_supplied_requires_approval": "Textile fourni par le client non approuvé. Demandez puis faites valider cette exception dans la section Approbations.",
              "inconsistent_subgroup_brackets": "Paliers blanc et couleur incohérents. Alignez les bornes des deux sous-groupes dans la grille ERP.",
              "invalid_margin_rate": "Coefficient textile invalide (minimum 1). Saisissez une valeur supérieure ou égale à 1.",
              "invalid_price": "Prix négatif dans la grille ERP. Corrigez ce montant dans la grille puis recalculez le devis.",
              "manual_price_requires_approval": "Prix manuel non approuvé. Renseignez son motif puis faites valider cette exception dans la section Approbations.",
              "missing_customer": "Client manquant. Sélectionnez le client du devis avant de calculer les tarifs.",
              "missing_dimensions": "Paramètre de grille manquant. Sélectionnez le nombre de couleurs, le format ou le nombre de points demandé par la technique.",
              "missing_margin_rate": "Coefficient client absent. Renseignez le coefficient textile dans la fiche client ou sur cette ligne.",
              "missing_price": "Tarif absent dans la grille ERP. Renseignez le prix du palier correspondant puis recalculez le devis.",
              "missing_quantity": "Aucune quantité allouée. Associez le marquage à au moins une taille avec une quantité supérieure à zéro.",
              "missing_supplier_cost": "Coût fournisseur absent. Renseignez ou rafraîchissez le coût fournisseur du textile.",
              "missing_textile_classification": "Classification blanc ou couleur manquante. Classez le coloris dans le catalogue ou corrigez le textile sélectionné.",
              "missing_tier": "Aucun palier ne couvre cette quantité. Ajoutez un palier dans la grille ERP ou forcez le prix avec un motif.",
              "mixed_catalogue_prices": "Prix catalogue différents entre les tailles. Séparez ces variantes en lignes distinctes.",
              "mixed_supplier_costs": "Coûts fournisseur incohérents entre les tailles. Séparez les tailles dans des lignes tarifaires distinctes ou harmonisez leurs coûts.",
              "no_grid": "Grille tarifaire introuvable. Créez ou activez une grille correspondant à la technique et au type de client, ou forcez le prix avec un motif.",
              "pricing_not_calculated": "Tarification non calculée. Enregistrez le devis pour appliquer la grille ERP actuelle.",
              "quote_required": "Tarif configuré sur devis. Forcez le prix avec un motif après avoir obtenu le chiffrage nécessaire.",
              "size_allocations_required": "Répartition par taille requise. Ouvrez « Textiles associés » et allouez chaque quantité aux tailles concernées.",
              "zero_net_requires_complimentary": "Total net nul après remise. Déclarez la ligne offerte ou réduisez la remise.",
              "zero_price_requires_complimentary": "Prix nul non autorisé. Déclarez la ligne offerte ou saisissez un prix strictement positif."
            },
            "pricing_calculate_button": "Calculer le tarif",
            "pricing_calculate_hint": "Enregistre le devis et applique la grille ERP actuelle.",
            "pricing_choice": "Choix tarifaire",
            "pricing_choice_empty": "Choisissez d’abord une technique pour voir les tarifs.",
            "pricing_choice_hint": "Nombre de couleurs, format ou points selon la technique.",
            "pricing_choice_none": "Aucun paramètre",
            "pricing_choice_prototype": "Prototype",
            "pricing_choice_standard": "Standard",
            "pricing_color_plural": "couleurs",
            "pricing_color_singular": "couleur",
            "pricing_dimension": "Paramètre de grille ERP",
            "pricing_extra_blocking_reason": "Option %{code} : %{reason}",
            "pricing_extra_blocking_reasons": {
              "inactive": "désactivée dans l’ERP. Retirez cette option du marquage ou réactivez-la dans les grilles tarifaires.",
              "invalid_price": "montant négatif dans l’ERP. Renseignez un montant strictement positif, ou déclarez le marquage offert si cette option doit rester à zéro.",
              "missing": "absente des grilles tarifaires pour cette technique. Ajoutez-la dans la grille correspondante, ou retirez les pièces personnalisées du marquage.",
              "missing_percentage": "pourcentage absent dans l’ERP. Renseignez le pourcentage de cette option dans la grille correspondante.",
              "missing_price": "tarif absent dans l’ERP. Renseignez le montant de cette option dans la grille correspondante.",
              "wrong_customer_type": "indisponible pour ce type de client. Retirez cette option ou corrigez son périmètre client dans les grilles tarifaires.",
              "wrong_technique": "incompatible avec la technique sélectionnée. Retirez cette option ou rétablissez la technique pour laquelle elle a été configurée.",
              "zero_price_requires_complimentary": "prix nul. Déclarez le marquage offert ou renseignez un montant strictement positif."
            },
            "pricing_pending_hint": "Enregistrez le devis pour calculer le palier, les sous-groupes et les frais depuis les grilles ERP.",
            "pricing_recalculate_short": "À recalculer",
            "pricing_section": "Prix",
            "pricing_stale_error_link": "Voir l’erreur",
            "pricing_stale_on_conflict": "Tarif en attente : le devis a été enregistré ailleurs entre-temps.",
            "pricing_stale_on_error": "Tarif en attente : corrigez d’abord l’erreur.",
            "pricing_stale_on_save": "Tarif recalculé à l’enregistrement.",
            "pricing_stale_reload": "Recharger la dernière version",
            "pricing_statuses": {
              "blocked": "Bloqué",
              "complimentary": "Offert",
              "pending": "À calculer",
              "priced": "Tarif ERP appliqué"
            },
            "pricing_stitch_unit": "points",
            "pricing_subgroups": {
              "all": "Tous textiles",
              "colored": "Textile couleur",
              "white": "Textile blanc"
            },
            "pricing_total": "Total marquage et frais",
            "pricing_unavailable": "Tarif indisponible",
            "pricing_vat_short": "TVA",
            "product": "Produit",
            "quantity": "Quantité",
            "quantity_stepper": {
              "decrement": "Retirer une pièce, __FIELD__",
              "increment": "Ajouter une pièce, __FIELD__"
            },
            "refresh_supplier_price": "Rafraîchir depuis Imbretex",
            "remove_file": "Retirer %{filename}",
            "replace_textile": "Remplacer",
            "responsible": "Commercial",
            "save": "Enregistrer",
            "save_textiles_before_allocating": "Enregistrez d'abord le devis pour pouvoir allouer ces tailles.",
            "search_product": "Rechercher par nom ou référence...",
            "section_name": "Nom de la section",
            "select_all_textiles": "Tout sélectionner",
            "select_payment_method": "Sélectionner...",
            "select_template": "Sélectionner un modèle (optionnel)",
            "settings": "Paramètres",
            "shipping_address": "Adresse de livraison",
            "size_breakdown_required": "Ajoutez des tailles à ce textile avant de lui associer un marquage.",
            "size_quantity_label": "Quantité textile, taille %{size}",
            "size_quantity_template_label": "Quantité textile par taille",
            "sizes_hint": "La quantité de la ligne est la somme des tailles.",
            "sizes_section": "Tailles & quantités",
            "stale_update": "Ce devis a été modifié dans un autre onglet ou par un autre utilisateur. Rechargez la page avant de poursuivre.",
            "sub_technique": "Procédé DTF",
            "sub_technique_hint": "Variante de production utilisée pour sélectionner la grille tarifaire DTF, DST ou FLEX.",
            "subtotal_ht": "Total HT",
            "summary": "Récapitulatif",
            "supplier_price": "Prix fournisseur (€)",
            "supplier_price_unknown": "Tarif fournisseur inconnu — à rafraîchir ou à saisir.",
            "tabs": {
              "documents": "Notes & documents",
              "markings": "Marquages",
              "textiles": "Textiles"
            },
            "tariffs_changed_since_save": "Les tarifs ERP ont changé depuis la dernière sauvegarde. Enregistrez le devis pour actualiser les montants affichés.",
            "technique": "Technique",
            "template": "Modèle",
            "textile_price": "Prix textile (€)",
            "title": "Titre",
            "total_ttc": "Total TTC",
            "unit": "Unité",
            "unit_price_erp_hint": "Calculé depuis la grille ERP, sauf prix forcé.",
            "unit_price_ht": "Prix unitaire HT",
            "validity_date": "Date de validité",
            "vat": "TVA",
            "vat_rate": "Taux TVA"
          },
          "garment_types": {
            "autre": "Autre",
            "casquette": "Casquette",
            "polo": "Polo",
            "sac": "Sac",
            "sweat": "Sweat",
            "tshirt": "T-shirt",
            "veste": "Veste"
          },
          "index": {
            "card": {
              "actions": {
                "accept": "Marquer comme accepté",
                "complete": "Compléter",
                "delete": "Supprimer",
                "duplicate": "Dupliquer",
                "edit": "Modifier",
                "lose": "Marquer comme perdu",
                "new_version": "Créer une nouvelle version",
                "open": "Ouvrir le devis",
                "open_short": "Ouvrir",
                "pdf": "Télécharger le PDF",
                "proof": "Voir le BAT",
                "reopen": "Rouvrir le devis",
                "resume": "Reprendre",
                "send": "Envoyer la V%{number}",
                "update": "Mettre à jour"
              },
              "amount": {
                "discount_amount": "remise %{value}",
                "discount_percentage": "remise %{value} %",
                "excluding_tax": "HT",
                "lines_without_price": {
                  "one": "%{count} ligne sans tarif",
                  "other": "%{count} lignes sans tarif"
                },
                "margin": "marge %{value} %",
                "missing": "Prix à compléter",
                "valid_until": "valable jusqu’au %{date}",
                "viewed": "vu par le client"
              },
              "confirm": {
                "delete": {
                  "accept": "Supprimer",
                  "text": "%{reference} · Le brouillon et ses lignes seront supprimés définitivement.",
                  "title": "Supprimer ce brouillon ?"
                }
              },
              "events": {
                "created": "créé le %{date}",
                "design": "en conception depuis le %{date}",
                "lost": "perdu le %{date}",
                "sent": "envoyé le %{date}",
                "won": "validé le %{date}"
              },
              "menu": {
                "advance": "Faire avancer",
                "consult": "Consulter",
                "label": "Plus d’actions pour %{reference}"
              },
              "pieces": {
                "one": "%{count} pc",
                "other": "%{count} pcs"
              },
              "tags": {
                "draft_revision": "V%{number} en brouillon",
                "expired": "Validité dépassée",
                "price_missing": "Prix manquant"
              }
            },
            "columns": {
              "date": "Date",
              "denomination": "Client",
              "reference": "N° devis",
              "responsible": "Responsable",
              "status": "État",
              "title": "Intitulé"
            },
            "duplicate": "Dupliquer un devis",
            "duplicate_dialog": {
              "action": "Dupliquer",
              "action_for": "Dupliquer %{reference}",
              "empty": "Aucun devis ne correspond à cette recherche.",
              "intro": "Cherchez le devis à reprendre. La copie s’ouvre en brouillon, à votre nom.",
              "results": "Devis à dupliquer",
              "search_placeholder": "Rechercher un n°, un client, un intitulé…"
            },
            "empty": {
              "filtered": "Aucun devis ne correspond à ces filtres.",
              "none": "Aucun devis pour le moment. Lancez le premier.",
              "title": "Aucun devis"
            },
            "filters": {
              "all_periods": "Toutes les périodes",
              "all_responsibles": "Tous les responsables",
              "mine": "Mes devis",
              "periods": {
                "last_month": "Mois dernier",
                "last_year": "Année dernière",
                "this_month": "Ce mois",
                "this_quarter": "Ce trimestre",
                "this_year": "Cette année"
              },
              "reset": "Réinitialiser",
              "search_placeholder": "Rechercher un n°, un client, un intitulé…"
            },
            "footer": {
              "drafts": {
                "one": "%{count} brouillon",
                "other": "%{count} brouillons",
                "zero": "aucun brouillon"
              },
              "estimates": {
                "one": "%{count} devis",
                "other": "%{count} devis"
              }
            },
            "groups": {
              "meta": "%{count} devis · %{amount} HT",
              "this_week": "Cette semaine"
            },
            "kpis": {
              "awaiting_customer": "En attente client",
              "awaiting_customer_hint": {
                "one": "%{count} devis envoyé · HT",
                "other": "%{count} devis envoyés · HT",
                "zero": "Aucun devis envoyé"
              },
              "conversion": "Taux de transformation",
              "conversion_hint": "sur les 90 derniers jours",
              "conversion_none": "—",
              "conversion_value": "%{rate} %",
              "drafts": "Brouillons",
              "drafts_hint": "dont %{count} à compléter",
              "expiring_soon": "Expirent sous 7 jours",
              "expiring_soon_hint": "à relancer",
              "label": "Indicateurs"
            },
            "lost_reasons": {
              "label": "Motifs de perte",
              "none": "Sans motif"
            },
            "new": "Nouveau devis",
            "statuses": {
              "design": "En conception",
              "draft": "Brouillon",
              "lost": "Perdu",
              "pending": "Non validé",
              "sent": "En cours",
              "won": "Affaire validée"
            },
            "subtitle": "Suivez vos devis, reprenez un brouillon ou lancez-en un nouveau.",
            "tabs": {
              "all": "Tous",
              "design": "En conception",
              "draft": "Brouillons",
              "label": "Filtrer par statut",
              "lost": "Perdus",
              "pending": "Non validés",
              "sent": "En cours",
              "won": "Affaires"
            },
            "title": "Devis",
            "todo": {
              "ctas": {
                "approvals": "Examiner",
                "expired": "Mettre à jour",
                "price_missing": "Compléter"
              },
              "meta": "%{title} · créé le %{date}",
              "reasons": {
                "approvals": {
                  "one": "%{count} approbation en attente",
                  "other": "%{count} approbations en attente"
                },
                "expired": "Validité dépassée depuis le %{date}",
                "price_missing": "Prix manquant sur une ligne"
              },
              "title": "À traiter"
            }
          },
          "lose": {
            "comment_required": "Précisez le motif dans le commentaire.",
            "reason_required": "Choisissez le motif de la perte."
          },
          "lose_dialog": {
            "comment": "Commentaire",
            "comment_hint": "Obligatoire avec « Autre motif ».",
            "confirm": "Marquer comme perdu",
            "intro": "%{reference} · Le devis sort des devis en cours. Vous pourrez annuler pendant une heure.",
            "reason": "Motif",
            "title": "Affaire perdue"
          },
          "lost_reasons": {
            "competitor": "Offre d’un concurrent retenue",
            "lead_time": "Délai trop long",
            "other": "Autre motif",
            "price": "Prix trop élevé",
            "project_abandoned": "Projet abandonné"
          },
          "markings": {
            "block": {
              "add": "Ajouter un marquage",
              "empty_text": "En 4 étapes : la technique, l’emplacement, le logo, puis les textiles concernés.",
              "empty_title": "Aucun marquage pour l’instant",
              "locked": "Ajoutez d’abord un textile : chaque marquage s’applique à un ou plusieurs textiles."
            },
            "card": {
              "actions": {
                "delete": "Supprimer le marquage : %{name}",
                "duplicate": "Dupliquer le marquage : %{name}",
                "edit": "Modifier le marquage : %{name}",
                "more_actions": "Actions secondaires : %{name}",
                "pricing": "Tarif du marquage : %{name}"
              },
              "artwork_pending": "Visuel à fournir",
              "custom_zone": "Zone à faire valider",
              "delete_confirm": {
                "accept": "Supprimer",
                "text": "Le marquage, ses affectations aux textiles et ses personnalisations sont retirés du devis.",
                "title": "Supprimer ce marquage ?"
              },
              "dimensions": "%{width} × %{height} mm",
              "edit": "Modifier",
              "no_textile": "Aucun textile associé",
              "personalized_pieces": "· %{pieces} pcs personnalisées",
              "pieces_html": "%{pieces} pcs",
              "pricing": "Tarif",
              "textile_chip": "%{textile} · %{pieces} pcs",
              "underbase": "+ sous-couche"
            },
            "wizard": {
              "artwork": {
                "drop": "Déposer le logo ici",
                "drop_hint": "ou cliquer pour choisir · AI, SVG ou PDF de préférence (PNG ou JPG en haute définition)",
                "intro": "Saisissez le texte à marquer ou déposez le fichier du client. S’il doit encore fournir le visuel, cochez la case ci-dessous.",
                "library": "Depuis les documents du devis",
                "notes": "Consignes pour l’atelier",
                "notes_placeholder": "Ex. logo en blanc sur les textiles foncés",
                "optional": "facultatif",
                "personalized_pieces": "Pièces personnalisées",
                "personalized_pieces_hint": "Chacune ajoute le supplément de personnalisation des grilles tarifaires, selon l’emplacement : petit (cœur, manches) ou grand (poitrine, dos, emplacement personnalisé). Broderie, transfert et PAP appliquent leurs propres options de personnalisation. Noms, prénoms et tailles se recueillent au BAT.",
                "personalized_pieces_max": "/ %{pieces}",
                "remove_pending": "Retirer %{filename}",
                "text": "Texte à marquer",
                "text_hint": "Le texte peut être utilisé seul ou avec un logo. La mise en forme se précise au BAT.",
                "text_placeholder": "Ex. STAFF",
                "title": "Le visuel à marquer",
                "use": "Utiliser",
                "use_label": "Utiliser %{name} comme logo"
              },
              "close": "Fermer",
              "next": "Suivant",
              "placement": {
                "advised": "Conseillé",
                "custom": "Ou un emplacement personnalisé",
                "format": "Format du marquage",
                "format_examples": {
                  "A3": "Dos, grand visuel",
                  "A4": "Poitrine, logo moyen",
                  "A6": "Cœur, manches, petit logo"
                },
                "format_size": "%{width} × %{height} mm",
                "intro": "Choisissez l’emplacement, puis l’un des trois formats si la technique en demande un (la sérigraphie et la broderie n’en ont pas). Le format conseillé pour l’emplacement est signalé.",
                "title": "Où placer le marquage, et à quel format ?",
                "zone": "Emplacement",
                "zone_names": {
                  "left_sleeve": "Épaule / manche gauche",
                  "right_sleeve": "Épaule / manche droite"
                }
              },
              "previous": "Précédent",
              "steps": {
                "artwork": "Logo",
                "placement": "Emplacement",
                "technique": "Technique",
                "textiles": "Textiles"
              },
              "steps_label": "Étapes du marquage",
              "technique": {
                "colours": "Nombre de couleurs du logo",
                "colours_hint": "Chaque couleur demande un écran : c’est ce qui fixe le prix. Sur textile de couleur, la sous-couche est ajoutée d’office.",
                "help": {
                  "dtf": {
                    "description": "Transfert imprimé puis pressé à chaud. Toutes les couleurs, dès une pièce.",
                    "tips": [
                      "Idéal petites séries, prénoms et numéros",
                      "Accepte photos et dégradés"
                    ]
                  },
                  "dtg": {
                    "description": "Impression numérique directe sur le textile, comme une imprimante.",
                    "tips": [
                      "Idéal pour visuels photo sur coton",
                      "Meilleur rendu sur textile clair"
                    ]
                  },
                  "embroidery": {
                    "description": "Logo cousu au fil dans le textile. Rendu haut de gamme et durable.",
                    "tips": [
                      "Idéal côté cœur, casquettes, polos, sweats",
                      "Petits formats, pas de dégradés"
                    ]
                  },
                  "other": {
                    "description": "Personnalisation PAP, transfert ou autre technique.",
                    "tips": [
                      "Précisez la technique ci-dessous"
                    ]
                  },
                  "screen_print": {
                    "description": "Encre déposée à travers un écran. Couleurs vives et très résistantes.",
                    "tips": [
                      "Idéal pour les séries et les logos en aplats",
                      "Prix selon le nombre de couleurs"
                    ]
                  }
                },
                "intro": "Chaque technique a ses points forts. En cas de doute, la description vous aide à choisir.",
                "other": "Autre technique",
                "required": "obligatoire",
                "title": "Quelle technique de marquage ?"
              },
              "textiles": {
                "all": "Tous les textiles, toutes les tailles",
                "all_hint": "Chaque taille jusqu’à sa quantité sur le devis",
                "intro": "Tout est coché par défaut. Ajustez les quantités taille par taille si seule une partie des pièces est marquée (ex. 10 des 20 M).",
                "item_checkbox": "Marquer : %{textile}",
                "size_quantity": "%{textile} %{size}, sur %{max}",
                "title": "Sur quels textiles ?"
              },
              "title_edit": "Modifier le marquage",
              "title_new": "Ajouter un marquage"
            }
          },
          "new": {
            "title": "Nouveau devis"
          },
          "pdf_viewer": {
            "new_tab": "Nouvel onglet",
            "new_tab_title": "Ouvrir l’aperçu PDF dans un nouvel onglet",
            "open": "Aperçu PDF",
            "title": "Aperçu du devis"
          },
          "personalizations": {
            "all_markings": "Tous les marquages",
            "all_textiles": "Tous les textiles",
            "count": {
              "one": "%{count} pièce",
              "other": "%{count} pièces"
            },
            "empty": "Aucune pièce ne correspond à ces filtres.",
            "errors_only": "Erreurs uniquement",
            "export": "Exporter CSV",
            "filter": "Filtrer",
            "filters": "Filtres",
            "go_to_errors": "Accéder directement aux erreurs",
            "import": "Importer CSV",
            "imported": {
              "one": "%{count} ligne importée",
              "other": "%{count} lignes importées"
            },
            "intro": "Six pièces sont affichées par page. Les erreurs restent filtrables et bloquent l'envoi du devis.",
            "marking": "Marquage",
            "mobile_notice": "Consultation mobile : l'import, les filtres avancés et la modification des personnalisations sont disponibles sur tablette ou ordinateur.",
            "page": "Page %{page}",
            "saved": "Personnalisations enregistrées",
            "textile_size": "Textile et taille",
            "title": "Personnalisation variable"
          },
          "proof_approval": {
            "locked": "Le BAT est déjà parti chez le client ; la case ne peut plus changer.",
            "no_proof": "Ce devis n’a pas de BAT."
          },
          "revisions": {
            "accepted": "V%{number} acceptée",
            "after": "Maintenant",
            "before": "Avant",
            "changes": "Changements V%{before}/V%{after}",
            "draft": "Brouillon V%{number}",
            "families": {
              "approvals": "Approbations",
              "documents": "Documents",
              "general": "Informations générales",
              "markings": "Marquages",
              "textiles": "Textiles",
              "totals": "Totaux"
            },
            "no_changes": "Aucun changement depuis la dernière version envoyée.",
            "rejected": "V%{number} refusée",
            "sent": "V%{number} envoyée",
            "title": "Révisions"
          },
          "send_dialog": {
            "blocked": "Envoi bloqué tant que ces points ne sont pas corrigés",
            "confirm": "Envoyer le devis",
            "current_total": "Montant TTC envoyé",
            "draft_reference": "recevra sa référence au premier envoi",
            "frozen_revision": "Ce renvoi utilisera la révision déjà envoyée, sans nouveau calcul tarifaire.",
            "intro": "Le devis %{reference} va être envoyé par email.",
            "no_email": "Aucun email n'est renseigné pour ce client — saisissez-en un pour envoyer.",
            "pricing_updated": "Les tarifs ont changé depuis la dernière sauvegarde ; ce montant sera appliqué à l'envoi.",
            "recipients": "Destinataires",
            "recipients_hint": "Cochés d'office : les contacts « devis par défaut », à défaut le contact principal. Chaque adresse reçoit son propre email.",
            "saved_total": "Montant enregistré : %{amount}.",
            "title": "Envoyer le devis au client"
          },
          "show": {
            "acceptance_comment": "Commentaire du client",
            "actions": {
              "lose": "Marquer comme perdu",
              "revert": "Annuler la dernière action",
              "send_to_pao": "Passer en affaire",
              "start_production": "Démarrer la production",
              "validate_estimate": "Affaire gagnée",
              "validate_production": "Valider la production"
            },
            "artwork_missing": "Fichier non reçu",
            "artwork_pending_from_customer": "Visuel à fournir par le client",
            "color_swatch_label": "Coloris : %{colors}",
            "confirm": {
              "revert": {
                "text": "Le devis revient à son statut précédent.",
                "title": "Annuler cette action ?"
              },
              "send_to_pao": {
                "text": "L’affaire part en conception pour préparer le BAT.",
                "title": "Passer ce devis en affaire ?"
              },
              "start_production": {
                "text": "Le BAT est approuvé ; l’atelier peut lancer la production.",
                "title": "Démarrer la production de cette affaire ?"
              },
              "validate_estimate": {
                "text": "Le devis devient une affaire validée.",
                "title": "Valider ce devis ?"
              },
              "validate_production": {
                "text": "L’affaire est marquée comme terminée.",
                "title": "Valider la production de ce devis ?"
              }
            },
            "confirm_duplicate": "Dupliquer ce devis ?",
            "discount": "remise %{value}",
            "documents": "Documents joints",
            "edit": "Modifier",
            "expired": "validité dépassée",
            "global_discount": "Remise globale",
            "global_discount_percentage": "Remise globale (%{value} %)",
            "loading": "Chargement…",
            "lost_at": "Perdu le",
            "margin": "Marge",
            "markings": "Marquages",
            "new_version": "Nouvelle version",
            "no_items": "Aucun textile",
            "payment_delay_days": {
              "one": "%{count} jour",
              "other": "%{count} jours"
            },
            "payment_method": "Paiement",
            "payment_terms": "Conditions de paiement",
            "production_validated_at": "Production validée le",
            "proof": {
              "approval": {
                "approve": "Approuver et envoyer",
                "approve_confirm": "Envoyer ce BAT au client (%{email}) ?",
                "approved": "Approuvé et envoyé par %{name} le %{date}",
                "approver": "Approbateur prévu",
                "files": "Fichiers du BAT",
                "information": "Pour information",
                "internal_note": "Note de la PAO",
                "pending": "À approuver avant l’envoi au client",
                "return": "Renvoyer à la PAO",
                "return_dialog": {
                  "comment": "Ce qu’il faut reprendre",
                  "confirm": "Renvoyer à la PAO",
                  "intro": "Le BAT v%{version} redevient modifiable, sans nouvelle version : le client n’a rien reçu.",
                  "title": "Renvoyer le BAT à la PAO"
                },
                "returned": "Renvoyé à la PAO par %{name} le %{date}",
                "submitted": "Soumis par %{name} le %{date}",
                "waiting_for": "En attente de l’approbation de %{name}."
              },
              "none": "Aucun BAT préparé pour l’instant.",
              "open": "Voir le BAT",
              "prepare": "Préparer le BAT",
              "requirement": {
                "hint": "La PAO soumet le BAT au commercial, qui l’approuve et l’envoie au client.",
                "label": "BAT soumis à mon approbation avant envoi",
                "locked_on": "Le BAT de ce devis est soumis à l’approbation du commercial.",
                "save": "Enregistrer"
              },
              "responded_at": "Réponse du client le %{date}",
              "sent_at": "Envoyé le %{date}",
              "statuses": {
                "approved": "approuvé par le client",
                "draft": "en préparation",
                "pending_approval": "en attente de votre approbation",
                "revision_requested": "modifications demandées",
                "sent": "envoyé au client"
              },
              "title": "BAT"
            },
            "resend": "Renvoyer",
            "send": "Envoyer",
            "sent_at": "Envoyé le",
            "sent_count": {
              "one": "%{count} envoi",
              "other": "%{count} envois"
            },
            "sent_to_pao_at": "Passé en affaire le",
            "subtotal": "Sous-total HT",
            "supply": "Approvisionnement",
            "textile_image_missing": "Aucune image textile",
            "textiles": "Textiles",
            "tracking": {
              "description": "Scannez ce code pour ouvrir la fiche du dossier. Une connexion ERP est nécessaire.",
              "download": "Télécharger le QR",
              "image_alt": "QR de suivi du dossier %{reference}",
              "title": "Suivi interne du dossier"
            },
            "untyped_marking": "Marquage",
            "validated_at": "Validé le"
          },
          "textiles": {
            "block": {
              "add_catalogue": "Textile du catalogue",
              "add_customer": "Fourni par le client",
              "add_section": "Ajouter une section",
              "empty_text": "Ajoutez un textile du catalogue, avec le stock et le tarif du client, ou un textile apporté par le client.",
              "empty_title": "Aucun textile pour l’instant"
            },
            "card": {
              "add_marking": "Ajouter un marquage à : %{name}",
              "add_marking_short": "+ Marquage",
              "already_marked": "Déjà marqué",
              "copy_markings": "Reprendre les marquages d’un autre textile : %{name}",
              "copy_placeholder": "Mêmes marquages que…",
              "customer_price": "Tarif client",
              "customer_supplied": "Fourni par le client",
              "delete": "Supprimer la ligne : %{name}",
              "delete_confirm": {
                "accept": "Supprimer",
                "text": "Le textile et ses quantités sont retirés du devis, ainsi que leurs affectations aux marquages.",
                "title": "Supprimer cette ligne ?"
              },
              "duplicate": "Dupliquer la ligne : %{name}",
              "edit": "Modifier",
              "edit_label": "Modifier : %{name}",
              "more_actions": "Actions secondaires : %{name}",
              "no_colour": "Couleur non précisée",
              "no_textile_price": "pas de prix textile",
              "plan": "Plan de marquage",
              "replace": "Remplacer le textile",
              "unit_part_html": "× %{price} HT"
            },
            "picker": {
              "add": "Ajouter au devis",
              "all_categories": "Toutes les catégories",
              "all_suppliers": "Tous les fournisseurs",
              "already_marked": "Produit déjà marqué, sans marquage à ajouter",
              "cancel": "Annuler",
              "category": "Catégorie",
              "color": "Couleur",
              "color_placeholder": "Ex. Blanc, Noir, Gris chiné…",
              "comment": "Marque / commentaire",
              "comment_placeholder": "Ex. Gildan 64000, tailles mélangées…",
              "customer_notice": "Le client apporte ses propres textiles. La ligne apparaît comme un textile standard et peut recevoir des marquages.",
              "garment_type": "Type de vêtement",
              "grid_applied": "%{grid} appliqué",
              "origin": "Origine du textile",
              "placeholder_text": "Ses coloris, tailles, stocks et le prix pour ce client s’afficheront ici.",
              "placeholder_title": "Choisissez un produit",
              "results": "Produits",
              "search_label": "Rechercher un produit",
              "search_placeholder": "Référence, nom, marque…",
              "size_quantity": "Taille %{size}",
              "sizes": "Quantités par taille",
              "supplier": "Fournisseur",
              "tabs": {
                "catalogue": "Catalogue",
                "customer": "Fourni par le client",
                "manual": "Saisie manuelle"
              },
              "title": "Ajouter un textile"
            }
          },
          "units": {
            "kg": "Kg",
            "lot": "Lot",
            "m": "Mètre",
            "pce": "Pièce"
          },
          "vat_rates": {
            "vat_10": "10%",
            "vat_20": "20%",
            "vat_5_5": "5,5%"
          }
        },
        "js": {
          "autosave": {
            "close_discard_confirm": "Fermer sans enregistrer ?\n\nOK = Fermer sans enregistrer\nAnnuler = Rester sur le devis",
            "close_save_confirm": "Attention — ce devis comporte des modifications non sauvegardées. Souhaitez-vous enregistrer avant de fermer ?\n\nOK = Enregistrer et fermer\nAnnuler = Voir les autres options",
            "conflict": "Version du devis obsolète",
            "conflict_reload_confirm": "Recharger la version la plus récente ? Vos modifications locales non enregistrées seront perdues.",
            "leave_confirm": "Quitter cette page et perdre les modifications non enregistrées ?",
            "modified": "Modifié — à enregistrer",
            "reload": "Recharger",
            "remove_file": "Retirer %{filename}",
            "save_blocked": {
              "one": "Enregistrement impossible : %{count} point à corriger",
              "other": "Enregistrement impossible : %{count} points à corriger"
            },
            "save_blocked_others": {
              "one": "Voir l’autre point",
              "other": "Voir les %{count} autres points"
            },
            "save_error": "Erreur de sauvegarde",
            "saved": "Enregistré",
            "saved_at": "Enregistré à %{timestamp}",
            "saving": "Enregistrement...",
            "structural_queued": "Enregistrement... action en attente",
            "validation_error": "Vérifiez le champ signalé avant d’enregistrer."
          },
          "dropzone": {
            "bytes": "%{size} o",
            "error": "Erreur",
            "file_too_large": "Fichier trop volumineux (maximum %{size})",
            "kilobytes": "%{size} Ko",
            "megabytes": "%{size} Mo",
            "remove_file": "Retirer %{filename}",
            "unsupported_type": "Format de fichier non autorisé",
            "upload_complete": "%{total} fichier(s) — envoi terminé",
            "upload_errors": "%{done}/%{total} — %{errors} erreur(s)",
            "upload_failed": "Échec de l'envoi",
            "uploading": "%{done}/%{total} — envoi en cours…"
          },
          "estimate_editor": {
            "allocation_item_label": "Marquer : %{textile}",
            "allocation_label": "%{textile} %{size}, sur %{max}",
            "new_line": "Nouvelle ligne",
            "over_stock": {
              "one": "%{count} taille au-delà du stock · délai à confirmer",
              "other": "%{count} tailles au-delà du stock · délai à confirmer"
            },
            "pieces": {
              "one": "%{count} pce",
              "other": "%{count} pcs"
            },
            "pricing_unavailable": "Tarif indisponible",
            "replace_allocated_accept": "Remplacer",
            "replace_allocated_confirm": "Il est utilisé par des marquages. Les allocations et personnalisations des tailles identiques sont conservées ; celles des tailles retirées sont supprimées.",
            "replace_allocated_title": "Remplacer ce textile ?",
            "reprice_required": "À recalculer",
            "size_quantity": "Quantité textile, taille %{size}"
          },
          "inline_edit": {
            "save_error": "Erreur de sauvegarde — cliquez pour réessayer"
          },
          "item_pricing": {
            "margin_rate_invalid": "Coefficient textile invalide : saisissez au moins 1.",
            "network_error": "Erreur réseau",
            "no_variant": "Aucune variante sélectionnée",
            "refresh_failed": "Erreur lors de la mise à jour",
            "refreshed": "Prix mis à jour",
            "refreshing": "Mise à jour…",
            "supplier_price_unknown": "Tarif fournisseur inconnu — à rafraîchir ou à saisir."
          },
          "marking_form": {
            "above_maximum": "Sur devis : quantité au-delà du dernier palier (%{count}).",
            "ambiguous_grid": "Plusieurs grilles actives couvrent cette combinaison : faites corriger les tarifs ERP.",
            "below_minimum": "Sur devis : quantité minimale %{count} pour cette technique.",
            "compatibility": {
              "custom_zone": "Zone personnalisée ; approbation requise.",
              "customer_supplied": "Textile fourni par le client ; approbation requise.",
              "dimensions_exceeded": "Les dimensions dépassent la capacité déclarée.",
              "inherited": "Règle produit héritée pour ce coloris",
              "max_dimensions": "Maximum : %{width} × %{height} mm",
              "select_definition": "Sélectionnez une technique et une zone.",
              "status": {
                "allowed": "Autorisé",
                "approval_required": "Approbation requise",
                "incompatible": "Incompatible",
                "unspecified": "Non renseigné"
              },
              "unspecified": "Aucune règle produit × zone × technique n’est renseignée."
            },
            "invalid_price": "Prix négatif dans la grille ERP : faites corriger ce tarif.",
            "missing_dimensions": "Aucun tarif pour cette combinaison de dimensions.",
            "missing_tier": "Aucun palier tarifaire ne couvre cette quantité.",
            "no_grid": "Aucune grille tarifaire pour cette technique et ce type de client.",
            "pieces_of": "%{marked} / %{total} pcs",
            "quote_required": "Sur devis.",
            "recalculate_required": "À recalculer",
            "unavailable": "indisponible dans la grille actuelle"
          },
          "marking_plan": {
            "all": "Tout",
            "all_label": "%{marking} : toutes les pièces",
            "cell_label": "%{marking}, taille %{size}, sur %{count}",
            "copied": {
              "one": "%{count} marquage repris de %{textile} sur toutes les pièces : ajustez dans le plan si besoin.",
              "other": "%{count} marquages repris de %{textile} sur toutes les pièces : ajustez dans le plan si besoin."
            },
            "copy_from": "Reprendre les marquages de",
            "copy_placeholder": "Choisir un textile…",
            "hide": "Masquer le plan de marquage",
            "none": "Aucun",
            "none_label": "%{marking} : aucune pièce",
            "nothing_to_copy": "Aucun marquage compatible à reprendre.",
            "pieces": {
              "one": "%{count} pce",
              "other": "%{count} pcs"
            },
            "result": "Ce que ça donne",
            "result_hint": "Sur une même taille, les pièces se cumulent : les 10 à l’épaule font partie des 20 au dos.",
            "show": "Plan de marquage",
            "size": "Taille",
            "table_label": "Plan de marquage : %{textile}",
            "unmarked": "sans marquage",
            "untyped": "Marquage"
          },
          "marking_wizard": {
            "add": "Ajouter le marquage",
            "artwork_pending": "À fournir par le client",
            "artwork_text": "Texte à marquer",
            "artwork_to_provide": "À fournir",
            "colours": {
              "one": "%{count} couleur",
              "other": "%{count} couleurs"
            },
            "dimensions": "%{width} × %{height} mm",
            "files": {
              "one": "%{count} fichier",
              "other": "%{count} fichiers"
            },
            "format_advised": "Pour « %{zone} », le format %{format} est conseillé.",
            "impossible_everywhere": "Impossible sur les textiles du devis",
            "impossible_on": "Impossible sur : %{textiles}",
            "marked_pieces": {
              "one": "%{count} pce marquée",
              "other": "%{count} pcs marquées"
            },
            "missing": "Il manque : %{what}.",
            "missing_artwork": "le texte ou le logo (ou cochez « Visuel à fournir par le client »)",
            "missing_colours": "le nombre de couleurs",
            "missing_format": "le format",
            "missing_technique": "la technique",
            "missing_textiles": "au moins un textile",
            "missing_zone": "l’emplacement",
            "next": "Suivant",
            "pieces": {
              "one": "%{count} pce",
              "other": "%{count} pcs"
            },
            "size_kb": "%{size} Ko",
            "size_mb": "%{size} Mo",
            "step_ok": "Étape %{step} sur %{total}",
            "step_ok_done": "c’est bon",
            "text_and_files": {
              "one": "Texte et 1 fichier",
              "other": "Texte et %{count} fichiers"
            },
            "to_choose": "À choisir",
            "update": "Mettre à jour le marquage",
            "zone_first": "Choisissez d’abord un emplacement."
          },
          "textile_picker": {
            "add": "Ajouter au devis",
            "add_title": "Ajouter un textile",
            "article": "Article",
            "catalogue_summary": "%{pieces} · %{colours} · %{unit} HT / pce · %{total} HT",
            "choose_product": "Choisissez un produit dans la liste.",
            "client_price": "%{price} € HT",
            "colours": {
              "one": "%{count} coloris",
              "other": "%{count} coloris"
            },
            "colourway": "Coloris",
            "compatibility": {
              "allowed": "%{count} autorisée(s)",
              "approval_required": "%{count} avec approbation",
              "incompatible": "%{count} incompatible(s)",
              "unspecified": "%{count} non renseignée(s)"
            },
            "compatibility_status": {
              "allowed": "Autorisé",
              "approval_required": "Approbation requise",
              "incompatible": "Incompatible",
              "unspecified": "Non renseigné"
            },
            "compatibility_title": "Marquages possibles sur ce produit",
            "customer_summary": "%{pieces} fournies par le client · pas de prix textile",
            "fill_quantities": "Renseignez au moins une quantité.",
            "inherited_rule": "Règle produit héritée",
            "legend_over": "au-delà du stock",
            "legend_unmapped": "taille non reliée",
            "load_error": "Impossible de charger les données. Réessayez.",
            "loading": "Chargement du produit…",
            "manual_failed": "L’article n’a pas pu être enregistré.",
            "manual_hint": "Enregistrez l’article pour choisir les quantités.",
            "manual_no_sizes": "Sélectionnez au moins une taille.",
            "manual_quantity_for": "Quantité pour %{article}",
            "manual_saving": "Enregistrement dans le catalogue…",
            "manual_stock": "Stock à confirmer auprès du fournisseur",
            "matrix_scroll_region": "Coloris et tailles du produit. Faites défiler horizontalement pour voir toutes les tailles.",
            "max_dimensions": "Max. %{width} × %{height} mm",
            "missing": "Il manque : %{fields}.",
            "missing_garment_type": "le type de vêtement",
            "missing_quantity": "au moins une quantité",
            "no_filled_colour": "Aucun coloris saisi.",
            "no_filtered_results": "Aucun produit pour ces filtres.",
            "no_results": "Aucun produit pour « %{query} ». Essayez la référence fournisseur, un mot du nom ou la marque.",
            "no_variants": "Aucune variante disponible pour ce produit.",
            "object_summary": "%{pieces} · %{unit} HT / pce · %{total} HT",
            "only_filled": "Seulement les coloris saisis",
            "ordered_group": "Déjà commandés par ce client",
            "out_of_stock": "rupture",
            "over_stock_item": "%{colour} %{size} (%{quantity} pour %{stock} en stock)",
            "over_stock_text": "Vous pouvez l’ajouter quand même : le délai de réapprovisionnement sera à confirmer au client.",
            "over_stock_title": {
              "one": "%{count} taille au-delà du stock :",
              "other": "%{count} tailles au-delà du stock :"
            },
            "per_piece": "par pièce · prix client",
            "pieces": {
              "one": "%{count} pce",
              "other": "%{count} pcs"
            },
            "price_unavailable": "Tarif indisponible",
            "price_varies": "Prix selon la taille",
            "quantity_for": "%{colour}, taille %{size}, stock %{stock}",
            "replace": "Remplacer",
            "replace_title": "Remplacer le textile",
            "results_group": {
              "one": "%{count} résultat",
              "other": "%{count} résultats"
            },
            "select_customer_first": "Choisir un client",
            "select_customer_hint": "Sélectionnez d’abord un client : les tarifs dépendent de sa marge textile.",
            "select_one_colourway": "Sélectionnez un seul coloris et tarif pour remplacer cette ligne.",
            "size_ambiguous": "Taille ambiguë",
            "size_ambiguous_hint": "Taille « %{size} » reliée à plusieurs tailles du catalogue : à confirmer avant de la commander.",
            "size_unmapped": "à relier",
            "size_unmapped_hint": "Taille « %{size} » non reliée au catalogue du fournisseur : elle ne peut pas être commandée.",
            "stock": "stock %{count}",
            "stock_as_of": "Stock au %{date}",
            "type_more": "Tapez au moins deux caractères ou choisissez un filtre.",
            "unmapped_all_text": "Ses tailles ne sont pas encore reliées au catalogue du fournisseur. Choisissez un autre produit.",
            "unmapped_all_title": "Ce produit ne peut pas être commandé pour l’instant.",
            "unmapped_some": "Les tailles %{sizes} ne sont pas encore reliées au fournisseur et ne peuvent pas être commandées.",
            "variants": {
              "one": "%{count} variante",
              "other": "%{count} variantes"
            }
          }
        },
        "manual_articles": {
          "below_cost": "doit être au moins égal au prix d’achat",
          "colors_hint": "Une couleur par ligne",
          "create_and_select": "Enregistrer et choisir les quantités",
          "duplicate": "Cet article existe déjà pour ce fournisseur.",
          "edit": "Modifier l’article manuel",
          "fields": {
            "colors": "Couleurs *",
            "details": "Caractéristiques / description libre",
            "enabled": "Disponible dans le catalogue",
            "kind": "Type d’article",
            "name": "Dénomination *",
            "purchase_price": "Prix d’achat HT (€) *",
            "reference": "Code article *",
            "sale_price": "Prix de vente HT (€) *",
            "sizes": "Tailles canoniques *",
            "supplier": "Fournisseur *"
          },
          "kinds": {
            "object": "Objet",
            "textile": "Textile"
          },
          "new": "Nouvel article manuel",
          "notice": "L’article sera enregistré dans le catalogue et réutilisable dans vos prochains devis.",
          "reactivate_existing": "Ouvrir la fiche de l’article désactivé pour le réactiver",
          "saved": "Article manuel enregistré dans le catalogue.",
          "stock_unknown": "Stock à confirmer",
          "unit": "Quantité",
          "use_existing": "Choisir l’article déjà présent dans le catalogue"
        },
        "marking_catalogue": {
          "active": "Actif",
          "code": "Code stable",
          "intro": "Les techniques et zones sont globales et partagées avec Production. Désactivez une entrée pour la retirer des nouveaux devis sans casser l'historique.",
          "name": "Libellé",
          "position": "Ordre",
          "techniques": "Techniques",
          "title": "Référentiel de marquage",
          "zones": "Zones"
        },
        "pdf": {
          "already_marked": "Produit déjà marqué",
          "artwork_pending_from_customer": "Visuel à fournir par le client",
          "artwork_text": "Texte à marquer : %{text}",
          "banner": "DEVIS",
          "contact": "Contact : %{name}",
          "customer_label": "CLIENT",
          "customer_number": "Client n°",
          "date": "Date",
          "dimension_2": "Tissu",
          "dimension_colors_count": "Nombre de couleurs",
          "dimension_format": "Format",
          "dimension_stitches_count": "Nombre de points",
          "dimension_type": "Type",
          "draft_reference": "Brouillon",
          "erp_fee": "Frais de marquage",
          "estimate_number": "Devis n°",
          "global_discount": "Remise globale",
          "global_discount_with_pct": "Remise globale (%{percentage}%)",
          "header_description": "Désignation",
          "header_quantity": "Quantité",
          "header_ref": "Référence",
          "header_total": "Montant HT",
          "header_unit_price": "PU HT",
          "issuer_address": "13 ZA de Bel Air\n29700 PLUGUFFAN\nFrance\nsofidial@sofidial.fr",
          "issuer_name": "SOFIDIAL SAS",
          "legal": "SOFIDIAL SAS - 13 ZA de Bel Air - 29700 PLUGUFFAN · RCS QUIMPER 792456618 - SAS au capital de 60 000 euros · N° TVA FR67792456618 - CODE NAF : 1330Z",
          "line_discount": "Remise : %{discount}",
          "marking": "Marquage",
          "marking_dimensions": "Dimensions",
          "marking_files": "Fichier(s)",
          "marking_textiles": "Textile(s) associé(s)",
          "markings_total": "Total marquages HT",
          "no_lines": "Aucun article.",
          "notes": "Notes",
          "payment_delay": "Délai de paiement",
          "payment_delay_value": "%{days} jours",
          "payment_method": "Mode de paiement",
          "payment_terms": "Conditions de paiement",
          "sales_rep_line": "Commercial : %{name}",
          "sign_date": "Date",
          "sign_function": "Fonction",
          "sign_name": "Nom",
          "sign_stamp": "Signature et cachet",
          "sign_title": "BON POUR ACCORD",
          "sizes": "Tailles : %{sizes}",
          "subject": "Objet",
          "subtotal": "Total HT",
          "textiles_total": "Total textiles HT",
          "total": "Total TTC",
          "underbase": "+ sous-couche",
          "validity": "Validité",
          "vat": "TVA",
          "version": "Version",
          "watermark": "BROUILLON"
        },
        "printing_price_grids": {
          "history": {
            "changed_from": "de",
            "changed_to": "à",
            "columns": {
              "change": "Modification",
              "date": "Date",
              "entry": "Tarif",
              "user": "Utilisateur"
            },
            "no_changes": "Aucune modification enregistrée",
            "on_quote": "Devis",
            "system_user": "Système",
            "title": "Historique des modifications"
          },
          "index": {
            "active": "Active",
            "direct": "Direct",
            "entries_count": {
              "one": "%{count} entrée",
              "other": "%{count} entrées"
            },
            "inactive": "Inactive",
            "no_grids": "Aucune grille tarifaire",
            "reseller": "Revendeur",
            "seed_hint": "Exécutez : rake printing_prices:seed",
            "standalone_extra_columns": {
              "code": "Code",
              "customer_type": "Type de client",
              "name": "Nom",
              "price": "Tarif",
              "price_type": "Mode",
              "technique": "Technique"
            },
            "standalone_extras": "Suppléments sans grille active",
            "standalone_extras_hint": "Ces frais restent proposés dans les devis selon la technique et le type de client.",
            "techniques": {
              "dtf": "DTF / Numérique",
              "dtg": "Impression numérique",
              "embroidery": "Broderie",
              "engraving": "Gravure",
              "laser": "Laser",
              "misc": "Divers",
              "personalisation_pap": "Personnalisation PAP",
              "personalisation_transfert": "Personnalisation Transfert",
              "screen_print": "Sérigraphie",
              "sublimation": "Sublimation",
              "transfer": "Transfert"
            },
            "title": "Grilles tarifaires"
          },
          "show": {
            "active": "Active",
            "add_extra": "Ajouter un supplément",
            "add_row": "Ajouter une ligne",
            "choose_dimension": "Choisir une dimension",
            "confirm_delete_extra": "Supprimer ce supplément ?",
            "confirm_delete_row": "Supprimer cette ligne de la grille ?",
            "delete_extra": "Supprimer ce supplément",
            "delete_row": "Supprimer cette ligne",
            "dimension_scope": "Dimension",
            "direct": "Direct",
            "entries_count": {
              "one": "%{count} entrée",
              "other": "%{count} entrées"
            },
            "extras": "Suppléments",
            "extras_columns": {
              "code": "Code",
              "name": "Nom",
              "price": "Prix",
              "type": "Type"
            },
            "fixed": "Forfaitaire",
            "inactive": "Inactive",
            "invalid_quantity": "Quantité invalide : saisissez un nombre entier positif ou zéro.",
            "no_extras": "Aucun supplément",
            "on_quote": "Sur devis",
            "per_piece": "Par pièce",
            "percentage": "Pourcentage",
            "price_will_reset": "Le prix sera réinitialisé",
            "prices": "Tarifs",
            "quantity_max": "Qté max",
            "quantity_min": "Qté min",
            "reseller": "Revendeur",
            "save": "Enregistrer",
            "standard_dimension": "Standard",
            "unsaved_changes": "Modifications non enregistrées"
          }
        },
        "products": {
          "capabilities": {
            "cell_height": "Hauteur maximale (%{cell})",
            "cell_note": "Note opérateur (%{cell})",
            "cell_status": "Statut (%{cell})",
            "cell_width": "Largeur maximale (%{cell})",
            "colorway_scope_help": "Hérite de la règle produit, sauf exception explicite par cellule",
            "complete_override": "Remplace entièrement la règle produit",
            "dimensions": "%{width} × %{height} mm",
            "height": "Hauteur max",
            "inherit": "Hériter — %{status}",
            "inherited": "Hérité de la règle produit",
            "intro": "La règle produit s'applique à tous les coloris. Ouvrez un coloris pour définir une exception complète sur une cellule technique × zone.",
            "manage_catalogue": "Gérer les techniques et zones",
            "matrix_region": "Matrice de compatibilité, %{label}. Faites défiler horizontalement pour voir toutes les zones.",
            "open_matrix": "Ouvrir la matrice",
            "operator_note": "Note opérateur",
            "product_rule": "Règle produit",
            "size_aliases": {
              "ambiguous": "Correspondance ambiguë — confirmation manuelle requise",
              "confirm": "Confirmer les correspondances",
              "hint": "Ces correspondances s’appliquent à tous les produits %{supplier}. Une taille non mappée bloque son ajout au devis.",
              "summary": "%{mapped}/%{total} tailles mappées",
              "title": "Correspondance des tailles fournisseur",
              "unmapped": "Non mappée"
            },
            "statuses": {
              "allowed": "Autorisé",
              "approval_required": "Approbation requise",
              "incompatible": "Incompatible",
              "unspecified": "Non renseigné"
            },
            "summary": {
              "one": "1 cellule renseignée",
              "other": "%{count} cellules renseignées"
            },
            "technique": "Technique",
            "title": "Compatibilités de marquage",
            "width": "Largeur max"
          },
          "colorway_unassigned": "Coloris non renseigné",
          "edit": {
            "title": "Modifier le produit"
          },
          "form": {
            "brand": "Marque",
            "category": "Catégorie",
            "description": "Description",
            "enabled": "Produit activé",
            "grammage": "Grammage (g/m²)",
            "images": "Images",
            "information": "Informations",
            "mode": "Mode",
            "name": "Nom",
            "reference": "Référence",
            "status": "Statut",
            "supplier": "Fournisseur",
            "tags": "Tags",
            "tags_placeholder": "Séparez vos tags par une virgule",
            "vat_rate": "TVA",
            "weight": "Poids (g)"
          },
          "index": {
            "add_to_estimate": "Ajouter au devis",
            "all_categories": "Toutes les catégories",
            "all_suppliers": "Tous les fournisseurs",
            "columns": {
              "actions": "Actions",
              "category": "Catégorie",
              "name": "Nom",
              "reference": "Référence",
              "supplier": "Fournisseur"
            },
            "footer": {
              "products": {
                "one": "1 produit",
                "other": "%{count} produits",
                "zero": "Aucun produit"
              }
            },
            "no_products": "Aucun produit trouvé",
            "reset": "Réinitialiser",
            "search_placeholder": "Rechercher un produit...",
            "title": "Produits"
          },
          "show": {
            "edit": "Modifier",
            "fields": {
              "brand": "Marque",
              "category": "Catégorie",
              "grammage": "Grammage",
              "mode": "Mode",
              "reference": "Référence",
              "supplier": "Fournisseur",
              "variants_count": "Nb variantes",
              "vat_rate": "TVA",
              "weight": "Poids"
            },
            "no_description": "Aucune description",
            "no_stores": "Aucune boutique associée",
            "sections": {
              "description": "Description",
              "details": "Détails produit",
              "stores": "Boutiques",
              "variants": "Variantes"
            },
            "variants": {
              "name": "Nom",
              "no_variants": "Aucune variante",
              "price": "Prix",
              "reference": "Référence",
              "size": "Taille",
              "stock": "Stock",
              "supplier_price": "Prix fournisseur"
            }
          }
        },
        "suppliers": {
          "index": {
            "columns": {
              "actions": "Actions",
              "name": "Fournisseur",
              "products_count": "Nb produits"
            },
            "footer": {
              "suppliers": {
                "one": "1 fournisseur",
                "other": "%{count} fournisseurs",
                "zero": "Aucun fournisseur"
              }
            },
            "no_suppliers": "Aucun fournisseur trouvé",
            "reset": "Réinitialiser",
            "search_placeholder": "Rechercher un fournisseur...",
            "see_products": "Voir les produits",
            "title": "Fournisseurs"
          },
          "show": {
            "back": "Retour",
            "footer": {
              "products": {
                "one": "1 produit",
                "other": "%{count} produits",
                "zero": "Aucun produit"
              }
            },
            "no_products": "Aucun produit trouvé",
            "reset": "Réinitialiser"
          }
        }
      },
      "shared": {
        "header": {
          "account": "Mon compte : %{name}",
          "breadcrumb": "Fil d’Ariane",
          "open_navigation": "Ouvrir la navigation"
        },
        "pagination": {
          "info": "%{from}–%{to} sur %{count}",
          "label": "Pagination",
          "next": "Page suivante",
          "previous": "Page précédente"
        },
        "toast": {
          "close": "Fermer"
        }
      },
      "table": {
        "action_button_component": {
          "delete": "Supprimer",
          "download": "Télécharger",
          "edit": "Modifier",
          "settings": "Paramètres",
          "view": "Voir"
        },
        "scroll_region": "Tableau de données défilant horizontalement"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "must be accepted",
        "already_confirmed": "was already confirmed, please try signing in",
        "aspect_ratio_invalid": "has an invalid aspect ratio",
        "aspect_ratio_is_not": "must have an aspect ratio of %{aspect_ratio}",
        "aspect_ratio_not_landscape": "must be a landscape image",
        "aspect_ratio_not_portrait": "must be a portrait image",
        "aspect_ratio_not_square": "must be a square image",
        "blank": "can't be blank",
        "confirmation": "doesn't match %{attribute}",
        "confirmation_period_expired": "needs to be confirmed within %{period}, please request a new one",
        "content_type_invalid": "has an invalid content type",
        "dimension_height_equal_to": "height must be equal to %{length} pixel",
        "dimension_height_greater_than_or_equal_to": "height must be greater than or equal to %{length} pixel",
        "dimension_height_inclusion": "height is not included between %{min} and %{max} pixel",
        "dimension_height_less_than_or_equal_to": "height must be less than or equal to %{length} pixel",
        "dimension_max_inclusion": "must be less than or equal to %{width} x %{height} pixel",
        "dimension_min_inclusion": "must be greater than or equal to %{width} x %{height} pixel",
        "dimension_width_equal_to": "width must be equal to %{length} pixel",
        "dimension_width_greater_than_or_equal_to": "width must be greater than or equal to %{length} pixel",
        "dimension_width_inclusion": "width is not included between %{min} and %{max} pixel",
        "dimension_width_less_than_or_equal_to": "width must be less than or equal to %{length} pixel",
        "empty": "can't be empty",
        "equal_to": "must be equal to %{count}",
        "even": "must be even",
        "exclusion": "is reserved",
        "expired": "has expired, please request a new one",
        "file_size_not_between": "file size must be between %{min_size} and %{max_size} (current size is %{file_size})",
        "file_size_not_greater_than": "file size must be greater than %{min_size} (current size is %{file_size})",
        "file_size_not_greater_than_or_equal_to": "file size must be greater than or equal to %{min_size} (current size is %{file_size})",
        "file_size_not_less_than": "file size must be less than %{max_size} (current size is %{file_size})",
        "file_size_not_less_than_or_equal_to": "file size must be less than or equal to %{max_size} (current size is %{file_size})",
        "greater_than": "must be greater than %{count}",
        "greater_than_or_equal_to": "must be greater than or equal to %{count}",
        "image_metadata_missing": "is not a valid image",
        "image_not_processable": "is not a valid image",
        "in": "must be in %{count}",
        "inclusion": "is not included in the list",
        "invalid": "is invalid",
        "less_than": "must be less than %{count}",
        "less_than_or_equal_to": "must be less than or equal to %{count}",
        "limit_out_of_range": "total number is out of range",
        "model_invalid": "Validation failed: %{errors}",
        "not_a_number": "is not a number",
        "not_an_integer": "must be an integer",
        "not_found": "not found",
        "not_locked": "was not locked",
        "not_saved": {
          "one": "1 error prohibited this %{resource} from being saved:",
          "other": "%{count} errors prohibited this %{resource} from being saved:"
        },
        "odd": "must be odd",
        "other_than": "must be other than %{count}",
        "password_too_long": "is too long",
        "present": "must be blank",
        "required": "must exist",
        "spoofed_content_type": "has a content type that is not what it is declared through its content, filename and extension",
        "taken": "has already been taken",
        "too_long": {
          "one": "is too long (maximum is %{count} character)",
          "other": "is too long (maximum is %{count} characters)"
        },
        "too_short": {
          "one": "is too short (minimum is %{count} character)",
          "other": "is too short (minimum is %{count} characters)"
        },
        "total_file_size_not_between": "total file size must be between %{min_size} and %{max_size} (current size is %{total_file_size})",
        "total_file_size_not_greater_than": "total file size must be greater than %{min_size} (current size is %{total_file_size})",
        "total_file_size_not_greater_than_or_equal_to": "total file size must be greater than or equal to %{min_size} (current size is %{total_file_size})",
        "total_file_size_not_less_than": "total file size must be less than %{max_size} (current size is %{total_file_size})",
        "total_file_size_not_less_than_or_equal_to": "total file size must be less than or equal to %{max_size} (current size is %{total_file_size})",
        "wrong_length": {
          "one": "is the wrong length (should be %{count} character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      },
      "template": {
        "body": "There were problems with the following fields:",
        "header": {
          "one": "%{count} error prohibited this %{model} from being saved",
          "other": "%{count} errors prohibited this %{model} from being saved"
        }
      }
    },
    "export": "Exporter",
    "favorites": {
      "favorite": {
        "add_to_cart": "Ajouter au panier"
      },
      "index": {
        "title": "Mes favoris"
      }
    },
    "filter": "Filtrer :",
    "filters": {
      "periods": {
        "all_time": "Depuis toujours",
        "this_month": "Ce mois",
        "this_week": "Cette semaine",
        "this_year": "Cette année",
        "today": "Aujourd'hui"
      }
    },
    "flash": {
      "actions": {
        "create": {
          "notice": "%{resource_name} was successfully created."
        },
        "destroy": {
          "alert": "%{resource_name} could not be destroyed.",
          "notice": "%{resource_name} was successfully destroyed."
        },
        "update": {
          "notice": "%{resource_name} was successfully updated."
        }
      }
    },
    "hello": "Hello world",
    "helpers": {
      "select": {
        "prompt": "Please select"
      },
      "submit": {
        "address": {
          "create": "Créer l'%{model}",
          "update": "Modifier l'%{model}"
        },
        "create": "Create %{model}",
        "product": {
          "create": "Créer le %{model}",
          "update": "Modifier le %{model}"
        },
        "product_category": {
          "create": "Créer la %{model}",
          "update": "Modifier la %{model}"
        },
        "product_color": {
          "create": "Créer la %{model}",
          "update": "Modifier la %{model}"
        },
        "product_variant": {
          "create": "Créer la %{model}",
          "update": "Modifier la %{model}"
        },
        "promo_code": null,
        "store": {
          "create": "Créer la %{model}",
          "update": "Modifier la %{model}"
        },
        "submit": "Save %{model}",
        "update": "Update %{model}",
        "user": {
          "create": "Créer l'%{model}",
          "update": "Modifier l'%{model}"
        }
      }
    },
    "home": "Accueil",
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      },
      "transliterate": {
        "rule": {
          "À": "A",
          "Â": "A",
          "Æ": "Ae",
          "Ç": "C",
          "È": "E",
          "É": "E",
          "Ê": "E",
          "Ë": "E",
          "Î": "I",
          "Ï": "I",
          "Ô": "O",
          "Ù": "U",
          "Û": "U",
          "Ü": "U",
          "à": "a",
          "â": "a",
          "æ": "ae",
          "ç": "c",
          "è": "e",
          "é": "e",
          "ê": "e",
          "ë": "e",
          "î": "i",
          "ï": "i",
          "ô": "o",
          "ù": "u",
          "û": "u",
          "ü": "u",
          "ÿ": "y",
          "Œ": "Oe",
          "œ": "oe",
          "Ÿ": "Y"
        }
      }
    },
    "i18n_tasks": {
      "add_missing": {
        "added": {
          "one": "Added %{count} key",
          "other": "Added %{count} keys"
        }
      },
      "cmd": {
        "args": {
          "default_text": "Default: %{value}",
          "desc": {
            "all_locales": "Do not expect key patterns to start with a locale, instead apply them to all locales implicitly.",
            "config": "Override config location",
            "confirm": "Confirm automatically",
            "data_format": "Data format: %{valid_text}.",
            "keep_order": "Keep the order of the keys",
            "key_pattern": "Filter by key pattern (e.g. 'common.*')",
            "locale": "i18n_tasks.common.locale",
            "locale_to_translate_from": "Locale to translate from",
            "locales_filter": "Locale(s) to process. Special: base",
            "missing_types": "Filter by types: %{valid}",
            "nostdin": "Do not read from stdin",
            "out_format": "Output format: %{valid_text}",
            "pattern_router": "Use pattern router: keys moved per config data.write",
            "strict": "Avoid inferring dynamic key usages such as t(\"cats.#{cat}.name\"). Takes precedence over the config setting if set.",
            "translation_backend": "Translation backend [google, deepl, yandex, openai])",
            "value": "Value. Interpolates: %%{value}, %%{human_key}, %%{key}, %%{default}, %%{value_or_human_key}, %%{value_or_default_or_human_key}"
          }
        },
        "desc": {
          "add_missing": "add missing keys to locale data, optionally match a pattern",
          "check_consistent_interpolations": "verify that all translations use correct interpolation variables",
          "check_normalized": "verify that all translation data is normalized",
          "check_prism": "verify that Prism-scanner produces the same (or better) results as the default parser",
          "check_reserved_interpolations": "verify that all translations avoid reserved interpolation variables",
          "config": "display i18n-tasks configuration",
          "cp": "copy the keys in locale data that match the given pattern",
          "data": "show locale data",
          "data_merge": "merge locale data with trees",
          "data_remove": "remove keys present in tree from data",
          "data_write": "replace locale data with tree",
          "eq_base": "show translations equal to base value",
          "find": "show where keys are used in the code",
          "gem_path": "show path to the gem",
          "health": "is everything OK?",
          "irb": "start REPL session within i18n-tasks context",
          "missing": "show missing translations, optionally match a pattern",
          "mv": "rename/merge the keys in locale data that match the given pattern",
          "normalize": "normalize translation data: sort and move to the right files",
          "remove_unused": "remove unused keys",
          "rm": "remove the keys in locale data that match the given pattern",
          "translate_missing": "translate missing keys with Google Translate or DeepL Pro, optionally match a pattern",
          "tree_convert": "convert tree between formats",
          "tree_filter": "filter tree by key pattern",
          "tree_merge": "merge trees",
          "tree_mv_key": "rename/merge/remove the keys matching the given pattern",
          "tree_set_value": "set values of keys, optionally match a pattern",
          "tree_subtract": "tree A minus the keys in tree B",
          "tree_translate": "Google Translate a tree to root locales",
          "unused": "show unused translations"
        },
        "encourage": [
          "Good job!",
          "Well done!",
          "Perfect!"
        ],
        "enum_list_opt": {
          "invalid": "%{invalid} is not in: %{valid}."
        },
        "enum_opt": {
          "invalid": "%{invalid} is not one of: %{valid}."
        },
        "errors": {
          "invalid_backend": "Invalid backend: %{invalid}. Must be one of %{valid}.",
          "invalid_format": "invalid format: %{invalid}. valid: %{valid}.",
          "invalid_locale": "invalid locale: %{invalid}",
          "invalid_missing_type": {
            "one": "invalid type: %{invalid}. valid: %{valid}.",
            "other": "unknown types: %{invalid}. valid: %{valid}."
          },
          "pass_forest": "pass locale forest"
        }
      },
      "common": {
        "continue_q": "Continue?",
        "key": "Key",
        "locale": "Locale",
        "n_more": "%{count} more",
        "value": "Value"
      },
      "data_stats": {
        "text": "has %{key_count} keys across %{locale_count} locales. On average, values are %{value_chars_avg} characters long, keys have %{key_segments_avg} segments, a locale has %{per_locale_avg} keys.",
        "text_single_locale": "has %{key_count} keys in total. On average, values are %{value_chars_avg} characters long, keys have %{key_segments_avg} segments.",
        "title": "Forest (%{locales})"
      },
      "deepl_translate": {
        "errors": {
          "no_api_key": "Setup DeepL Pro API key via DEEPL_AUTH_KEY environment variable or translation.deepl_api_key in config/i18n-tasks.yml. Get the key at https://www.deepl.com/pro.",
          "no_results": "DeepL returned no results.",
          "specific_target_missing": "You must supply a specific variant for the given target language e.g. en-us instead of en."
        }
      },
      "google_translate": {
        "errors": {
          "no_api_key": "Set Google API key via GOOGLE_TRANSLATE_API_KEY environment variable or translation.google_translate_api_key in config/i18n-tasks.yml. Get the key at https://code.google.com/apis/console.",
          "no_results": "Google Translate returned no results. Make sure billing information is set at https://code.google.com/apis/console."
        }
      },
      "health": {
        "no_keys_detected": "No keys detected. Check data.read in config/i18n-tasks.yml."
      },
      "inconsistent_interpolations": {
        "none": "No inconsistent interpolations found."
      },
      "missing": {
        "details_title": "Value in other locales or source",
        "none": "No translations are missing."
      },
      "openai_translate": {
        "errors": {
          "no_api_key": "Set OpenAI API key via OPENAI_API_KEY environment variable or translation.openai_api_key in config/i18n-tasks.yml. Get the key at https://openai.com/.",
          "no_results": "OpenAI returned no results."
        }
      },
      "remove_unused": {
        "confirm": {
          "one": "%{count} translation will be removed from %{locales}.",
          "other": "%{count} translation will be removed from %{locales}."
        },
        "noop": "No unused keys to remove",
        "removed": "Removed %{count} keys"
      },
      "reserved_interpolations": {
        "details_title": "Reserved interpolation keys",
        "none": "No reserved interpolations found."
      },
      "translate_missing": {
        "translated": "Translated %{count} keys"
      },
      "unused": {
        "none": "Every translation is in use."
      },
      "usages": {
        "none": "No key usages found."
      },
      "watsonx_translate": {
        "errors": {
          "no_api_key": "Set watsonx API key via WATSONX_API_KEY environment variable or translation.watsonx_api_key in config/i18n-tasks.yml. Get the key at https://www.ibm.com/products/watsonx-ai.",
          "no_project_id": "Set watsonx Project ID via WATSONX_PROJECT_ID environment variable or translation.watsonx_api_key in config/i18n-tasks.yml. Get the key at https://www.ibm.com/products/watsonx-ai.",
          "no_results": "watsonx returned no results."
        }
      },
      "yandex_translate": {
        "errors": {
          "no_api_key": "Set Yandex API key via YANDEX_API_KEY environment variable or translation.yandex_api_key in config/i18n-tasks.yml. Get the key at https://tech.yandex.com/translate.",
          "no_results": "Yandex returned no results."
        }
      }
    },
    "ice_cube": {
      "array": {
        "last_word_connector": ", and ",
        "two_words_connector": " and ",
        "words_connector": ", "
      },
      "at_hours_of_the_day": {
        "one": "on the %{segments} hour of the day",
        "other": "on the %{segments} hours of the day"
      },
      "at_seconds_of_minute": {
        "one": "at the %{segments} second",
        "other": "at the %{segments} seconds"
      },
      "date": {
        "day_names": [
          "dimanche",
          "lundi",
          "mardi",
          "mercredi",
          "jeudi",
          "vendredi",
          "samedi"
        ],
        "formats": {
          "default": "%B %-d, %Y"
        },
        "month_names": [
          null,
          "janvier",
          "février",
          "mars",
          "avril",
          "mai",
          "juin",
          "juillet",
          "août",
          "septembre",
          "octobre",
          "novembre",
          "décembre"
        ]
      },
      "days_of_month": {
        "one": "%{segments} day of the month",
        "other": "%{segments} days of the month"
      },
      "days_of_week": "%{segments} %{day}",
      "days_of_year": {
        "one": "%{segments} day of the year",
        "other": "%{segments} days of the year"
      },
      "days_on": [
        "Sundays",
        "Mondays",
        "Tuesdays",
        "Wednesdays",
        "Thursdays",
        "Fridays",
        "Saturdays"
      ],
      "each_day": {
        "one": "Daily",
        "other": "Every %{count} days"
      },
      "each_hour": {
        "one": "Hourly",
        "other": "Every %{count} hours"
      },
      "each_minute": {
        "one": "Minutely",
        "other": "Every %{count} minutes"
      },
      "each_month": {
        "one": "Monthly",
        "other": "Every %{count} months"
      },
      "each_second": {
        "one": "Secondly",
        "other": "Every %{count} seconds"
      },
      "each_week": {
        "one": "Weekly",
        "other": "Every %{count} weeks"
      },
      "each_year": {
        "one": "Yearly",
        "other": "Every %{count} years"
      },
      "in": "in %{target}",
      "integer": {
        "literal_ordinals": {
          "-1": "last",
          "-2": "2nd to last"
        },
        "negative": "%{ordinal} to last",
        "ordinal": "%{number}%{ordinal}",
        "ordinals": {
          "1": "st",
          "11": "th",
          "12": "th",
          "13": "th",
          "2": "nd",
          "3": "rd",
          "default": "th"
        }
      },
      "not": "not %{target}",
      "not_on": "not on %{target}",
      "on": "on the %{sentence}",
      "on_days": "on %{days}",
      "on_minutes_of_hour": {
        "one": "on the %{segments} minute of the hour",
        "other": "on the %{segments} minutes of the hour"
      },
      "on_seconds_of_minute": {
        "one": "on the %{segments} second of the minute",
        "other": "on the %{segments} seconds of the minute"
      },
      "on_weekdays": "on Weekdays",
      "on_weekends": "on Weekends",
      "pieces_connector": " / ",
      "string": {
        "format": {
          "count": "%{rest} %{current}",
          "day": "%{rest} %{current}",
          "day_of_month": "%{rest} %{current}",
          "day_of_week": "%{rest} %{current}",
          "day_of_year": "%{rest} %{current}",
          "default": "%{rest} %{current}",
          "hour_of_day": "%{rest} %{current}",
          "minute_of_hour": "%{rest} %{current}",
          "until": "%{rest} %{current}"
        }
      },
      "times": {
        "one": "%{count} time",
        "other": "%{count} times"
      },
      "until": "until %{date}"
    },
    "layouts": {
      "admin": {
        "all_stores": "Toutes les boutiques",
        "commissions": "Commissions",
        "configuration": "Configuration",
        "dashboard": "Tableau de bord",
        "erp": "Accéder à l'ERP",
        "jobs": "Tâches",
        "monitoring": "Surveillance",
        "orders": "Commandes",
        "product_categories": "Catégories produits",
        "product_colors": "Couleurs produits",
        "products": "Produits",
        "promo_codes": "Codes promo",
        "statistics": "Statistiques",
        "storage": "Stockage",
        "stores": "Boutiques",
        "users": "Utilisateurs",
        "your_profile": "Votre profil"
      },
      "application": {
        "legal": "Mentions légales",
        "privacy": "Politique de confidentialité",
        "terms": "Conditions générales de vente"
      },
      "erp": {
        "modules": {
          "accounting": {
            "description": "Gestion financière et facturation",
            "name": "Comptabilité"
          },
          "administration": {
            "description": "Direction et pilotage stratégique",
            "name": "Administration"
          },
          "design": {
            "description": "Création et validation des visuels",
            "name": "Graphisme"
          },
          "inventory": {
            "description": "Gestion des stocks et approvisionnements",
            "name": "Inventaire"
          },
          "logistics": {
            "description": "Expéditions et livraisons",
            "name": "Logistique"
          },
          "production": {
            "description": "Fabrication et suivi de production",
            "name": "Production"
          },
          "sales": {
            "description": "Relation client et ventes",
            "name": "Commercial"
          },
          "stores": {
            "description": "Création et suivi des boutiques clients",
            "name": "Boutiques"
          }
        },
        "nav": {
          "access": "Accéder",
          "customers": "Clients",
          "dashboard": "Pilotage",
          "estimate_templates": "Modèles de devis",
          "estimates": "Devis",
          "pricing_grids": "Grilles tarifaires",
          "products": "Produits",
          "search": "Rechercher",
          "suppliers": "Fournisseurs"
        },
        "search": {
          "customers": "Clients",
          "estimates": "Devis",
          "min_chars": "Tapez au moins 2 caractères",
          "no_results": "Aucun résultat",
          "placeholder": "Rechercher clients, devis, produits...",
          "products": "Produits"
        }
      },
      "store_admin": {
        "all_my_stores": "Toutes mes boutiques",
        "configuration": "Configuration",
        "dashboard": "Tableau de bord",
        "orders": "Commandes",
        "products": "Produits",
        "promo_codes": "Codes promo",
        "statistics": "Statistiques",
        "stores": "Boutiques",
        "your_profile": "Votre profil"
      }
    },
    "missing": "Manquant(e)",
    "no_data": "Aucune donnée à afficher 🥲",
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "negative_format": "-%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Billion",
            "million": "Million",
            "quadrillion": "Quadrillion",
            "thousand": "Thousand",
            "trillion": "Trillion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB",
            "zb": "ZB"
          }
        }
      },
      "nth": {},
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "open": "Ouvrir",
    "order_items": {
      "order_item": {
        "color": "Couleur",
        "quantity": "Quantité",
        "size": "Taille"
      }
    },
    "orders": {
      "delivery": {
        "account": "Compte",
        "additional_information": "Informations complémentaires",
        "address_save_failed": "Impossible d'enregistrer l'adresse. Corrigez les champs signalés et réessayez.",
        "billing_address": "Adresse de facturation",
        "billing_addresses": "Utiliser une adresse de facturation",
        "free": "Gratuit",
        "multiple_deliveries_help": "Les articles en stock seront expédiés immédiatement et le reste plus tard. Si vous optez pour la livraison, vous paierez deux fois les frais de port.",
        "my_order": "Ma commande",
        "next": "Suivant",
        "processing": "Traitement...",
        "shipping_address": "Adresse de livraison",
        "shipping_addresses": "Utiliser une adresse de livraison",
        "stock_warning": "Nous n'avons pas l'intégralité de vos articles en stock. Vous pouvez opter pour une expédition des articles en stock suivi d'une seconde livraison avec le reste des articles lors que nous les aurons.",
        "title": "Livraison",
        "use_shipping_address": "Identique livraison"
      },
      "failure": {
        "error_occured": "Une erreur est survenue pendant la validation de votre commande dans la boutique %{store}.",
        "failure": "Commande non validée. 👎",
        "my_order": "Ma commande",
        "retry": "Réessayer",
        "title": "Commande annulée"
      },
      "index": {
        "my_orders": "Mes commandes",
        "signout": "Déconnexion",
        "title": "Commandes"
      },
      "invoice": {
        "delivery": "Frais de port HT",
        "delivery_address": "Adresse de livraison",
        "discount": "Remise HT",
        "invoiced_at": "Date de facture",
        "item": {
          "name": "Article",
          "quantity": "Quantité",
          "total": "Total HT",
          "total_with_vat": "Total TTC",
          "unit_price": "Prix unitaire HT",
          "vat": "TVA"
        },
        "order_reference": "Référence de la commande",
        "store_name": "Boutique",
        "subtotal": "Sous-total HT",
        "title": "Facture %{reference}",
        "total": "Total HT",
        "total_with_vat": "Total TTC",
        "vat": "TVA"
      },
      "order": {
        "delivery": "Expédition : %{type}",
        "paid_at": "Payée le : %{date}",
        "total": "Total : %{amount}"
      },
      "order_information": {
        "delivery": "Livraison",
        "discount": "Remise",
        "free": "Gratuite",
        "to_be_defined": "à définir",
        "total": "Total",
        "total_items": {
          "one": "1 article",
          "other": "%{count} articles",
          "zero": "Aucun article"
        },
        "vat_rounding_adjustment": "Arrondi TVA"
      },
      "payment": {
        "next": "Suivant",
        "title": "Paiement"
      },
      "show": {
        "invoice": "Facture %{reference}",
        "my_orders": "Mes commandes",
        "state": "État de la commande :",
        "title": "Commande %{reference}"
      },
      "success": {
        "my_order": "Ma commande",
        "next": "Suivant",
        "success": "Commande validée ! 👍",
        "thank_you_for_your_order": "Merci pour votre commande dans la boutique %{store}.",
        "title": "Commande validée"
      }
    },
    "pages": {
      "home": {
        "title": "Accueil"
      }
    },
    "pay": {
      "all_rights_reserved": "All rights reserved.",
      "back": "Go back",
      "cancelled": {
        "description": "This payment was cancelled.",
        "header": "Payment Cancelled"
      },
      "errors": {
        "action_required": "This payment attempt failed because additional action is required before it can be completed.",
        "braintree": {
          "authorization": "Either the data you submitted is malformed and does not match the API or the API key you used may not be authorized to perform this action."
        },
        "email_required": "Email is required to create a customer",
        "invalid_payment": "This payment attempt failed because of an invalid payment method.",
        "no_processor": "No payment processor selected. Make sure to set the %{class_name}'s `processor` attribute to either 'stripe' or 'braintree'."
      },
      "invoice": {
        "date": "Date",
        "number": "Invoice Number",
        "payment_method": "Payment method"
      },
      "line_items": {
        "amount": "Amount",
        "amount_discount": "%{name} (%{amount} off)",
        "description": "Description",
        "discount": "Discount",
        "percent_discount": "%{name} (%{percent}% off)",
        "quantity": "Quantity",
        "subtotal": "Subtotal",
        "tax": "Tax",
        "total": "Total",
        "unit_price": "Unit Price"
      },
      "receipt": {
        "amount_paid": "Amount paid",
        "date": "Date",
        "number": "Receipt Number",
        "paid": "Paid",
        "payment_method": "Payment Method",
        "refunded": "Refunded",
        "refunded_on": "Refunded on %{date}"
      },
      "refund": "Refund",
      "requires_action": {
        "button": "Pay %{amount}",
        "card": "Credit or debit card",
        "description": "Extra confirmation is needed to process your payment. Please confirm your payment by filling out your payment details below.",
        "full_name": "Full name",
        "header": "Confirm your %{amount} payment",
        "name_missing": "Please provide your name.",
        "success": "The payment was successful."
      },
      "successful": {
        "description": "This payment was successfully confirmed.",
        "header": "Payment Successful"
      },
      "user_mailer": {
        "payment_action_required": {
          "subject": "[%{application}] Confirm your payment"
        },
        "payment_failed": {
          "subject": "[%{application}] Action Required – Your payment failed"
        },
        "receipt": {
          "subject": "[%{application}] Payment receipt"
        },
        "refund": {
          "subject": "[%{application}] Payment refunded"
        },
        "subscription_renewing": {
          "subject": "[%{application}] Your upcoming subscription renewal"
        },
        "subscription_trial_ended": {
          "subject": "[%{application}] Your trial has ended"
        },
        "subscription_trial_will_end": {
          "subject": "[%{application}] Your trial is ending soon"
        }
      }
    },
    "product_variants": {
      "designer": {
        "back": "Arrière",
        "base": "Base",
        "front": "Avant"
      }
    },
    "products": {
      "product": {
        "add_to_cart": "Ajouter"
      },
      "search": {
        "accessories": "Accessoires",
        "all_products": "Tous nos produits",
        "clothing": "Vêtements",
        "filter_color": "Couleurs",
        "filter_mode": "Mode",
        "filter_products": "Catégorie de produits",
        "filter_size": "Tailles",
        "pagy_product": {
          "one": "produit",
          "other": "produits",
          "zero": "produit"
        },
        "search_products": "Rechercher des produits",
        "title": "Résultats de recherche"
      },
      "show": {
        "add_to_cart": "Ajouter au panier",
        "back_customization": "Dos (%{price})",
        "chest_customization": "Poitrine (%{price})",
        "close": "Fermer",
        "colors": "Couleurs",
        "customization_saved": "Personnalisation enregistrée et ajoutée au panier",
        "customize": "Personnaliser",
        "customize_your_product": "Personnalisez votre produit",
        "description": "Description",
        "heart_customization": "Coeur (%{price})",
        "left_sleeve_customization": "Manche gauche (%{price})",
        "out_of_stock": "Nous n'avons plus cet article en stock.",
        "quantity": "Quantité",
        "right_sleeve_customization": "Manche droite (%{price})",
        "save_customization": "Enregistrer la personnalisation",
        "similar_products": "Produits similaires",
        "sizes": "Tailles",
        "sizes_guide": "Guide des tailles",
        "title": "Produit %{product}"
      }
    },
    "profiles": {
      "edit": {
        "account": "Compte",
        "leave_blank_if_you_dont_want_to_change_it": "(laissez vide si vous ne souhaitez pas le changer)",
        "minimum_password_length": "Minimum de %{count} caractères",
        "my_information": "Mon compte",
        "save": "Sauvegarder",
        "signout": "Déconnexion",
        "title": "Mon compte",
        "waiting_confirmation": "En attente de confirmation pour %{email}"
      }
    },
    "proof_approval_mailer": {
      "details": {
        "approver": "Approbateur prévu : %{email}",
        "information": "Pour information : %{emails}",
        "internal_note": "Note de la PAO : %{note}",
        "submitted": "Soumis par %{name} le %{date}"
      },
      "greeting": "Bonjour %{name},",
      "reminder": {
        "body": "Le BAT v%{version} de l'affaire %{reference} (%{customer}), soumis le %{date}, attend toujours votre approbation : le client ne l'a pas encore reçu.",
        "subject": "Rappel : BAT v%{version} de l'affaire %{reference} à approuver"
      },
      "requested": {
        "actions": "Depuis la page du devis, approuvez-le pour l'envoyer au client, ou renvoyez-le à la PAO avec un commentaire.",
        "body": "Le BAT v%{version} de l'affaire %{reference} (%{customer}) attend votre approbation avant de partir chez le client.",
        "cta": "Voir le BAT dans l'ERP",
        "subject": "BAT v%{version} de l'affaire %{reference} à approuver"
      },
      "returned": {
        "body": "%{name} vous renvoie le BAT v%{version} de l'affaire %{reference} (%{customer}) avant l'envoi au client :",
        "cta": "Reprendre le BAT",
        "subject": "BAT v%{version} de l'affaire %{reference} renvoyé à la PAO"
      }
    },
    "search": {
      "result": {
        "created_at": "Créé(e) il y a %{time}",
        "updated_at": "Mis(e) à jour il y a %{time}"
      }
    },
    "search_placeholder": "Rechercher...",
    "shared": {
      "account_navigation": {
        "addresses": "Adresses",
        "orders": "Commandes",
        "profile": "Profile"
      },
      "flashes": {
        "close": "Fermer"
      },
      "form_errors": {
        "save_error": "Erreur lors de la sauvegarde"
      },
      "funnel_steps": {
        "cart": "Panier",
        "delivery": "Livraison",
        "summary": "Récapitulatif",
        "summary_short": "Récap"
      }
    },
    "show": "Afficher",
    "store_admin": {
      "dashboard": {
        "index": {
          "last_month_orders": "Commandes du mois dernier par jour",
          "title": "Statistiques"
        }
      },
      "orders": {
        "index": {
          "title": "Commandes"
        },
        "order": {
          "delivery": "Expédition : %{type}",
          "paid_at": "Payée le : %{date}",
          "total": "Total : %{amount}"
        },
        "show": {
          "actions": "Actions disponibles",
          "billing_address": "Adresse de facturation",
          "cancel": "Annuler",
          "cancel_confirmation": "Annuler la commande %{order} ?",
          "customer": "Client",
          "delivery_to_store": "📦 Livraison à la boutique %{store}",
          "invoices": "Factures",
          "items": "Articles",
          "multiple_deliveries": "Expédition multiple",
          "no_customer": "Aucun client",
          "order": "Commande",
          "parcels": "Colis",
          "shipping_address": "Adresse de livraison",
          "summary": "Résumé",
          "title": "Commande %{order}"
        }
      },
      "product_variants": {
        "edit": {
          "title": "Modification de la variante %{product_variant}"
        },
        "form": {
          "base_variant": "Il s'agit de la variante de base importée depuis le fournisseur et n'étant pas liée à une boutique.",
          "batch_create": "Création en lot",
          "batch_update": "Mise à jour en lot",
          "create_other_product_variants_help": "Si activé, le variant sera dupliqué pour toutes les tailles du produit.",
          "images": "Images",
          "information": "Informations générales",
          "no_images": "Aucune image",
          "no_primary_image": "Aucune image principale",
          "pricing": "Tarification",
          "product_variant_enabled_help": "Les variantes de produits inactives ne sont pas achetables et restent cachés.",
          "store": "Boutique",
          "store_variant": "Il s'agit d'une variante liée à la boutique %{store}.",
          "supplier": "Informations fournisseur (%{supplier})",
          "update_other_product_variants_help": "Si activé, le nom et le prix de cette variante seront appliqués aux autres variantes de ce produit. Les images des variantes de taille différente, mais avec les mêmes couleurs, seront également mises à jour."
        },
        "image": {
          "delete": "Supprimer",
          "delete_confirmation": "Supprimer cette image ?"
        },
        "index": {
          "title": "Variantes de %{product}"
        },
        "new": {
          "title": "Nouvelle variante pour %{product}"
        },
        "product_variant": {
          "delete_confirmation": "Supprimer la variante %{product_variant} ?",
          "global": "Commun à toutes les boutiques",
          "price": "Prix : %{price}",
          "size": "Taille : %{size}",
          "specific_to_store": "Spécifique à %{store}"
        },
        "show": {
          "title": "Variante %{product_variant}"
        },
        "update": {
          "title": "Modification de la variante %{product_variant}"
        }
      },
      "products": {
        "edit": {
          "title": "Modification du produit %{product}"
        },
        "form": {
          "base_product": "Il s'agit du produit de base importé depuis le fournisseur et n'étant pas liée à une boutique.",
          "images": "Images",
          "information": "Informations générales",
          "no_images": "Aucune image",
          "no_sizes_guide": "Aucun guide de tailles disponible",
          "open_sizes_guide": "Voir le guide",
          "pricing": "Tarification",
          "product_enabled_help": "Les produits inactifs ne sont pas achetables et restent cachés.",
          "store": "Boutique",
          "store_product": "Il s'agit d'un produit lié à la boutique %{store}.",
          "supplier": "Fournisseur",
          "tags_placeholder": "Séparez vos tags par un espace"
        },
        "image": {
          "delete": "Supprimer",
          "delete_confirmation": "Supprimer cette image ?"
        },
        "index": {
          "title": "Mes produits"
        },
        "new": {
          "title": "Nouveau produit"
        },
        "product": {
          "created_at": "Créé le : %{date}",
          "delete_confirmation": "Supprimer le produit %{product} ?",
          "global": "Commun à toutes les boutiques",
          "reference": "Référence : %{reference}",
          "specific_to_store": "Spécifique à %{store}",
          "supplier": "Fournisseur : %{supplier}"
        },
        "show": {
          "add_product_variant": "Ajouter un variant",
          "disable_all": "Désactiver tout",
          "disable_color_confirmation": "Désactiver toutes les variantes de la couleur %{color} ?",
          "duplicate_for_store": "Dupliquer pour %{store}",
          "duplicate_for_store_confirmation": "Dupliquer le produit et tous ses variants pour la boutique %{store} ?",
          "enable_all": "Activer tout",
          "enable_color_confirmation": "Activer toutes les variantes de la couleur %{color} ?",
          "title": "Produit %{product}",
          "variants": "Variantes"
        },
        "update": {
          "title": "Modification du produit %{product}"
        }
      },
      "promo_codes": {
        "edit": {
          "title": "Modification du code promo %{promo_code}"
        },
        "form": {
          "information": "Informations générales",
          "promo_code_enabled_help": "Les codes promo inactifs ne sont pas utilisables sur les boutiques.",
          "select_a_store": "Sélectionnez une boutique"
        },
        "index": {
          "contact_support": "Veuillez contacter le support SOFIDIAL pour créer un code promo ou gérer les codes promo existants.",
          "title": "Codes promo"
        },
        "new": {
          "title": "Nouveau code promo"
        },
        "promo_code": {
          "code_type": "Type : %{type}",
          "created_at": "Créé le : %{date}",
          "delete_confirmation": "Supprimer le code promo %{promo_code} ?",
          "utilizations": "Utilisations : %{value}",
          "value": "Valeur : %{value}"
        },
        "show": {
          "title": "Code promo %{promo_code}"
        }
      },
      "search": {
        "index": {
          "search_results": "Résultats de recherche pour %{query}",
          "title": "Résultats de recherche pour %{query}"
        }
      },
      "stores": {
        "edit": {
          "title": "Modification de la boutique %{store}"
        },
        "form": {
          "add_field": "Ajouter un champ",
          "billing_address": "Adresse facturation",
          "custom_fields": "Champs personnalisés",
          "delete_banner": "Supprimer la bannière",
          "delete_banner_confirmation": "Supprimer la bannière de la boutique ?",
          "delete_mobile_banner": "Supprimer la bannière mobile",
          "delete_mobile_banner_confirmation": "Supprimer la bannière mobile de la boutique ?",
          "dns_setup_documentation_html": "Créez un enregistrement <code>CNAME</code> pointant vers <code>%{target}<c/ode> dans la zone DNS de votre domaine.",
          "information": "Informations générales",
          "mobile_banner_help": "Image affichée uniquement sur mobile, remplaçant le message texte de la bannière.",
          "payment_and_billing": "Paiement et facturation",
          "remove_field": "Retirer",
          "shipping_address": "Adresse de livraison",
          "store_enabled_help": "Les boutiques inactives restent cachées.",
          "urls": "URLs",
          "use_shipping_address": "Identique livraison"
        },
        "index": {
          "title": "Mes boutiques"
        },
        "product": {
          "delete_confirmation": "Désactiver le produit %{product} de la boutique ?",
          "deleting": "Désactivation en cours...",
          "product_since": "Depuis le %{date}",
          "store_product": "Spécifique à %{store}",
          "variants": {
            "one": "1 variante",
            "other": "%{count} variantes",
            "zero": "Aucune variante"
          }
        },
        "show": {
          "add_admin": "Ajouter",
          "add_product": "Ajouter",
          "no_matching_products": "Aucun produit ne correspond à votre recherche.",
          "products": "Produits",
          "search_products": "Rechercher un produit par nom ou référence",
          "select_a_new_admin": "Sélectionnez un nouvel administrateur",
          "select_a_new_product": "Sélectionnez un nouveau produit",
          "sort": "Trier",
          "store_admins": "Administrateurs",
          "store_products": "Produits actifs",
          "title": "Boutique %{store}"
        },
        "sort_products": {
          "title": "Trier les produits"
        },
        "user": {
          "admin_since": "Depuis le %{date}"
        }
      }
    },
    "stores": {
      "show": {
        "accessories": "Accessoires",
        "all_products": "Tous nos produits",
        "clothing": "Vêtements",
        "filter_color": "Couleurs",
        "filter_mode": "Mode",
        "filter_products": "Catégorie de produits",
        "filter_size": "Tailles",
        "filter_tag": "Thèmes",
        "pagy_product": {
          "one": "produit",
          "other": "produits",
          "zero": "produit"
        },
        "search_products": "Rechercher des produits",
        "title": "Tous nos produits"
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", and ",
        "two_words_connector": " and ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%B %d, %Y %H:%M",
        "short": "%d %b %H:%M",
        "time": "%H:%M"
      },
      "pm": "pm"
    }
  },
  "fr": {
    "actions": "Actions",
    "activemodel": {
      "attributes": {
        "manual_article": {
          "article_kind": "Type d’article",
          "colors_text": "Couleurs",
          "name": "Dénomination",
          "purchase_price": "Prix d’achat HT",
          "reference": "Code article",
          "sale_price": "Prix de vente HT",
          "size_ids": "Tailles",
          "supplier_name": "Fournisseur"
        }
      }
    },
    "activerecord": {
      "attributes": {
        "address": {
          "address_type": "Type",
          "address_types": {
            "billing": "Facturation",
            "shipping": "Livraison"
          },
          "addressable_id": "Identifiant",
          "addressable_type": "Type",
          "city": "Ville",
          "company": "Entreprise",
          "country": "Pays",
          "default": "Adresse par défaut",
          "email": "Email",
          "first_name": "Prénom",
          "id": "ID",
          "last_name": "Nom",
          "latitude": "Latitude",
          "longitude": "Longitude",
          "name": "Nom de l'adresse",
          "phone": "Téléphone",
          "siren": "SIREN",
          "state": "Region",
          "street": "Rue",
          "street_information": "Informations",
          "vat_number": "Numéro de TVA",
          "zipcode": "Code postal"
        },
        "cart": {
          "id": "ID",
          "promo_code": "Code promo",
          "store": "Boutique",
          "user": "Client"
        },
        "cart_item": {
          "cart_id": "Panier",
          "customization_keys": {
            "back": "Dos",
            "chest": "Poitrine",
            "heart": "Cœur",
            "left_sleeve": "Manche gauche",
            "right_sleeve": "Manche droite"
          },
          "customizations": "Personnalisations",
          "id": "ID",
          "product_variant_id": "Produit",
          "quantity": "Quantité"
        },
        "commission": {
          "delivery_price": "Frais de livraison",
          "ends_on": "Fin",
          "id": "ID",
          "sofidial_part": "Part Sofidial",
          "starts_on": "Début",
          "store_part": "Part Club",
          "stripe_fee": "Frais Stripe",
          "total": "Total",
          "vat": "TVA"
        },
        "customer": {
          "default_global_discount_percentage": "Remise globale par défaut",
          "textile_margin_rate": "Coefficient textile"
        },
        "customer_product_price": {
          "product": "Produit",
          "product_id": "Produit",
          "unit_price": "Prix unitaire HT",
          "unit_price_cents": "Prix unitaire HT"
        },
        "estimate": {
          "customer": "Client",
          "global_discount_amount": "Remise globale (€)",
          "global_discount_amount_cents": "Remise globale (€)",
          "global_discount_percentage": "Remise globale (%)",
          "global_discount_type": "Type de remise globale",
          "items": "Lignes",
          "markings": "Marquages",
          "payment_delay_days": "Délai de paiement",
          "payment_method": "Mode de règlement",
          "payment_terms": "Modalités de règlement",
          "reference": "Référence",
          "responsible": "Responsable",
          "status": "Statut",
          "title": "Titre du devis",
          "validity_date": "Date de validité"
        },
        "estimate/items": {
          "description": "Description",
          "printing_technique": "Technique de marquage",
          "quantity": "Quantité",
          "textile_margin_rate": "Coefficient textile",
          "unit": "Unité",
          "unit_price": "Prix unitaire HT",
          "unit_price_cents": "Prix unitaire HT",
          "vat_rate": "Taux TVA"
        },
        "estimate/markings": {
          "personalized_pieces_count": "Pièces personnalisées",
          "vat_rate": "Taux TVA"
        },
        "estimate_item": {
          "customer_assets": "Fichiers du client",
          "customization_notes": "Notes personnalisation",
          "customization_price": "Prix personnalisation",
          "customization_price_cents": "Prix personnalisation",
          "description": "Description",
          "discount_amount": "Remise (€)",
          "discount_amount_cents": "Remise (€)",
          "discount_percentage": "Remise (%)",
          "discount_type": "Type de remise",
          "garment_type": "Type de vêtement",
          "line_type": "Type de ligne",
          "position": "Position",
          "pricing_status": "Statut du tarif",
          "printing_dimension_1": "Dimension",
          "printing_dimension_2": "Textile",
          "printing_price_cents": "Prix marquage",
          "printing_sub_technique": "Sous-technique",
          "printing_technique": "Technique de marquage",
          "product": "Produit",
          "product_colorway": "Coloris",
          "product_type": "Type de produit",
          "product_variant": "Variante",
          "quantity": "Quantité",
          "reference": "Référence",
          "section": "Section",
          "supplier_price_cents": "Prix fournisseur",
          "textile_margin_rate": "Coefficient textile",
          "textile_price_cents": "Prix textile",
          "unit": "Unité",
          "unit_price": "Prix unitaire HT",
          "unit_price_cents": "Prix unitaire HT",
          "vat_rate": "Taux TVA"
        },
        "estimate_item_variant": {
          "canonical_size": "Taille",
          "product_variant": "Variante",
          "quantity": "Quantité",
          "size_label": "Taille"
        },
        "estimate_marking": {
          "artwork_text": "Texte à marquer",
          "artwork_version": "Révision du fichier de marquage",
          "custom_marking_zone_name": "Zone personnalisée",
          "discount_amount_cents": "Remise (€)",
          "discount_percentage": "Remise (%)",
          "files": "Fichiers",
          "marking_zone": "Zone de marquage",
          "personalization_config": "Personnalisation",
          "personalized_pieces_count": "Pièces personnalisées",
          "pricing_status": "Statut du tarif",
          "quantity": "Quantité marquée",
          "series_key": "Série de marquage",
          "unit_price": "Prix unitaire HT",
          "unit_price_cents": "Prix unitaire HT",
          "vat_rate": "Taux TVA"
        },
        "estimate_marking_allocation": {
          "estimate_item_variant_id": "Taille",
          "item_variant": "Taille",
          "quantity": "Quantité marquée",
          "textile_type": "Type de textile"
        },
        "estimate_marking_extra": {
          "printing_extra": "Option ERP",
          "printing_extra_id": "Option ERP"
        },
        "estimate_marking_item": {
          "item": "Textile",
          "quantity": "Quantité"
        },
        "estimate_revision_delivery": {
          "recipient_email": "Adresse email du destinataire",
          "revision": "Révision"
        },
        "estimate_section": {
          "name": "Nom"
        },
        "favorite": {
          "id": "ID",
          "product_variant_id": "Produit",
          "store_id": "Boutique",
          "user_id": "Client"
        },
        "order": {
          "delivery_method": "Mode de livraison",
          "delivery_methods": {
            "delivery": "Livraison",
            "pickup": "Retrait chez %{store}"
          },
          "delivery_price": "Prix de livraison",
          "delivery_price_with_vat": "Prix de livraison TTC",
          "discount": "Remise",
          "id": "ID",
          "multiple_deliveries": "Expédition multiple",
          "paid_at": "Payée le",
          "promo_code": "Code promo",
          "reference": "Référence",
          "state": "État",
          "states": {
            "awaiting_payment": "En attente de paiement",
            "cancelled": "Annulée",
            "delivered": "Livrée",
            "paid": "Payée",
            "partially_shipped": "Partiellement expédiée",
            "pending": "En attente",
            "shipped": "Expédiée"
          },
          "store": "Boutique",
          "subtotal": "Sous-total HT",
          "subtotal_with_vat": "Sous-total TTC",
          "total": "Total HT",
          "total_with_vat": "Total TTC",
          "user": "Client",
          "vat": "TVA"
        },
        "order_item": {
          "customization_keys": {
            "back": "Dos",
            "chest": "Poitrine",
            "heart": "Cœur",
            "left_sleeve": "Manche gauche",
            "right_sleeve": "Manche droite"
          },
          "customizations": "Personnalisations",
          "id": "ID",
          "order_id": "Commande",
          "product_variant_id": "Produit",
          "quantity": "Quantité"
        },
        "parcel": {
          "carrier": "Transporteur",
          "carriers": {
            "dpd": "DPD"
          },
          "delivered_on": "Date de livraison",
          "id": "ID",
          "order_id": "Commande",
          "order_items": "Articles",
          "order_items_count": "Nombre d'articles",
          "state": "État",
          "states": {
            "delivered": "Livré",
            "pending": "En préparation",
            "returned": "Retourné",
            "shipped": "Expédié"
          },
          "tracking_number": "Numéro de suivi",
          "weight": "Poids"
        },
        "product": {
          "brand": "Marque",
          "description": "Description",
          "enabled": "Activé",
          "id": "ID",
          "images": "Images",
          "mode": "Mode",
          "modes": {
            "children": "Enfant",
            "men": "Homme",
            "mixed": "Mixte",
            "women": "Femme"
          },
          "name": "Nom",
          "product_category": "Catégorie",
          "product_category_id": "Catégorie",
          "reference": "Référence",
          "should_update_other_products_with_same_reference": "Mettre à jour les produits avec la même référence",
          "sizes_guide": "Guide des tailles",
          "sofidial_price": "Prix SOFIDIAL",
          "store": "Boutique",
          "store_id": "Boutique",
          "supplier": "Fournisseur",
          "supplier_price": "Prix fournisseur",
          "suppliers": {
            "imbretex": "Imbretex",
            "other": "Autre"
          },
          "tag_list": "Tags",
          "vat_rate": "Taux de TVA",
          "vat_rates": {
            "vat_20": "20%"
          },
          "weight": "Poids (en grammes)"
        },
        "product_category": {
          "group": "Groupe",
          "groups": {
            "accessories": "Accessoires",
            "clothing": "Vêtements"
          },
          "id": "ID",
          "name": "Nom",
          "products_count": "Nombre de produits"
        },
        "product_color": {
          "group": "Groupe de couleurs",
          "groups": {
            "ash": "Cendre",
            "black": "Noir",
            "blue": "Bleu",
            "brown": "Marron",
            "burgundy": "Bordeaux",
            "dark_grey": "Gris foncé",
            "green": "Vert",
            "grey": "Gris",
            "heather": "Herbe",
            "khaki": "Kaki",
            "misc": "Divers",
            "natural": "Naturelle",
            "navy": "Navy",
            "orange": "Orange",
            "pink": "Rose",
            "purple": "Mauve",
            "red": "Rouge",
            "sand": "Sable",
            "white": "Blanc",
            "yellow": "Jaune"
          },
          "hex": "Code hexadecimal",
          "id": "ID",
          "image": "Image",
          "name": "Nom",
          "products_count": "Nombre de produits"
        },
        "product_variant": {
          "back_image": "Image arrière",
          "description": "Description",
          "enabled": "Activée",
          "front": "Mis en avant",
          "front_image": "Image avant",
          "id": "ID",
          "images": "Images",
          "name": "Nom",
          "price": "Prix HT",
          "price_with_vat": "Prix TTC",
          "primary_image": "Image principale",
          "product_color_ids": "Couleurs",
          "product_id": "Produit",
          "reference": "Référence",
          "should_create_other_product_variants": "Créer les autres variantes de même couleur du produit",
          "should_update_other_colorless_variants": "Mettre à jour les autres variantes sans couleur du produit",
          "should_update_other_product_variants": "Mettre à jour les autres variantes du produit",
          "size": "Taille",
          "sofidial_price": "Prix SOFIDIAL HT",
          "store_id": "Boutique",
          "supplier_price": "Prix fournisseur HT",
          "weight": "Poids"
        },
        "product_variant_customization": {
          "cart_id": "Panier",
          "created_at": "Créé le",
          "id": "ID",
          "image": "Image",
          "product_variant_id": "Variante de produit",
          "updated_at": "Modifié le"
        },
        "promo_code": {
          "code_type": "Type",
          "code_types": {
            "fixed": "Fixe",
            "percentage": "Pourcentage"
          },
          "enabled": "Activé",
          "expires_at": "Expire le",
          "id": "ID",
          "name": "Nom",
          "store": "Boutique",
          "store_id": "Boutique",
          "value": "Valeur"
        },
        "proof_delivery": {
          "proof": "BAT",
          "recipient_email": "Adresse email du destinataire"
        },
        "store": {
          "accent_color": "Couleur d'accentuation",
          "account_number": "Numéro de compte comptable",
          "advanced_customization_enabled": "Activer la personnalisation avancée",
          "allow_search_engines": "Autoriser les moteurs de recherche",
          "banner": "Bannière",
          "banner_message": "Message de la bannière",
          "billing_address": "Adresse facturation",
          "billing_email": "Adresse email de facturation",
          "customization_enabled": "Activer la personnalisation",
          "delivery_enabled": "Activer la livraison",
          "description": "Description",
          "domain": "Domaine",
          "enabled": "Activé",
          "id": "ID",
          "mobile_banner": "Bannière mobile",
          "name": "Nom",
          "order_prefix": "Préfixe de commande",
          "pickup_location_name": "Nom du lieu de retrait",
          "shipping_address": "Adresse de livraison",
          "subdomain": "Sous-domaine",
          "supplier_orders_enabled": "Activer les commandes fournisseur"
        },
        "store_custom_field": {
          "description": "Description",
          "field_type": "Field type",
          "field_types": {
            "boolean": "Case à cocher",
            "date": "Date",
            "email": "Email",
            "float": "Nombre flottant",
            "integer": "Nombre entier",
            "number": "Nombre",
            "phone": "Téléphone",
            "string": "Texte",
            "text": "Texte long",
            "url": "URL"
          },
          "name": "Nom",
          "position": "Position",
          "required": "Obligatoire"
        },
        "supplier_order": {
          "external_id": "ID externe",
          "id": "ID",
          "metadata": "Métadonnées",
          "order_id": "Commande",
          "state": "État",
          "states": {
            "created": "Créée",
            "failed": "Échouée"
          },
          "supplier": "Fournisseur",
          "suppliers": {
            "imbretex": "Imbretex",
            "other": "Autre"
          }
        },
        "supply_order": {
          "suppliers": {
            "imbretex": "Imbretex",
            "other": "Autre fournisseur"
          }
        },
        "supply_order_item": {
          "quantity_ordered": "Quantité commandée",
          "quantity_received": "Quantité reçue",
          "size_label": "Taille",
          "supplier_reference": "Référence fournisseur"
        },
        "user": {
          "current_password": "Mot de passe actuel",
          "email": "Email",
          "first_name": "Prénom",
          "full_name": "Nom complet",
          "gender": "Genre",
          "genders": {
            "female": "Femme",
            "male": "Homme",
            "other": "Autre"
          },
          "id": "ID",
          "last_name": "Nom de famille",
          "password": "Mot de passe",
          "password_confirmation": "Confirmation du mot de passe",
          "user_type": "Type",
          "user_types": {
            "admin": "Admin",
            "customer": "Client",
            "store_admin": "Admin magasin"
          }
        }
      },
      "enums": {
        "customer": {
          "family": {
            "administration": "Administration",
            "individual": "Particulier",
            "professional": "Professionnel",
            "reseller": "Revendeur"
          },
          "legal_form": {
            "association": "Association",
            "autre": "Autre",
            "ei": "Entreprise Individuelle",
            "eurl": "EURL",
            "sa": "SA",
            "sarl": "SARL",
            "sas": "SAS",
            "sasu": "SASU",
            "sci": "SCI"
          }
        },
        "customer_asset": {
          "category": {
            "brand_guidelines": "Charte graphique",
            "logo": "Logo",
            "mockup": "Maquette",
            "other": "Autre",
            "photo": "Photo"
          }
        },
        "estimate": {
          "payment_method": {
            "bank_transfer": "Virement bancaire",
            "cash": "Espèces",
            "check": "Chèque",
            "credit_card": "Carte bancaire"
          },
          "status": {
            "completed": "Affaire validée",
            "draft": "Brouillon",
            "in_design": "En conception",
            "in_production": "Passé en affaire",
            "lost": "Perdu",
            "sent": "Non validé",
            "validated": "En cours"
          }
        },
        "estimate_item": {
          "discount_type": {
            "fixed": "Montant fixe",
            "percentage": "Pourcentage"
          }
        },
        "proof": {
          "status": {
            "approved": "Approuvé",
            "draft": "Brouillon",
            "pending_approval": "En attente d'approbation commerciale",
            "revision_requested": "Révision demandée",
            "sent": "Envoyé au client"
          }
        },
        "supply_order": {
          "status": {
            "failed": "En échec",
            "ordered": "Commandée",
            "pending": "Brouillon",
            "received": "Reçue"
          }
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "La validation a échoué : %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Vous ne pouvez pas supprimer l'enregistrement parce que les %{record} dépendants existent",
            "has_one": "Vous ne pouvez pas supprimer l'enregistrement car un(e) %{record} dépendant(e) existe"
          }
        },
        "models": {
          "address": {
            "company_or_name_missing": "Vous devez indiquer vos nom et prénom ou votre entreprise."
          },
          "customer_product_price": {
            "attributes": {
              "product_id": {
                "taken": "a déjà un tarif pour ce client"
              }
            }
          },
          "product_variant": {
            "attributes": {
              "price": {
                "price_lower_than_sofidial_price": "doit être supérieur ou égal au prix SOFIDIAL"
              },
              "sofidial_price": {
                "sofidial_price_lower_than_supplier_price": "doit être supérieur ou égal au prix fournisseur"
              }
            }
          }
        }
      },
      "models": {
        "address": "Adresse",
        "billing_address": "Adresse de facturation",
        "cart": "Panier",
        "cart_item": "Article",
        "commission": "Commission",
        "customer_product_price": "Tarif client",
        "estimate_revision_delivery": "Envoi du devis",
        "favorite": "Favori",
        "invoice": "Facture",
        "order": "Commande",
        "order_item": "Article",
        "parcel": "Colis",
        "product": "Produit",
        "product_category": "Catégorie de produit",
        "product_color": "Couleur de produit",
        "product_variant": "Variante de produit",
        "product_variant_customization": "Personnalisation de produit",
        "production_order": "Ordre de production",
        "promo_code": "Code promo",
        "proof_delivery": "Envoi du BAT",
        "shipping_address": "Adresse de livraison",
        "store": "Boutique",
        "store_custom_field": "Champ personnalisé",
        "supplier_order": "Commande fournisseur",
        "supply_order": "Commande d'approvisionnement",
        "supply_order_item": "Ligne d'approvisionnement",
        "user": "Utilisateur"
      }
    },
    "add": "Ajouter",
    "addresses": {
      "address": {
        "type": "Type : %{type}"
      },
      "edit": {
        "edit_address": "Modifier l'adresse %{address}",
        "save": "Sauvegarder",
        "title": "Modifier une adresse"
      },
      "form": {
        "address_default_help": "Si activé, cette adresse sera utilisée comme adresse par défaut pour %{type}."
      },
      "index": {
        "my_addresses": "Mes adresses",
        "signout": "Déconnexion",
        "title": "Adresses"
      }
    },
    "admin": {
      "commissions": {
        "commission": {
          "discount": "Remise : %{amount}",
          "gross_sofidial_part": "Part Sofidial Brute : %{amount}",
          "net_sofidial_part": "Part Sofidial Nette : %{amount}",
          "store_part": "Part Club : %{amount}",
          "supplier_part": "Part Fournisseur : %{amount}",
          "total": "Total : %{amount}"
        },
        "index": {
          "title": "Commissions"
        }
      },
      "controllers": {
        "addresses": {
          "create": {
            "notice": "Adresse créée."
          },
          "destroy": {
            "notice": "Adresse supprimée."
          },
          "update": {
            "notice": "Adresse mise à jour."
          }
        }
      },
      "dashboard": {
        "index": {
          "last_month_orders": "Commandes du mois dernier par jour",
          "title": "Statistiques"
        }
      },
      "invoices": {
        "invoice": {
          "archived_version": "Version archivée"
        }
      },
      "order_items": {
        "order_item": {
          "color": "Couleur",
          "fonts": "Polices",
          "quantity": "Quantité",
          "size": "Taille"
        }
      },
      "orders": {
        "charge": {
          "receipt": "Reçu"
        },
        "index": {
          "title": "Commandes"
        },
        "order": {
          "created_at": "Créée le : %{date}",
          "delivery": "Expédition : %{type}",
          "paid_at": "Payée le : %{date}",
          "store": "Boutique : %{store}",
          "total": "Total : %{amount}"
        },
        "show": {
          "actions": "Actions disponibles",
          "add_parcel": "Ajouter un colis",
          "assets": "Ressources",
          "available_for_pickup": "Disponible pour le retrait",
          "billing_address": "Adresse de facturation",
          "billing_identifiers_not_editable": "Les identifiants de cette commande ne peuvent plus être modifiés ici.",
          "billing_identifiers_review_required": "Vérifiez le SIREN et le numéro de TVA du client avant d'émettre sa facture.",
          "billing_identifiers_saved": "Identifiants du client enregistrés.",
          "cancel": "Annuler",
          "cancel_confirmation": "Annuler la commande %{order} ?",
          "charges": "Paiements",
          "customer": "Client",
          "delivery_to_store": "📦 Livraison à la boutique %{store}",
          "invoiced_order_cannot_be_deleted": "Une commande facturée ne peut pas être supprimée.",
          "invoices": "Factures",
          "items": "Articles",
          "multiple_deliveries": "Expédition multiple",
          "no_customer": "Aucun client",
          "order": "Commande",
          "parcels": "Colis",
          "save_billing_identifiers": "Enregistrer les identifiants",
          "ship_confirmation": "Marquer la commande %{order} comme disponible pour le retrait ?",
          "shipping_address": "Adresse de livraison",
          "siren_invalid": "SIREN invalide.",
          "siren_missing": "Renseignez le SIREN du client avant d'émettre sa facture.",
          "summary": "Résumé",
          "supplier_orders": "Commandes fournisseur",
          "title": "Commande %{order} du %{date}",
          "vat_number_invalid": "Numéro de TVA invalide.",
          "vat_review_required": "Le traitement de TVA de cette commande doit être vérifié avant l'expédition.",
          "with_vat": "(assujetti à la TVA)",
          "without_vat": "(non assujetti à la TVA)"
        },
        "supplier_order": {
          "state": "État : %{state}"
        }
      },
      "parcels": {
        "form": {
          "add": "Ajouter"
        },
        "index": {
          "title": "Colis"
        }
      },
      "product_categories": {
        "edit": {
          "title": "Modification de la catégorie %{product_category}"
        },
        "form": {
          "information": "Informations générales"
        },
        "index": {
          "title": "Catégories"
        },
        "new": {
          "title": "Nouvelle catégorie"
        },
        "product_category": {
          "created_at": "Créée le : %{date}",
          "delete_confirmation": "Supprimer la catégorie %{product_category} ?",
          "group": "Groupe : %{group}"
        },
        "show": {
          "title": "Catégorie %{product_category}"
        }
      },
      "product_colors": {
        "edit": {
          "title": "Modification de la couleur %{product_color}"
        },
        "form": {
          "current_hex_value_html": "Valeur actuelle : <code>%{hex}</code>",
          "delete_image": "Supprimer l'image",
          "delete_image_confirmation": "Etes-vous sûr de vouloir supprimer l'image de la couleur ?",
          "information": "Informations générales"
        },
        "index": {
          "title": "Couleurs"
        },
        "new": {
          "title": "Nouvelle couleur"
        },
        "product_color": {
          "created_at": "Créée le : %{date}",
          "delete_confirmation": "Supprimer la couleur %{product_color} ?",
          "group": "Groupe : %{group}",
          "hex": "Code hexadécimal : %{hex}"
        },
        "show": {
          "title": "Couleur %{product_color}"
        }
      },
      "product_variant_customizations": {
        "index": {
          "title": "Personnalisations"
        },
        "product_variant_customization": {
          "created_at": "Créée le %{date}",
          "delete_confirmation": "Supprimer la personnalisation du variant %{product_variant} ?"
        }
      },
      "product_variants": {
        "edit": {
          "title": "Modification de la variante %{product_variant}"
        },
        "form": {
          "base_variant": "Il s'agit de la variante de base importée depuis le fournisseur et n'étant pas liée à une boutique.",
          "batch_create": "Création en lot",
          "batch_update": "Mise à jour en lot",
          "create_other_product_variants_help": "Si activé, le variant sera dupliqué pour toutes les tailles du produit.",
          "customization": "Personnalisation",
          "images": "Images",
          "information": "Informations générales",
          "no_back_image": "Aucune image arrière",
          "no_front_image": "Aucune image avant",
          "no_images": "Aucune image",
          "no_primary_image": "Aucune image principale",
          "pricing": "Tarification",
          "product_variant_enabled_help": "Les variantes de produits inactives ne sont pas achetables et restent cachés.",
          "store": "Boutique",
          "store_variant": "Il s'agit d'une variante liée à la boutique %{store}.",
          "supplier": "Informations fournisseur (%{supplier})",
          "update_other_colorless_variants_help": "Si activé, les couleurs de cette variante seront appliquées aux autres variantes de ce produit sans couleur.",
          "update_other_product_variants_help": "Si activé, le nom et le prix de cette variante seront appliqués aux autres variantes de ce produit. Les images des variantes de taille différente, mais avec les mêmes couleurs, seront également mises à jour."
        },
        "image": {
          "delete": "Supprimer",
          "delete_confirmation": "Supprimer cette image ?"
        },
        "index": {
          "title": "Variantes de %{product}"
        },
        "new": {
          "title": "Nouvelle variante pour %{product}"
        },
        "product_variant": {
          "delete_confirmation": "Supprimer la variante %{product_variant} ?",
          "global": "Commun à toutes les boutiques",
          "price": "Prix : %{price}",
          "size": "Taille : %{size}",
          "specific_to_store": "Spécifique à %{store}"
        },
        "show": {
          "title": "Variante %{product_variant}"
        },
        "update": {
          "title": "Modification de la variante %{product_variant}"
        }
      },
      "products": {
        "edit": {
          "title": "Modification du produit %{product}"
        },
        "form": {
          "base_product": "Il s'agit du produit de base importé depuis le fournisseur et n'étant pas liée à une boutique.",
          "images": "Images",
          "information": "Informations générales",
          "no_images": "Aucune image",
          "no_sizes_guide": "Aucun guide de tailles disponible",
          "open_sizes_guide": "Voir le guide",
          "pricing": "Tarification",
          "product_enabled_help": "Les produits inactifs ne sont pas achetables et restent cachés.",
          "should_update_other_products_with_same_reference_help": "Cocher cette case pour mettre à jour le prix SOFIDIAL de tous les produits de ce magasin avec la même référence.",
          "store": "Boutique",
          "store_product": "Il s'agit d'un produit lié à la boutique %{store}.",
          "supplier": "Fournisseur",
          "tags_placeholder": "Séparez vos tags par un espace"
        },
        "image": {
          "delete": "Supprimer",
          "delete_confirmation": "Supprimer cette image ?"
        },
        "index": {
          "title": "Produits"
        },
        "new": {
          "title": "Nouveau produit"
        },
        "product": {
          "created_at": "Créé le : %{date}",
          "delete_confirmation": "Supprimer le produit %{product} ?",
          "global": "Commun à toutes les boutiques",
          "reference": "Référence : %{reference}",
          "specific_to_store": "Spécifique à %{store}",
          "supplier": "Fournisseur : %{supplier}"
        },
        "show": {
          "add_product_variant": "Ajouter un variant",
          "colorless_variants": "Variantes sans couleur",
          "disable_all": "Désactiver tout",
          "disable_color_confirmation": "Désactiver toutes les variantes de la couleur %{color} ?",
          "duplicate_for_store": "Dupliquer pour %{store}",
          "duplicate_for_store_confirmation": "Dupliquer le produit et tous ses variants pour la boutique %{store} ?",
          "enable_all": "Activer tout",
          "enable_color_confirmation": "Activer toutes les variantes de la couleur %{color} ?",
          "title": "Produit %{product}",
          "variants": "Variantes"
        },
        "update": {
          "title": "Modification du produit %{product}"
        }
      },
      "promo_codes": {
        "edit": {
          "title": "Modification du code promo %{promo_code}"
        },
        "form": {
          "information": "Informations générales",
          "promo_code_enabled_help": "Les codes promo inactifs ne sont pas utilisables sur les boutiques.",
          "select_a_store": "Sélectionnez une boutique"
        },
        "index": {
          "title": "Codes promo"
        },
        "new": {
          "title": "Nouveau code promo"
        },
        "promo_code": {
          "code_type": "Type : %{type}",
          "created_at": "Créé le : %{date}",
          "delete_confirmation": "Supprimer le code promo %{promo_code} ?",
          "utilizations": "Utilisations : %{value}",
          "value": "Valeur : %{value}"
        },
        "show": {
          "title": "Code promo %{promo_code}"
        }
      },
      "search": {
        "index": {
          "search_results": "Résultats de recherche pour %{query}",
          "title": "Résultats de recherche pour %{query}"
        }
      },
      "stores": {
        "edit": {
          "title": "Modification de la boutique %{store}"
        },
        "form": {
          "add_field": "Ajouter un champ",
          "advanced_customization_enabled_help": "Affiche l'outil de personnalisation avancée sur la boutique.",
          "allow_search_engines_help": "Autoriser les moteurs de recherche à indexer cette boutique.",
          "billing_address": "Adresse facturation",
          "custom_fields": "Champs personnalisés",
          "customization": {
            "advanced_customization_price": "Prix personnalisation avancée",
            "advanced_customization_price_per_element": "Prix avancée par élément",
            "back": "Activer le dos",
            "back_price": "Prix dos",
            "both_sleeves_price": "Prix deux manches",
            "chest": "Activer la poitrine",
            "chest_and_back_price": "Prix poitrine + dos",
            "chest_price": "Prix poitrine",
            "heart": "Activer le cœur",
            "heart_and_back_price": "Prix cœur + dos",
            "heart_price": "Prix cœur",
            "left_sleeve": "Activer la manche gauche",
            "prices_help": "Prix en euros, hors taxe (ex. 4,58)",
            "right_sleeve": "Activer la manche droite",
            "sleeve_price": "Prix une manche",
            "title": "Personnalisation par emplacement"
          },
          "customization_enabled_help": "Affiche l'outil de personnalisation sur la boutique.",
          "delete_banner": "Supprimer la bannière",
          "delete_banner_confirmation": "Supprimer la bannière de la boutique ?",
          "delete_mobile_banner": "Supprimer la bannière mobile",
          "delete_mobile_banner_confirmation": "Supprimer la bannière mobile de la boutique ?",
          "delivery_enabled_help": "Active l'option de livraison pour les commandes.",
          "dns_setup_documentation_html": "Créez un enregistrement <code>CNAME</code> pointant vers <code>%{target}<c/ode> dans la zone DNS de votre domaine.",
          "information": "Informations générales",
          "mobile_banner_help": "Image affichée uniquement sur mobile, remplaçant le message texte de la bannière.",
          "payment_and_billing": "Paiement et facturation",
          "remove_field": "Retirer",
          "shipping_address": "Adresse de livraison",
          "store_enabled_help": "Les boutiques inactives restent cachées.",
          "supplier_orders_enabled_help": "Active l'envoie automatique des commandes au fournisseur.",
          "urls": "URLs",
          "use_shipping_address": "Identique livraison"
        },
        "index": {
          "title": "Boutiques"
        },
        "new": {
          "title": "Nouvelle boutique"
        },
        "product": {
          "delete_confirmation": "Désactiver le produit %{product} de la boutique ?",
          "deleting": "Désactivation en cours...",
          "product_since": "Depuis le %{date}",
          "store_product": "Spécifique à %{store}",
          "variants": {
            "one": "1 variante",
            "other": "%{count} variantes",
            "zero": "Aucune variante"
          }
        },
        "show": {
          "add_admin": "Ajouter",
          "add_product": "Ajouter",
          "no_matching_products": "Aucun produit ne correspond à votre recherche.",
          "products": "Produits",
          "search_products": "Rechercher un produit par nom ou référence",
          "select_a_new_admin": "Sélectionnez un nouvel administrateur",
          "select_a_new_product": "Sélectionnez un nouveau produit",
          "sort": "Trier",
          "store_admins": "Administrateurs",
          "store_products": "Produits actifs",
          "title": "Boutique %{store}"
        },
        "sort_products": {
          "title": "Trier les produits"
        },
        "user": {
          "admin_since": "Depuis le %{date}",
          "delete_confirmation": "Supprimer l'administrateur %{user} de la boutique ?"
        }
      },
      "users": {
        "edit": {
          "title": "Modification de l'utilisateur %{user}"
        },
        "form": {
          "authentication": "Authentification",
          "information": "Informations générales"
        },
        "index": {
          "title": "Utilisateurs"
        },
        "new": {
          "title": "Nouvel utilisateur"
        },
        "show": {
          "title": "Utilisateur %{user}"
        },
        "user": {
          "created_at": "Créé(e) le : %{date}",
          "delete_confirmation": "Supprimer l'utilisateur %{user} ?",
          "email": "Email : %{email}",
          "user_type": "Type : %{type}"
        }
      }
    },
    "back": "Retour",
    "cancel": "Annuler",
    "cancelled_by_admin": "Annulée par l'administrateur",
    "cart_items": {
      "cart_item": {
        "color": "Couleur",
        "delete_confirmation": "Supprimer %{product_variant} de votre panier?",
        "no_stock_warning": "Nous n'avons plus cet article en stock.",
        "quantity": "Quantité",
        "size": "Taille",
        "stock_warning": "Nous n'avons que %{current_stock} articles en stock."
      }
    },
    "carts": {
      "show": {
        "delivery": "Livraison",
        "discount": "Remise",
        "my_cart": "Mon panier",
        "next": "Suivant",
        "ok": "OK",
        "processing": "Traitement...",
        "title": "Panier",
        "to_be_defined": "à définir",
        "total": "Total",
        "total_items": {
          "one": "1 article",
          "other": "%{count} articles",
          "zero": "Aucun article"
        },
        "vat_rounding_adjustment": "Arrondi TVA"
      }
    },
    "controllers": {
      "addresses": {
        "update": {
          "notice": "Adresse mise à jour."
        }
      },
      "admin": {
        "orders": {
          "cancel": {
            "notice": "Commande annulée."
          },
          "ship": {
            "notice": "Commande marquée comme disponible pour le retrait.",
            "payment_amount_mismatch": "Le montant encaissé sur Stripe ne correspond pas à la commande. L'expédition et la facture sont suspendues ; vérifiez le paiement avant de réessayer.",
            "payment_verification_unavailable": "La vérification du paiement Stripe est temporairement indisponible. La commande n'a pas été expédiée ni facturée ; réessayez plus tard."
          }
        },
        "parcels": {
          "create": {
            "notice": "Colis créé.",
            "payment_amount_mismatch": "Le montant encaissé sur Stripe ne correspond pas à la commande. Le colis et la facture sont suspendus ; vérifiez le paiement avant de réessayer.",
            "payment_verification_unavailable": "La vérification du paiement Stripe est temporairement indisponible. Le colis n'a pas été créé ni facturé ; réessayez plus tard."
          },
          "update": {
            "notice": "Colis mis à jour.",
            "payment_amount_mismatch": "Le montant encaissé sur Stripe ne correspond pas à la commande. Le colis et la facture sont suspendus ; vérifiez le paiement avant de réessayer.",
            "payment_verification_unavailable": "La vérification du paiement Stripe est temporairement indisponible. Le colis n'a pas été modifié ni facturé ; réessayez plus tard."
          }
        },
        "product_categories": {
          "create": {
            "alert": "Echec de création de la catégorie.",
            "notice": "Catégorie créée."
          },
          "destroy": {
            "notice": "Catégorie supprimée."
          },
          "update": {
            "alert": "Echec de mise à jourt de la catégorie.",
            "notice": "Catégorie mise à jour."
          }
        },
        "product_colors": {
          "create": {
            "alert": "Echec de création de la couleur.",
            "notice": "Couleur créée."
          },
          "destroy": {
            "notice": "Couleur supprimée."
          },
          "destroy_image": {
            "notice": "Image supprimée."
          },
          "update": {
            "alert": "Echec de mise à jourt de la couleur.",
            "notice": "Couleur mise à jour."
          }
        },
        "product_variant_customizations": {
          "destroy": {
            "notice": "Personnalisation supprimée."
          }
        },
        "product_variants": {
          "create": {
            "alert": "Echec de création de la variante.",
            "notice": "Variante créée."
          },
          "destroy": {
            "notice": "Variante supprimée."
          },
          "destroy_image": {
            "notice": "Image supprimée."
          },
          "front": {
            "notice": "Variante mise en avant."
          },
          "update": {
            "alert": "Echec de mise à jour de la variante.",
            "notice": "Variante mise à jour."
          }
        },
        "products": {
          "create": {
            "alert": "Echec de création du produit.",
            "notice": "Produit créé."
          },
          "destroy": {
            "notice": "Produit supprimé."
          },
          "destroy_image": {
            "notice": "Image supprimée."
          },
          "disable_color": {
            "notice": "Toutes les variantes de couleur %{color} ont été désactivées pour cette boutique."
          },
          "duplicate": {
            "notice": "Produit dupliqué."
          },
          "enable_color": {
            "notice": "Toutes les variantes de couleur %{color} ont été activées pour cette boutique."
          },
          "update": {
            "alert": "Echec de mise à jour du produit.",
            "notice": "Produit mis à jour."
          }
        },
        "promo_codes": {
          "create": {
            "alert": "Echec de création du code promo.",
            "notice": "Code promo créé."
          },
          "destroy": {
            "notice": "Code promo supprimé ou désactivé (si déjà utilisé au moins une fois)."
          },
          "update": {
            "notice": "Code promo mis à jour."
          }
        },
        "stores": {
          "add_admin": {
            "notice": "Administrateur boutique ajouté."
          },
          "add_product": {
            "notice": "Produit en cours d'ajouté sur la boutique."
          },
          "create": {
            "alert": "Echec de création de la boutique.",
            "notice": "Boutique créée."
          },
          "current": {
            "notice": "Boutique sélectionnée."
          },
          "destroy": {
            "alert": "Impossible de supprimer la boutique. Vérifiez ses commandes et factures.",
            "notice": "Boutique supprimée."
          },
          "destroy_banner": {
            "notice": "Bannière supprimée."
          },
          "destroy_mobile_banner": {
            "notice": "Bannière mobile supprimée."
          },
          "remove_admin": {
            "notice": "Administrateur boutique supprimé. 👋"
          },
          "remove_product": {
            "notice": "Produit en cours de désactivation sur la boutique."
          },
          "update": {
            "alert": "Echec de mise à jour de la boutique.",
            "notice": "Boutique mise à jour."
          }
        },
        "users": {
          "create": {
            "alert": "Echec de création de l'utilisateur.",
            "notice": "Utilisateur créé."
          },
          "destroy": {
            "notice": "Utilisateur supprimé."
          },
          "update": {
            "alert": "Echec de mise à jourt de l'utilisateur.",
            "notice": "Utilisateur mis à jour."
          }
        }
      },
      "application": {
        "user_not_authorized": "Vous n'êtes pas autorisé à effectuer cette action."
      },
      "cart_items": {
        "create": {
          "notice": "%{product} ajouté au panier."
        },
        "destroy": {
          "notice": "%{product} supprimé."
        },
        "update": {
          "notice": "%{product} mis à jour."
        }
      },
      "carts": {
        "checkout": {
          "alert": "Votre panier est vide.",
          "notice": "Commande créée."
        },
        "update": {
          "notice": "Panier mis à jour."
        }
      },
      "erp": {
        "access_denied": "Vous n'avez pas accès à ce module.",
        "design": {
          "proofs": {
            "destroy_file": {
              "file_removed": "Visuel supprimé",
              "not_editable": "Ce BAT n'est plus modifiable ; créez une révision pour le modifier."
            },
            "revision": {
              "revision_created": "Nouvelle version du BAT créée"
            },
            "send_to_customer": {
              "sent": "BAT envoyé au client pour validation"
            },
            "submit_for_approval": {
              "submitted": "BAT soumis au commercial pour approbation"
            },
            "update": {
              "not_editable": "Ce BAT n'est plus modifiable ; créez une révision pour le modifier.",
              "updated": "BAT enregistré"
            }
          }
        },
        "production": {
          "supply_orders": {
            "order": {
              "ordered": "Commande passée au fournisseur."
            },
            "receive": {
              "received": "Réception enregistrée."
            }
          }
        },
        "sales": {
          "customer_addresses": {
            "create": {
              "notice": "Adresse créée avec succès"
            },
            "destroy": {
              "notice": "Adresse supprimée avec succès"
            },
            "update": {
              "notice": "Adresse modifiée avec succès"
            }
          },
          "customer_assets": {
            "create": {
              "notice": "Fichier ajouté avec succès"
            },
            "destroy": {
              "notice": "Fichier supprimé avec succès"
            },
            "update": {
              "notice": "Fichier modifié avec succès"
            }
          },
          "customer_bank_accounts": {
            "create": {
              "notice": "Compte bancaire créé avec succès"
            },
            "destroy": {
              "notice": "Compte bancaire supprimé avec succès"
            },
            "update": {
              "notice": "Compte bancaire modifié avec succès"
            }
          },
          "customer_contacts": {
            "create": {
              "notice": "Contact créé avec succès"
            },
            "destroy": {
              "notice": "Contact supprimé avec succès"
            },
            "update": {
              "notice": "Contact modifié avec succès"
            }
          },
          "customer_product_prices": {
            "create": {
              "notice": "Tarif créé"
            },
            "destroy": {
              "notice": "Tarif supprimé"
            },
            "update": {
              "notice": "Tarif modifié"
            }
          },
          "customers": {
            "add_marking_position": {
              "label_required": "Le libellé est requis"
            },
            "create": {
              "notice": "Client créé avec succès"
            },
            "destroy": {
              "notice": "Client supprimé avec succès"
            },
            "update": {
              "notice": "Client modifié avec succès"
            }
          },
          "estimate_assets": {
            "create": {
              "notice": "Document(s) ajouté(s) au devis"
            },
            "destroy": {
              "notice": "Document retiré du devis"
            }
          },
          "estimate_proofs": {
            "approve": {
              "sent": "BAT approuvé et envoyé au client"
            },
            "requirement": {
              "not_required": "La PAO enverra le BAT directement au client",
              "required": "Le BAT de ce devis partira après votre approbation"
            },
            "return_to_studio": {
              "returned": "BAT renvoyé à la PAO"
            }
          },
          "estimate_templates": {
            "create": {
              "notice": "Modèle créé avec succès"
            },
            "destroy": {
              "notice": "Modèle supprimé avec succès"
            },
            "duplicate": {
              "notice": "Modèle dupliqué avec succès"
            },
            "update": {
              "notice": "Modèle modifié avec succès"
            }
          },
          "estimates": {
            "create": {
              "notice": "Devis créé avec succès"
            },
            "destroy": {
              "notice": "Devis supprimé avec succès"
            },
            "duplicate": {
              "duplicated": "Devis dupliqué avec succès"
            },
            "lose": {
              "lost": "Devis marqué comme perdu"
            },
            "revert": {
              "reverted": "Action annulée avec succès"
            },
            "send_estimate": {
              "no_email": "Impossible d'envoyer le devis sans destinataire. Cochez un contact ou saisissez une adresse.",
              "sent": "Devis envoyé au client"
            },
            "send_to_pao": {
              "sent_to_pao": "Devis envoyé en conception"
            },
            "start_production": {
              "production_started": "Affaire passée en production"
            },
            "update": {
              "notice": "Devis modifié avec succès"
            },
            "validate_estimate": {
              "validated": "Devis validé avec succès"
            },
            "validate_production": {
              "production_validated": "Production validée avec succès"
            }
          },
          "marking_catalogues": {
            "update": {
              "notice": "Référentiel mis à jour avec succès"
            }
          },
          "printing_price_grids": {
            "add_extra": {
              "notice": "Supplément ajouté"
            },
            "add_row": {
              "notice": "Ligne ajoutée à la grille"
            },
            "destroy_extra": {
              "notice": "Supplément supprimé"
            },
            "destroy_row": {
              "notice": "Ligne supprimée de la grille"
            },
            "entries_updated": {
              "notice": "Tarifs mis à jour avec succès"
            }
          },
          "product_variants": {
            "refresh_price": {
              "failed": "Échec de la mise à jour du prix Imbretex",
              "no_price": "Aucun prix retourné par Imbretex pour cette référence",
              "not_imbretex": "La référence n'est pas un produit Imbretex"
            }
          },
          "products": {
            "update": {
              "notice": "Produit modifié avec succès"
            },
            "update_marking_capabilities": {
              "notice": "Compatibilités mises à jour avec succès"
            },
            "update_size_aliases": {
              "notice": "Correspondances de tailles mises à jour avec succès"
            }
          }
        }
      },
      "order_items": {
        "create": {
          "notice": "%{product} ajouté au panier."
        }
      },
      "orders": {
        "checkout": {
          "notice": "Commande créée, choisissez un mode de livraison."
        },
        "payment": {
          "alert": "Veuillez remplir vos informations de livraison et de facturation avant de passer à la paiement.",
          "discount_exceeds_items": "La remise dépasse le montant des articles. Retirez ce code promo pour continuer.",
          "invalid_billing_siren": "Vérifiez le SIREN de facturation avant de payer, ou laissez ce champ vide.",
          "invalid_billing_vat_number": "Vérifiez le numéro de TVA de facturation avant de payer, ou laissez ce champ vide.",
          "missing_billing_siren": "Renseignez le SIREN de votre société française ou un numéro de TVA français valide avant de payer.",
          "stock_unavailable": "Le stock disponible a changé. Veuillez ajuster votre panier avant de réessayer.",
          "stripe_error": "Une erreur est survenue lors de la création du paiement. Veuillez réessayer.",
          "too_many_checkout_line_items": "Ce panier contient trop de lignes pour le paiement en ligne. Répartissez les articles sur plusieurs commandes.",
          "unsupported_vat_exemption": "Le mode de livraison et l'adresse de facturation ne permettent pas de confirmer l'exonération de TVA. Contactez-nous avant de payer."
        },
        "update": {
          "notice": "Commande mise à jour."
        }
      },
      "store_admin": {
        "orders": {
          "cancel": {
            "notice": "Commande annulée."
          }
        },
        "product_variants": {
          "create": {
            "alert": "Echec de création de la variante.",
            "notice": "Variante créée."
          },
          "destroy": {
            "notice": "Variante supprimée."
          },
          "destroy_image": {
            "notice": "Image supprimée."
          },
          "front": {
            "notice": "Variante mise en avant."
          },
          "update": {
            "alert": "Echec de mise à jour de la variante.",
            "notice": "Variante mise à jour."
          }
        },
        "products": {
          "create": {
            "alert": "Echec de création du produit.",
            "notice": "Produit créé."
          },
          "destroy": {
            "notice": "Produit supprimé."
          },
          "destroy_image": {
            "notice": "Image supprimée."
          },
          "disable_color": {
            "notice": "Toutes les variantes de couleur %{color} ont été désactivées pour cette boutique."
          },
          "duplicate": {
            "notice": "Produit dupliqué."
          },
          "enable_color": {
            "notice": "Toutes les variantes de couleur %{color} ont été activées pour cette boutique."
          },
          "update": {
            "alert": "Echec de mise à jour du produit.",
            "notice": "Produit mis à jour."
          }
        },
        "promo_codes": {
          "create": {
            "alert": "Echec de création du code promo.",
            "notice": "Code promo créé."
          },
          "destroy": {
            "notice": "Code promo supprimé ou désactivé (si déjà utilisé au moins une fois)."
          },
          "update": {
            "notice": "Code promo mis à jour."
          }
        },
        "stores": {
          "add_product": {
            "notice": "Produit en cours d'ajouté sur la boutique."
          },
          "current": {
            "notice": "Boutique sélectionnée."
          },
          "destroy_banner": {
            "notice": "Bannière supprimée."
          },
          "destroy_mobile_banner": {
            "notice": "Bannière mobile supprimée."
          },
          "remove_product": {
            "notice": "Produit en cours de désactivation sur la boutique."
          },
          "update": {
            "alert": "Echec de mise à jour de la boutique.",
            "notice": "Boutique mise à jour."
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dim",
        "lun",
        "mar",
        "mer",
        "jeu",
        "ven",
        "sam"
      ],
      "abbr_month_names": [
        null,
        "jan.",
        "fév.",
        "mars",
        "avr.",
        "mai",
        "juin",
        "juil.",
        "août",
        "sept.",
        "oct.",
        "nov.",
        "déc."
      ],
      "day_names": [
        "dimanche",
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "long": "%-d %B %Y",
        "short": "%-d %b"
      },
      "month_names": [
        null,
        "janvier",
        "février",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "août",
        "septembre",
        "octobre",
        "novembre",
        "décembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "environ une heure",
          "other": "environ %{count} heures"
        },
        "about_x_months": {
          "one": "environ un mois",
          "other": "environ %{count} mois"
        },
        "about_x_years": {
          "one": "environ un an",
          "other": "environ %{count} ans"
        },
        "almost_x_years": {
          "one": "presque un an",
          "other": "presque %{count} ans"
        },
        "half_a_minute": "une demi‑minute",
        "less_than_x_minutes": {
          "one": "moins d'une minute",
          "other": "moins de %{count} minutes",
          "zero": "moins d'une minute"
        },
        "less_than_x_seconds": {
          "one": "moins d'une seconde",
          "other": "moins de %{count} secondes",
          "zero": "moins d'une seconde"
        },
        "over_x_years": {
          "one": "plus d'un an",
          "other": "plus de %{count} ans"
        },
        "x_days": {
          "one": "%{count} jour",
          "other": "%{count} jours"
        },
        "x_minutes": {
          "one": "%{count} minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "%{count} mois",
          "other": "%{count} mois"
        },
        "x_seconds": {
          "one": "%{count} seconde",
          "other": "%{count} secondes"
        },
        "x_years": {
          "one": "%{count} an",
          "other": "%{count} ans"
        }
      },
      "prompts": {
        "day": "Jour",
        "hour": "Heure",
        "minute": "Minute",
        "month": "Mois",
        "second": "Seconde",
        "year": "Année"
      }
    },
    "delete": "Supprimer",
    "devise": {
      "confirmations": {
        "confirmed": "Votre compte a été validé.",
        "new": {
          "or_continue_with": "ou continuer avec",
          "resend_confirmation_info": "Envoyer les instructions",
          "title": "Compte non confirmé ?"
        },
        "send_instructions": "Vous allez recevoir les instructions nécessaires à la confirmation de votre compte dans quelques minutes.",
        "send_paranoid_instructions": "Si votre e-mail existe dans notre base de données, vous allez bientôt recevoir un e-mail contenant les instructions de confirmation de votre compte."
      },
      "failure": {
        "already_authenticated": "Vous êtes déjà connecté.",
        "inactive": "Votre compte n'est pas encore activé.",
        "invalid": "Email et/ou mot de passe incorrect(s).",
        "last_attempt": "Vous avez droit à une tentative avant que votre compte ne soit verrouillé.",
        "locked": "Votre compte est verrouillé.",
        "not_found_in_database": "Email et/ou mot de passe incorrect(s).",
        "timeout": "Votre session est expirée. Veuillez vous reconnecter pour continuer.",
        "unauthenticated": "Vous devez vous connecter ou vous inscrire pour continuer.",
        "unconfirmed": "Vous devez valider votre compte pour continuer."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirmer mon email",
          "greeting": "Bienvenue %{recipient} !",
          "instruction": "Vous pouvez confirmer votre email grâce au lien ci-dessous :",
          "subject": "Instructions de confirmation"
        },
        "email_changed": {
          "greeting": "Bonjour %{recipient} !",
          "message": "Nous vous contactons pour vous informer que votre email a été changé en %{email}.",
          "message_unconfirmed": "Nous vous contactons pour vous informer que votre email est en train d'être changé par %{email}.",
          "subject": "Email modifié"
        },
        "password_change": {
          "greeting": "Bonjour %{recipient} !",
          "message": "Nous vous contactons pour vous notifier que votre mot de passe a été modifié.",
          "subject": "Mot de passe modifié"
        },
        "reset_password_instructions": {
          "action": "Changer mon mot de passe",
          "greeting": "Bonjour %{recipient} !",
          "instruction": "Quelqu'un a demandé un lien pour changer votre mot de passe, le voici :",
          "instruction_2": "Si vous n'avez pas émis cette demande, merci d'ignorer cet email.",
          "instruction_3": "Votre mot de passe ne changera pas tant que vous n'aurez pas cliqué sur ce lien et renseigné un nouveau mot de passe.",
          "subject": "Instructions pour changer le mot de passe"
        },
        "unlock_instructions": {
          "action": "Débloquer mon compte",
          "greeting": "Bonjour %{recipient} !",
          "instruction": "Suivez ce lien pour débloquer votre compte :",
          "message": "Votre compte a été bloqué suite à un nombre d'essais de connexions manquées trop important.",
          "subject": "Instructions pour déverrouiller le compte"
        }
      },
      "omniauth_callbacks": {
        "failure": "Nous n'avons pas pu vous authentifier via %{kind} : '%{reason}'.",
        "success": "Authentifié avec succès via %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Modifier mon mot de passe",
          "confirm_new_password": "Confirmer le nouveau mot de passe",
          "minimum_password_length": "Minimum de %{count} caractères",
          "new_password": "Nouveau mot de passe",
          "or_continue_with": "ou continuer avec",
          "title": "Modifier mon mot de passe"
        },
        "new": {
          "or_continue_with": "ou continuer avec",
          "send_password_reset_info": "Envoyer les instructions",
          "title": "Mot de passe oublié ?"
        },
        "no_token": "Vous ne pouvez accéder à cette page sans passer par un e-mail de réinitialisation de mot de passe. Si vous êtes passé par un e-mail de ce type, assurez-vous d'utiliser l'URL complète.",
        "send_instructions": "Vous allez recevoir les instructions de réinitialisation du mot de passe dans quelques instants.",
        "send_paranoid_instructions": "Si votre e-mail existe dans notre base de données, vous allez recevoir un lien de réinitialisation par e-mail.",
        "updated": "Votre mot de passe a été édité avec succès, vous êtes maintenant connecté.",
        "updated_not_active": "Votre mot de passe a été changé avec succès."
      },
      "registrations": {
        "destroyed": "Votre compte a été supprimé avec succès. Nous espérons vous revoir bientôt.",
        "new": {
          "already_a_member": "Déjà inscrit ?",
          "minimum_password_length": "Minimum de %{count} caractères",
          "or_continue_with": "ou continuer avec",
          "sign_up": "Inscription",
          "signin_to_your_account": "Connectez vous.",
          "title": "Inscription"
        },
        "signed_up": "Bienvenue, vous êtes connecté.",
        "signed_up_but_inactive": "Vous êtes bien enregistré. Vous ne pouvez cependant pas vous connecter car votre compte n'est pas encore activé.",
        "signed_up_but_locked": "Vous êtes bien enregistré. Vous ne pouvez cependant pas vous connecter car votre compte est verrouillé.",
        "signed_up_but_unconfirmed": "Un message contenant un lien de confirmation a été envoyé à votre adresse email. Ouvrez ce lien pour activer votre compte.",
        "update_needs_confirmation": "Votre compte a bien été mis à jour mais nous devons vérifier votre nouvelle adresse email. Merci de vérifier vos emails et de cliquer sur le lien de confirmation pour finaliser la validation de votre nouvelle adresse.",
        "updated": "Votre compte a été modifié avec succès.",
        "updated_but_not_signed_in": "Votre compte a été modifié avec succès. Merci de vous reconnecter."
      },
      "sessions": {
        "already_signed_out": "Déconnecté.",
        "new": {
          "not_a_member": "Pas encore inscrit ?",
          "or": "ou",
          "or_continue_with": "ou continuer avec",
          "remember_me": "Rester connecté",
          "sign_in": "Connexion",
          "signup": "Inscrivez-vous",
          "title": "Connexion"
        },
        "signed_in": "Ravi de vous revoir ! 👋",
        "signed_out": "A bientôt ! 👋"
      },
      "shared": {
        "links": {
          "didnt_receive_confirm_info": "Informations de confirmation non reçues ?",
          "didnt_receive_unlock_info": "Informations de déverrouillage non reçues ?",
          "forgot_password": "Mot de passe oublié ?",
          "signin": "Connexion",
          "signup": "Inscription"
        }
      },
      "unlocks": {
        "new": {
          "or_continue_with": "ou continuer avec",
          "resend_unlock_instructions": "Envoyer les instructions",
          "title": "Compte verrouillé ?"
        },
        "send_instructions": "Vous allez recevoir les instructions nécessaires au déverrouillage de votre compte dans quelques instants.",
        "send_paranoid_instructions": "Si votre compte existe, vous allez bientôt recevoir un email contenant les instructions pour le déverrouiller.",
        "unlocked": "Votre compte a été déverrouillé avec succès, vous êtes maintenant connecté."
      }
    },
    "display_period": "Période d'affichage",
    "edit": "Modifier",
    "erp": {
      "accounting": {
        "dashboard": {
          "index": {
            "title": "Pilotage Comptabilité"
          }
        }
      },
      "action_bar": {
        "add_button_component": {
          "add": "Ajouter"
        }
      },
      "administration": {
        "dashboard": {
          "index": {
            "title": "Pilotage Administration"
          }
        }
      },
      "alert": {
        "component": {
          "info": "Information :",
          "warn": "Attention :"
        }
      },
      "badge": {
        "chip_component": {
          "more": {
            "one": "1 autre",
            "other": "%{count} autres"
          }
        },
        "status_component": {
          "design": "En conception",
          "draft": "Brouillon",
          "lost": "Perdu",
          "pending": "Non validé",
          "sent": "En cours",
          "won": "Affaire validée"
        }
      },
      "confirm_dialog": {
        "component": {
          "cancel": "Annuler"
        }
      },
      "dashboard": {
        "index": {
          "title": "Tableau de bord"
        }
      },
      "deliveries": {
        "reminder": "Relance n°%{number}",
        "role": {
          "approver": "Approbateur",
          "information": "Pour information"
        },
        "status": {
          "dead": "Échec définitif",
          "delivered": "Envoyé",
          "delivering": "En cours d'envoi",
          "failed": "Échec, nouvel essai prévu",
          "queued": "En attente"
        }
      },
      "design": {
        "dashboard": {
          "index": {
            "title": "Pilotage Graphisme"
          }
        },
        "proofs": {
          "errors": {
            "approval_not_required": "Ce devis ne demande pas d'approbation commerciale : envoyez le BAT directement au client.",
            "approval_required": "Ce devis demande l'approbation du commercial avant l'envoi : soumettez le BAT au commercial.",
            "no_files": "Impossible d'envoyer le BAT sans visuel. Ajoutez au moins un fichier.",
            "no_recipient": "Impossible d'envoyer le BAT : aucune adresse email renseignée pour ce client.",
            "not_in_design": "Le BAT n'est disponible que pour une affaire en conception.",
            "return_comment_required": "Indiquez à la PAO ce qu'il faut reprendre."
          },
          "sales_approval": {
            "approved": "Approuvé et envoyé au client par %{name} le %{date}.",
            "pending": "BAT soumis par %{submitter} le %{date}, en attente de l'approbation de %{name}.",
            "required": "Ce BAT doit être approuvé par %{name} avant de partir : soumettez-le, %{name} l'enverra au client.",
            "returned": "Renvoyé à la PAO par %{name} le %{date}"
          },
          "send_dialog": {
            "approver": "Approbateur du BAT",
            "confirm": "Envoyer le BAT",
            "from_primary_contact": "Contact principal : %{name}",
            "information": "Pour information",
            "information_hint": "Ces destinataires reçoivent le BAT sans validation à donner ; seul l'approbateur le valide, et il ne reçoit qu'un email même s'il est coché ici.",
            "intro": "Le BAT de l'affaire %{reference} va être envoyé pour validation.",
            "no_email": "Aucun email n'est renseigné pour ce client — saisissez-en un pour envoyer.",
            "submission": {
              "confirm": "Soumettre au commercial",
              "intro": "Le BAT de l'affaire %{reference} attend l'approbation de %{name}, qui l'enverra à ces destinataires.",
              "title": "Soumettre le BAT au commercial"
            },
            "title": "Envoyer le BAT au client"
          },
          "show": {
            "attached_visuals": "Visuels joints",
            "back_to_estimate": "Retour au devis",
            "browse": "Parcourir",
            "confirm_remove_file": "Supprimer ce visuel du BAT ?",
            "create_revision": "Créer une révision",
            "deliveries": "Envois et relances du BAT v%{version}",
            "download": "Télécharger le fichier",
            "dropzone_hint": "Glissez-déposez vos fichiers ici ou",
            "files": "Visuels (images / PDF)",
            "history": "Historique des versions",
            "internal_note": "Note interne",
            "locked": "Ce BAT n'est plus modifiable (déjà envoyé ou approuvé). Créez une révision pour le modifier.",
            "locked_pending_approval": "Ce BAT attend l'approbation du commercial : il n'est plus modifiable tant qu'il ne vous est pas renvoyé.",
            "remove_file": "Supprimer le visuel",
            "save": "Enregistrer",
            "send_to_customer": "Envoyer au client",
            "submit_for_approval": "Soumettre au commercial",
            "title": "Bon À Tirer (BAT)"
          }
        },
        "public_proofs": {
          "action_impossible": "Cette action n'est plus possible pour ce BAT.",
          "approved": "Merci ! Le BAT a été approuvé. La production peut démarrer.",
          "revision_requested": "Votre demande de révision a bien été transmise au studio.",
          "show": {
            "already_responded": "Vous avez déjà répondu à ce BAT.",
            "approval_label": "Commentaire (optionnel)",
            "approve": "Approuver le BAT",
            "for_information": "Ce BAT vous est transmis pour information : sa validation est demandée à l'approbateur désigné.",
            "request_revision": "Demander une révision",
            "revision_label": "Votre demande de modification",
            "title": "Bon À Tirer à valider",
            "version": "Version %{number}"
          }
        }
      },
      "design_system": {
        "chrome": {
          "footer": "Footer",
          "modules": "Header et footer, couleur du module",
          "page_head": "En-tête de page",
          "sample_alert": "L’enregistrement a échoué",
          "sample_notice": "Modification enregistrée",
          "sample_status": "Statut de la page",
          "sample_subtitle": "Une phrase qui dit ce que l’on fait sur cette page.",
          "sample_title": "Titre de page",
          "title": "Chrome",
          "toasts": "Toasts"
        },
        "colors": {
          "accents": "Noir, accent et danger",
          "lines": "Filets",
          "modules": "Modules",
          "statuses": {
            "design": "En conception",
            "draft": "Brouillon",
            "lost": "Perdu",
            "pending": "Non validé",
            "sent": "En cours",
            "title": "Statuts",
            "won": "Affaire validée"
          },
          "surfaces": "Surfaces",
          "text": "Texte",
          "title": "Couleurs"
        },
        "data": {
          "add": "Ajouter",
          "all_periods": "Toutes les périodes",
          "badges": "Badges",
          "chip": "Coloris %{index}",
          "column_actions": "Actions",
          "column_amount": "Montant",
          "column_name": "Nom",
          "column_status": "Statut",
          "confirm_accept": "Confirmer l’action",
          "confirm_dialog": "Fenêtre de confirmation",
          "confirm_text": "Une phrase qui dit ce qui va se passer.",
          "confirm_title": "Confirmer cette action ?",
          "empty_message": "Les éléments créés apparaîtront ici.",
          "empty_title": "Aucun élément",
          "filters": "Barre d’actions et filtres",
          "kpi_dark": "Indicateur sombre",
          "kpi_hint": "Une précision sur le chiffre",
          "kpi_label": "Indicateur %{index}",
          "kpis": "Indicateurs",
          "marking_chip": "Marquage",
          "menu_advance": "Faire avancer",
          "menu_delete": "Supprimer",
          "menu_download": "Télécharger",
          "menu_duplicate": "Dupliquer",
          "menu_label": "Plus d’actions pour l’élément 1",
          "menu_open": "Ouvrir",
          "menu_view": "Consulter",
          "modal": "Fenêtre",
          "modal_intro": "Une phrase qui dit ce que l’on fait dans cette fenêtre.",
          "modal_save": "Enregistrer",
          "modal_title": "Titre de la fenêtre",
          "modal_xl": "Grande fenêtre",
          "modal_xl_title": "Grande fenêtre",
          "overlays": "Menu, confirmation et fenêtres",
          "panel_tabs": "Onglets à panneaux",
          "person": "Alex Durand",
          "reset": "Réinitialiser",
          "row": "Élément %{index}",
          "search_placeholder": "Rechercher…",
          "section_meta": "3 éléments",
          "section_title": "Titre de section",
          "status_tabs": "Statuts",
          "tab": "Onglet %{index}",
          "tab_panel": "Contenu de l’onglet %{index}.",
          "table": "Tableau",
          "tabs": "Onglets",
          "tags": {
            "alert": "En retard",
            "b2b": "Professionnel",
            "b2c": "Particulier",
            "info": "Chorus",
            "new": "Nouveau",
            "warn": "À compléter"
          },
          "title": "Navigation, données et surcouches",
          "toggle": "Mes éléments",
          "turbo_confirm": "Confirmation Turbo"
        },
        "forms": {
          "alert_text": "Le message explique la situation et ce que l’on peut faire.",
          "alert_title": "Titre en gras.",
          "alerts": "Alertes",
          "buttons": "Boutons",
          "card": "Carte de consultation",
          "card_field": "Libellé",
          "card_section": "Groupe de cartes",
          "check_card": "Carte à cocher",
          "check_card_description": "Une phrase qui précise la conséquence du choix.",
          "checklist": "Checklist",
          "choices": "Choix",
          "close": "Fermer",
          "days": "%{count} j",
          "disabled": "Désactivé",
          "disabled_value": "Valeur non modifiable",
          "edit": "Modifier",
          "error": "Saisissez une adresse email valide.",
          "fields": "Champs",
          "file_field": "Fichier",
          "form_section": "Section de formulaire",
          "form_section_text": "ERP::Form::SectionComponent, son icône dans la pastille, et ses actions.",
          "hint": "Une précision sous le champ.",
          "info_note": "Note d’information, sans icône.",
          "invalid": "Champ en erreur",
          "link": "Lien",
          "more_actions": "Plus d’actions",
          "option": "Option %{index}",
          "panel_help": "Une phrase qui dit ce que l’on renseigne dans ce bloc.",
          "panel_locked": "Bloc verrouillé",
          "panel_locked_help": "Validez d’abord le bloc précédent.",
          "panel_optional": "Bloc facultatif",
          "panel_summary_html": "<b>Résumé</b> du bloc une fois validé",
          "panel_title": "Titre du bloc",
          "panel_validate": "Valider et continuer",
          "panels": "Panneaux",
          "pill_radio": "Pilules (emplacement)",
          "pill_radio_sm": "Pilules (type)",
          "placeholder": "Texte d’aide dans le champ",
          "recap": "Récapitulatif",
          "recap_pieces": "%{count} pcs",
          "recap_settings": "Paramètres",
          "recap_subtotal": "Total HT",
          "recap_term": "Ligne %{index}",
          "recap_title": "Récapitulatif",
          "recap_total": "Total TTC",
          "search_placeholder": "Rechercher…",
          "searchable_select": "Liste avec recherche",
          "segmented": "Contrôle segmenté",
          "select": "Liste déroulante",
          "small": "Petite taille",
          "text_area": "Zone de texte",
          "text_field": "Champ texte",
          "title": "Formulaires et actions",
          "variants": {
            "accent": "Accent",
            "danger": "Danger",
            "ghost": "Secondaire",
            "primary": "Principal"
          },
          "with_icon": "Avec icône"
        },
        "radii": {
          "pill": "Pilule",
          "title": "Rayons"
        },
        "shadows": {
          "card": "cartes et panneaux",
          "hover": "survol des cartes",
          "title": "Ombres"
        },
        "show": {
          "intro": "Référence visuelle de l'ERP : chaque token et chaque composant, rendus avec les utilitaires Tailwind du design system. Réservée aux administrateurs.",
          "title": "Design system"
        },
        "typography": {
          "block_title": "Titre de bloc",
          "body": "Corps",
          "label": "Label majuscule",
          "meta": "Méta",
          "page_title": "Titre de page",
          "sample": "Portez les couleurs de votre équipe",
          "title": "Typographie"
        }
      },
      "footer_bar": {
        "container_component": {
          "created_at_by": "Créé le %{date} par %{user}",
          "updated_at_by": "Dernière modification le %{date} par %{user}"
        },
        "icon_button_component": {
          "add": "Ajouter",
          "close": "Retour",
          "delete": "Supprimer",
          "duplicate": "Dupliquer",
          "edit": "Modifier",
          "history": "Historique",
          "pdf": "PDF"
        },
        "save": "Enregistrer",
        "system": "Système"
      },
      "form": {
        "actions": {
          "cancel": "Annuler",
          "submit": "Enregistrer"
        },
        "errors": {
          "title": {
            "one": "%{count} erreur a empêché l'enregistrement",
            "other": "%{count} erreurs ont empêché l'enregistrement"
          }
        }
      },
      "inventory": {
        "dashboard": {
          "index": {
            "title": "Pilotage Inventaire"
          }
        }
      },
      "js": {
        "confirm": {
          "accept": "Confirmer",
          "cancel": "Annuler"
        }
      },
      "logistics": {
        "dashboard": {
          "index": {
            "title": "Pilotage Logistique"
          }
        }
      },
      "modal": {
        "component": {
          "close": "Fermer"
        }
      },
      "panel": {
        "component": {
          "optional": "facultatif"
        }
      },
      "pdf_viewer": {
        "component": {
          "close": "Fermer l’aperçu",
          "download": "Télécharger",
          "error": "Le PDF n’a pas pu être généré. Vérifiez la tarification du devis.",
          "loading": "Chargement du PDF…",
          "new_tab": "Nouvel onglet",
          "send": "Envoyer au client"
        }
      },
      "production": {
        "dashboard": {
          "index": {
            "affaires": "Affaires en production",
            "columns": {
              "actions": "Actions",
              "customer": "Client",
              "outstanding": "Reste à recevoir",
              "reference": "Affaire",
              "status": "Statut",
              "supply_orders": "Commandes",
              "textiles": "Textiles"
            },
            "empty": "Aucune affaire n'est encore entrée en production.",
            "textiles_pending": "En attente",
            "textiles_received": "Reçus le %{date}",
            "title": "Pilotage Production"
          }
        },
        "supply_orders": {
          "committed": "Cette commande a été passée au fournisseur (%{status}) : elle ne peut plus être supprimée.",
          "frozen_line": "Cette commande a été passée au fournisseur : %{attributes} ne peut plus être modifié. Ouvrez une seconde commande pour le reliquat.",
          "frozen_line_create": "Cette commande a été passée au fournisseur : aucune ligne ne peut plus y être ajoutée. Ouvrez une seconde commande.",
          "frozen_line_destroy": "Cette commande a été passée au fournisseur : ses lignes ne peuvent plus être supprimées.",
          "frozen_order": "Cette commande a été passée au fournisseur : %{attributes} ne peut plus être modifié.",
          "index": {
            "columns": {
              "actions": "Actions",
              "expected_at": "Attendu le",
              "lines": "Lignes",
              "ordered": "Commandé",
              "outstanding": "Reste",
              "received": "Reçu",
              "status": "Statut",
              "supplier": "Fournisseur"
            },
            "empty": "Aucune commande d'approvisionnement pour cette affaire.",
            "stale": "(stock non rafraîchi)",
            "textiles_received": "Textiles reçus le %{date}",
            "title": "Approvisionnement"
          },
          "invalid_quantity": "« %{value} » n'est pas une quantité entière.",
          "invalid_transition": "Action impossible sur une commande au statut %{status}.",
          "negative_delta": "Une quantité reçue doit être positive. Pour corriger une saisie, reprenez la commande à zéro.",
          "negative_reception": "Une quantité reçue ne peut pas être négative.",
          "never_refreshed": "Cette commande a été rouverte sans consulter le fournisseur : les quantités en stock ci-dessous sont les dernières valeurs connues.",
          "no_lines": "Cette commande ne contient aucune ligne : il n'y a rien à commander.",
          "no_production_order": "Cette affaire n'est pas encore entrée en production.",
          "not_in_production": "Cette affaire n'est plus en production : sa commande ne peut plus être passée.",
          "over_reception": "%{reference} : %{received} reçus pour %{ordered} commandés. Corrigez la saisie.",
          "show": {
            "columns": {
              "color": "Couleur",
              "ordered": "Commandé",
              "outstanding": "Reste",
              "received": "Reçu",
              "reception": "Réception",
              "reference": "Référence",
              "size": "Taille",
              "supplier_stock": "Stock fournisseur"
            },
            "confirm_order": "Passer cette commande au fournisseur ? Les quantités ne seront plus modifiables.",
            "empty": "Cette commande ne contient aucune ligne.",
            "expected_at": "attendu le %{date}",
            "external_id": "Réf. fournisseur %{id}",
            "order": "Commander",
            "receive": "Enregistrer la réception",
            "reception_hint": "Laissez vide une ligne qui n'a rien reçu.",
            "reception_label": "Quantité reçue pour %{reference}",
            "stock_as_of": "au %{date}",
            "stock_manual": "Fournisseur non connecté",
            "stock_never_refreshed": "jamais rafraîchi",
            "stock_stale": "Le stock fournisseur n'a pas pu être rafraîchi à la création de cette commande : les quantités en stock ci-dessous sont les dernières valeurs connues.",
            "stock_unknown": "Référence hors catalogue",
            "title": "Commande fournisseur"
          },
          "unknown_lines": "Ces lignes n'appartiennent pas à cette commande (%{ids}). Rechargez la page."
        }
      },
      "recap": {
        "checklist_component": {
          "done": "(fait)"
        }
      },
      "recipient_choices": {
        "customer_record": "Fiche client",
        "other": "Autres adresses",
        "other_hint": "Séparez les adresses par une virgule."
      },
      "sales": {
        "common": {
          "actions": "Actions",
          "back": "Retour",
          "bat_not_approved": "Mise en production impossible : le BAT n'est pas encore approuvé par le client",
          "cancel": "Annuler",
          "close": "Fermer",
          "confirm_delete": "Êtes-vous sûr de vouloir supprimer cet élément ?",
          "created": "Créé avec succès",
          "delete": "Supprimer",
          "deleted": "Supprimé avec succès",
          "download_file": "Télécharger %{name}",
          "duplication_failed": "La duplication a échoué : %{error}",
          "edit": "Modifier",
          "files_expired": "Les fichiers ont expiré. Veuillez les renvoyer.",
          "invalid_file": "Format de fichier non autorisé ou taille supérieure à 20 Mo. Aucun document n’a été ajouté.",
          "invalid_transition": "Transition impossible depuis le statut « %{status} »",
          "move_down": "Descendre",
          "move_up": "Monter",
          "next_section": "Section suivante",
          "on_quote": "Sur devis",
          "open_image": "Agrandir l’image de %{name}",
          "pdf_generation_failed": "Le PDF n’a pas pu être généré : les totaux de ce devis sont incohérents. L’incident a été signalé.",
          "previous_section": "Section précédente",
          "quantity": "Quantité",
          "revert_impossible": "Annulation impossible après 1 heure",
          "save": "Enregistrer",
          "updated": "Modifié avec succès"
        },
        "csv": {
          "name": "Nom",
          "price_excl_tax": "Prix HT",
          "quantity": "Quantité",
          "reference": "Référence",
          "size": "Taille",
          "sofidial_price_excl_tax": "Prix SOFIDIAL HT",
          "supplier_price_excl_tax": "Prix fournisseur HT",
          "variant_id": "ID Variante",
          "version_id": "ID Version"
        },
        "customer_addresses": {
          "edit": {
            "title": "Modifier l'adresse"
          },
          "index": {
            "billing": "Facturation",
            "columns": {
              "actions": "Actions",
              "address": "Adresse",
              "city": "Ville",
              "country": "Pays",
              "denomination": "Dénomination",
              "type": "Type"
            },
            "confirm_delete": "Êtes-vous sûr de vouloir supprimer cette adresse ?",
            "new": "Nouvelle adresse",
            "no_addresses": "Aucune adresse enregistrée",
            "primary": "Principale",
            "shipping": "Livraison",
            "title": "Adresses"
          },
          "new": {
            "title": "Nouvelle adresse"
          }
        },
        "customer_assets": {
          "edit": {
            "title": "Modifier le fichier"
          },
          "form": {
            "autosubmit_hint": "Les fichiers seront enregistrés automatiquement une fois l'envoi terminé.",
            "browse": "Parcourir",
            "category": "Catégorie",
            "description": "Description",
            "dropzone_hint": "Glissez-déposez vos fichiers ici ou",
            "file": "Fichier",
            "file_hint": "Formats acceptés : AI, images, PDF, Word. Taille max : 20 Mo.",
            "information": "Informations du fichier",
            "name": "Nom"
          },
          "index": {
            "all_categories": "Toutes les catégories",
            "columns": {
              "actions": "Actions",
              "category": "Catégorie",
              "date": "Date",
              "name": "Nom",
              "preview": "Aperçu",
              "size": "Taille",
              "type": "Type"
            },
            "confirm_delete": "Êtes-vous sûr de vouloir supprimer ce fichier ?",
            "no_assets": "Aucun fichier dans la bibliothèque",
            "reset_filters": "Réinitialiser",
            "title": "Bibliothèque"
          },
          "new": {
            "title": "Ajouter un fichier"
          }
        },
        "customer_bank_accounts": {
          "edit": {
            "title": "Modifier le compte bancaire"
          },
          "form": {
            "account_number": "N° de compte",
            "bank_code": "Code banque",
            "bank_info": "Informations bancaires",
            "branch_code": "Code guichet",
            "domestic_section": "National (RIB)",
            "international_section": "International (IBAN/BIC)",
            "options": "Options",
            "rib_key": "Clé RIB"
          },
          "index": {
            "columns": {
              "actions": "Actions",
              "bank_name": "Banque",
              "bic": "BIC",
              "domiciliation": "Domiciliation",
              "iban": "IBAN",
              "type": "Type"
            },
            "confirm_delete": "Êtes-vous sûr de vouloir supprimer ce compte bancaire ?",
            "international": "International",
            "new": "Nouveau compte",
            "no_bank_accounts": "Aucun compte bancaire enregistré",
            "primary": "Principal",
            "title": "Comptes bancaires"
          },
          "new": {
            "title": "Nouveau compte bancaire"
          }
        },
        "customer_contacts": {
          "edit": {
            "title": "Modifier le contact"
          },
          "form": {
            "active": "Actif",
            "fax": "Fax",
            "invoice_default_hint": "Son email devient l’email de facturation de la fiche.",
            "options": "Options",
            "phone_1": "Téléphone 1",
            "phone_2": "Téléphone 2"
          },
          "index": {
            "columns": {
              "actions": "Actions",
              "email": "Email",
              "function": "Fonction",
              "name": "Nom",
              "phone": "Téléphone",
              "status": "Statut"
            },
            "confirm_delete": "Êtes-vous sûr de vouloir supprimer ce contact ?",
            "inactive": "Inactif",
            "invoice_default": "Facture par défaut",
            "new": "Nouveau contact",
            "no_contacts": "Aucun contact enregistré",
            "primary": "Principal",
            "title": "Contacts"
          },
          "new": {
            "title": "Nouveau contact"
          }
        },
        "customer_estimates": {
          "accept_impossible": "Ce devis ne peut plus être accepté.",
          "accepted": "Devis accepté avec succès.",
          "artwork_pending_from_customer": "Visuel à fournir par le client",
          "pdf_unavailable": "Le PDF de ce devis n’a pas pu être établi. Contactez votre commercial, qui vous le transmettra.",
          "pricing_subgroups": {
            "all": "Tous les textiles",
            "color": "Textiles couleur",
            "colored": "Textiles couleur",
            "white": "Textiles blancs"
          },
          "reject_impossible": "Ce devis ne peut plus être refusé.",
          "rejected": "Devis refusé."
        },
        "customer_product_prices": {
          "edit": {
            "title": "Modifier le tarif"
          },
          "form": {
            "product": "Produit du catalogue",
            "product_hint": "Tapez au moins deux caractères.",
            "product_placeholder": "Rechercher par nom ou référence",
            "section": "Tarif",
            "unit_price": "Prix unitaire HT (€)",
            "unit_price_hint": "Le même prix pour toutes les couleurs et toutes les tailles."
          },
          "index": {
            "columns": {
              "actions": "Actions",
              "product": "Produit",
              "reference": "Référence",
              "unit_price": "Prix unitaire HT"
            },
            "confirm_delete": "Supprimer ce tarif ?",
            "intro": "Un prix unitaire HT fixe par produit du catalogue, toutes couleurs et tailles. Sur un devis de ce client, il remplace coefficient × prix fournisseur ; il reste modifiable à la ligne.",
            "new": "Nouveau tarif",
            "no_product_prices": "Aucun tarif client",
            "title": "Tarifs"
          },
          "new": {
            "title": "Nouveau tarif"
          }
        },
        "customers": {
          "chorus": "Chorus",
          "edit": {
            "title": "Modifier le client"
          },
          "form": {
            "address_line": "Adresse",
            "administrative": "Administratif",
            "archived": "Archivé",
            "chorus_hint": "Facultatifs, pour une administration facturée sur Chorus Pro.",
            "city": "Ville",
            "civility": "Civilité",
            "comments": "Commentaires",
            "commitment_number": "N° d’engagement",
            "contact": "Contact",
            "country": "Pays",
            "default_global_discount_percentage": "Remise globale par défaut (%)",
            "default_global_discount_percentage_hint": "Reprise sur les nouveaux devis de ce client, sans approbation.",
            "denomination": "Dénomination",
            "email": "Email",
            "family": "Famille",
            "first_name": "Prénom",
            "information": "Informations",
            "last_name": "Nom",
            "legal_form": "Forme juridique",
            "naf_code": "Code NAF",
            "not_assigned": "Non assigné",
            "payment_delay_days": "Délai de paiement (jours)",
            "payment_delay_days_placeholder": "Ex : 30",
            "payment_method": "Mode de paiement",
            "payment_method_hint": "Repris par défaut sur les nouveaux devis de ce client.",
            "payment_section": "Conditions de paiement",
            "payment_terms": "Conditions de paiement",
            "payment_terms_placeholder": "Ex : paiement à 30 jours fin de mois…",
            "phone_fixed": "Fixe",
            "phone_mobile": "Portable",
            "pole": "Pôle",
            "postal_code": "Code postal",
            "pricing": "Tarification",
            "primary_address": "Adresse principale",
            "responsible": "Responsable",
            "select_payment_method": "Sélectionner...",
            "service_code": "Code service",
            "siret": "SIRET",
            "status": "Statut",
            "textile_margin_rate": "Coefficient textile",
            "textile_margin_rate_hint": "Coefficient appliqué au prix fournisseur. Par défaut : %{default_rate}",
            "vat_number": "N° TVA",
            "website": "Site web"
          },
          "incomplete_profile": "Fiche à compléter",
          "index": {
            "active": "Actif",
            "add_customer": "Ajouter un nouveau client",
            "all_families": "Toutes les familles",
            "city_placeholder": "Ville",
            "columns": {
              "account_number": "ID",
              "actions": "Actions",
              "city": "Ville",
              "contact": "Contact",
              "denomination": "Dénomination client",
              "family": "Famille",
              "status": "Statut"
            },
            "export_csv": "Exporter en CSV",
            "export_pdf": "Exporter en PDF",
            "footer": {
              "customers": {
                "one": "1 client",
                "other": "%{count} clients",
                "zero": "Aucun client"
              }
            },
            "hide_archived": "Masquer archivés",
            "new": "Nouveau client",
            "no_customers": "Aucun client trouvé",
            "reset": "Réinitialiser",
            "search": "Rechercher",
            "search_placeholder": "Rechercher un client",
            "title": "Clients"
          },
          "new": {
            "title": "Nouveau client"
          },
          "profile_fields": {
            "address": "adresse complète (adresse, code postal, ville et pays)",
            "denomination": "dénomination",
            "email": "email",
            "family": "famille",
            "phone": "téléphone (portable ou fixe)",
            "siret": "SIRET"
          },
          "profile_missing_fields": "À renseigner : %{fields}.",
          "show": {
            "back": "Retour",
            "confirm_delete": "Êtes-vous sûr de vouloir supprimer ce client ?",
            "created_at": "Créé le %{date}",
            "created_at_by": "Client créé le %{date} par %{user}",
            "delete": "Supprimer",
            "edit": "Modifier",
            "fields": {
              "address": "Adresse",
              "city": "Ville",
              "civility": "Civilité",
              "commitment_number": "N° d’engagement",
              "country": "Pays",
              "default_global_discount": "Remise globale par défaut",
              "denomination": "Dénomination",
              "email": "Email",
              "family": "Famille",
              "first_name": "Prénom",
              "invoice_email": "Email de facturation",
              "last_name": "Nom",
              "legal_form": "Forme juridique",
              "mobile": "Portable",
              "naf_code": "Code NAF",
              "phone": "Fixe",
              "pole": "Pôle",
              "postal_code": "CP",
              "responsible": "Responsable",
              "service_code": "Code service",
              "siret": "SIRET",
              "vat_number": "N° TVA",
              "website": "Site web"
            },
            "loading": "Chargement...",
            "no_comments": "Aucun commentaire",
            "no_default_global_discount": "Aucune",
            "not_assigned": "Non assigné",
            "save": "Enregistrer",
            "sections": {
              "administrative": "Administratif",
              "comments": "Commentaires",
              "contact": "Contact",
              "customer_details": "Coordonnées client",
              "identity": "Contact principal",
              "information": "Informations",
              "primary_address": "Adresse principale",
              "responsible": "Responsable"
            },
            "status": {
              "archived": "Archivé",
              "label": "Statut"
            },
            "tab_addresses": "Adresses",
            "tab_appointments": "RDV",
            "tab_assets": "Bibliothèque",
            "tab_bank_accounts": "Comptes bancaires",
            "tab_contacts": "Contacts",
            "tab_estimates": "Devis",
            "tab_management": "Gestion",
            "tab_pricing": "Tarification",
            "tab_product_prices": "Tarifs",
            "tab_record": "Fiche",
            "tabs_label": "Sections de la fiche client",
            "title": "Fiche client",
            "updated_at": "Modifié le %{date}",
            "updated_at_by": "Dernière modification le %{date} par %{user}"
          }
        },
        "dashboard": {
          "index": {
            "active_customers": "Clients Actifs",
            "average_margin": "Marge Moyenne",
            "estimates_in_progress": "Devis en Cours",
            "no_recent_estimates": "Aucun devis récent",
            "no_upcoming_appointments": "Aucun rendez-vous à venir",
            "on_validated": "Sur devis validés",
            "recent_estimates": "Devis Récents",
            "recent_estimates_subtitle": "Suivi des derniers devis en cours",
            "scheduled_appointments": "RDV Planifiés",
            "this_week": "Cette semaine",
            "title": "Tableau de bord",
            "total_of": "Sur un total de %{count} clients",
            "upcoming_appointments": "RDV à Venir",
            "upcoming_appointments_subtitle": "Suivi des rendez-vous à venir",
            "value": "Valeur: %{amount}",
            "view_more": "Voir plus"
          }
        },
        "estimate_assets": {
          "index": {
            "add_to_library": "Ajouter à la bibliothèque du client",
            "confirm_unlink": "Retirer ce document du devis ?",
            "from_library": "Depuis la bibliothèque",
            "library_badge": "Bibliothèque",
            "no_documents": "Aucun document joint",
            "title": "Documents du devis",
            "upload_category": "Catégorie",
            "upload_file": "Télécharger un fichier",
            "upload_file_label": "Fichier",
            "upload_name": "Nom du fichier",
            "upload_submit": "Ajouter"
          },
          "library": {
            "empty_library": "La bibliothèque du client est vide",
            "link_selected": "Lier les fichiers sélectionnés"
          },
          "save_first": "Enregistrez le devis pour ajouter des documents"
        },
        "estimate_templates": {
          "edit": {
            "title": "Modifier le modèle"
          },
          "form": {
            "active": "Actif",
            "cancel": "Annuler",
            "description": "Description",
            "name": "Nom",
            "save": "Enregistrer",
            "validity_days": "Durée de validité (jours)"
          },
          "index": {
            "active": "Actif",
            "columns": {
              "actions": "Actions",
              "description": "Description",
              "name": "Nom",
              "status": "Statut",
              "validity_days": "Validité"
            },
            "inactive": "Inactif",
            "new": "Nouveau modèle",
            "no_templates": "Aucun modèle trouvé",
            "title": "Modèles de devis",
            "validity": {
              "one": "%{count} j",
              "other": "%{count} j"
            }
          },
          "new": {
            "title": "Nouveau modèle"
          },
          "show": {
            "days": "jours",
            "delete": "Supprimer",
            "description": "Description",
            "duplicate": "Dupliquer",
            "edit": "Modifier",
            "items": "Lignes prédéfinies",
            "no_items": "Aucune ligne prédéfinie",
            "title": "Modèle %{name}",
            "use_template": "Utiliser ce modèle",
            "validity": {
              "one": "Validité : %{count} jour",
              "other": "Validité : %{count} jours"
            },
            "validity_days": "Durée de validité"
          }
        },
        "estimates": {
          "approvals": {
            "approve": "Approuver",
            "decision_reason": "Motif de décision",
            "history": {
              "one": "Historique (%{count})",
              "other": "Historique (%{count})"
            },
            "notices": {
              "approved": "Approbation accordée",
              "auto_approved": "Approbation enregistrée",
              "rejected": "Approbation refusée",
              "requested": "Approbation demandée"
            },
            "pending": {
              "one": "%{count} approbation à obtenir avant l’envoi",
              "other": "%{count} approbations à obtenir avant l’envoi"
            },
            "ready": "Toutes les approbations requises sont accordées.",
            "reason": "Motif",
            "reject": "Refuser",
            "request": "Demander",
            "request_and_approve": "Demander et auto-approuver",
            "statuses": {
              "approved": "Approuvée",
              "invalidated": "Invalidée",
              "pending": "En attente",
              "rejected": "Refusée"
            },
            "title": "Approbations",
            "types": {
              "compatibility_override": "Compatibilité forcée",
              "complimentary": "Gratuité",
              "custom_marking_zone": "Zone personnalisée",
              "customer_supplied_textile": "Textile client",
              "discount_over_threshold": "Remise exceptionnelle",
              "manual_price": "Prix manuel"
            }
          },
          "compatibility_warnings": {
            "line": "%{marking} · %{textile} : compatibilité non renseignée — à vérifier au BAT.",
            "title": "À vérifier au BAT"
          },
          "customer_history": {
            "columns": {
              "description": "Description",
              "image": "Image",
              "marking": "Marquage",
              "quantity": "Qté",
              "reference": "Réf.",
              "unit_price": "PU HT"
            },
            "items_count": {
              "one": "%{count} article",
              "other": "%{count} articles"
            },
            "no_history": "Aucun historique pour ce client.",
            "reimport": "Réimporter",
            "table_scroll_region": "Lignes du devis %{reference}. Faites défiler horizontalement pour voir toutes les colonnes.",
            "title": "Historique — %{customer}",
            "wait_for_save": "Attendez la fin de l’enregistrement avant de réimporter une ligne."
          },
          "delivery_history": {
            "revision": "Révision %{number}",
            "title": "Envois et relances"
          },
          "discount_types": {
            "fixed": "Montant fixe",
            "percentage": "Pourcentage"
          },
          "edit": {
            "autosave_active": "Sauvegarde automatique active",
            "customer_history_button": "Historique & Anciennes commandes",
            "title": "Modifier le devis"
          },
          "editor": {
            "checklist": {
              "blocking": {
                "one": "%{count} point à régler avant l’envoi",
                "other": "%{count} points à régler avant l’envoi"
              },
              "groups": {
                "estimate": "Devis"
              },
              "items": {
                "customer": "Client choisi",
                "information": "Titre et validité",
                "markings": "Marquages définis",
                "textiles": "Au moins un textile"
              },
              "no_size": "non renseignée",
              "pricing": {
                "extra": "Option %{code} : %{reason}",
                "extras": {
                  "inactive": "désactivée",
                  "invalid_price": "tarif négatif",
                  "missing": "absente des grilles",
                  "missing_percentage": "pourcentage manquant",
                  "missing_price": "sans tarif",
                  "wrong_customer_type": "indisponible pour ce client",
                  "wrong_technique": "incompatible avec la technique",
                  "zero_price_requires_complimentary": "prix nul"
                },
                "fallback": "Prix à vérifier",
                "reasons": {
                  "above_maximum": "Quantité au-dessus du dernier palier",
                  "ambiguous_grid": "Plusieurs grilles tarifaires possibles",
                  "below_minimum": "Quantité sous le premier palier",
                  "customer_supplied_requires_approval": "Textile client à faire approuver",
                  "inconsistent_subgroup_brackets": "Paliers blanc et couleur incohérents",
                  "invalid_margin_rate": "Coefficient inférieur à 1",
                  "invalid_price": "Prix négatif dans la grille",
                  "manual_price_requires_approval": "Prix forcé à faire approuver",
                  "missing_customer": "Client manquant",
                  "missing_dimensions": "Couleurs, format ou points à choisir",
                  "missing_margin_rate": "Coefficient client absent",
                  "missing_price": "Prix absent de la grille",
                  "missing_quantity": "Aucune pièce associée",
                  "missing_supplier_cost": "Coût fournisseur absent",
                  "missing_textile_classification": "Coloris ni blanc ni couleur",
                  "missing_tier": "Aucun palier pour cette quantité",
                  "mixed_supplier_costs": "Coûts fournisseur différents selon les tailles",
                  "no_grid": "Aucune grille tarifaire",
                  "pricing_not_calculated": "Prix pas encore calculé",
                  "quote_required": "Prix sur devis, à forcer",
                  "size_allocations_required": "Répartition par taille à faire",
                  "zero_net_requires_complimentary": "Total nul après remise",
                  "zero_price_requires_complimentary": "Prix nul, à déclarer offert"
                },
                "subgroups": {
                  "all": "tous textiles",
                  "colored": "textile couleur",
                  "white": "textile blanc"
                },
                "with_subgroup": "%{label} (%{subgroup})"
              },
              "ready": "Prêt à l’envoi.",
              "reasons": {
                "approval_missing": "Approbation « %{type} » à obtenir",
                "canonical_size_missing": "Taille %{size} inconnue du catalogue",
                "compatibility_blocked": "%{textile} : %{reason}",
                "dimensions_missing": "Format à choisir",
                "duplicate_marking_series": "Même série que %{markings} : regrouper ou distinguer",
                "empty_estimate": "Aucune ligne chiffrée ni offerte",
                "global_discount_exceeds_subtotal": "Remise supérieure au sous-total",
                "invalid_allocation": "%{textile}, taille %{size} : répartition à corriger",
                "marking_zone_ambiguous": "Deux zones renseignées, n’en garder qu’une",
                "marking_zone_missing": "Zone de marquage à choisir",
                "textile_sizes_missing": "Quantités par taille à saisir",
                "validity_expired": "Date de validité dépassée",
                "validity_missing": "Date de validité à renseigner"
              },
              "title": "Checklist d’envoi",
              "unknown_textile": "Textile inconnu"
            },
            "customer": {
              "change": "Changer",
              "create": "Créer un nouveau client",
              "create_hint": "Sans quitter le devis",
              "create_named": "Créer le client « %{name} »",
              "estimates_count": {
                "one": "%{count} devis",
                "other": "%{count} devis"
              },
              "first_estimate": "Premier devis",
              "grid_title": "Grille tarifaire appliquée à ce devis",
              "grids": {
                "direct": "Tarif direct",
                "reseller": "Tarif revendeur"
              },
              "new_tag": "Nouveau client",
              "no_match": "Aucun client ne correspond à « %{query} ».",
              "payment": "Paiement : %{method}",
              "recent": "Vos clients récents"
            },
            "footer": {
              "back": "Retour aux devis",
              "new_status": "Brouillon non enregistré"
            },
            "general": {
              "choose_customer_first": "Choisissez d’abord un client",
              "customer_create": "Créer un nouveau client",
              "customer_missing": "Client absent de la liste ?",
              "customer_placeholder": "Rechercher un client par nom ou ville…",
              "customer_results": "Clients",
              "days": {
                "one": "%{count} j",
                "other": "%{count} j"
              },
              "edit": "Modifier",
              "help": "Le client est obligatoire : ses tarifs préférentiels s’appliquent aux textiles et aux marquages.",
              "missing": "Il manque :",
              "missing_fields": {
                "customer": "le client",
                "title": "le titre",
                "validity": "la date de validité"
              },
              "ready": "Tout est bon.",
              "save": "Enregistrer les informations",
              "title": "Informations générales",
              "title_hint": "Visible par le client sur le devis.",
              "title_label": "Titre du devis",
              "title_placeholder": "Ex. Tenues saison 2026-2027",
              "valid_until": "valable jusqu’au",
              "validate": "Valider et passer aux textiles",
              "validity_shortcuts": "Durée de validité"
            },
            "head": {
              "new_subtitle": "Remplissez les blocs dans l’ordre. Le brouillon est créé à la validation des informations générales."
            },
            "markings": {
              "help": "Ajoutez un marquage puis choisissez les textiles concernés.",
              "locked": "Disponible une fois les informations générales validées : chaque marquage s’applique à un ou plusieurs textiles."
            },
            "new_customer": {
              "address": "Adresse",
              "address_placeholder": "N° et rue",
              "cancel": "Annuler",
              "city": "Ville",
              "denomination": "Nom ou raison sociale",
              "email": "Email",
              "failed": "Le client n’a pas pu être créé. Réessayez dans un instant.",
              "family": "Type de client",
              "family_hint": "Un revendeur reçoit la grille revendeur ; les professionnels, les particuliers et les administrations, la grille directe.",
              "first_name": "Prénom du contact",
              "intro": "Le strict nécessaire pour faire le devis. La fiche pourra être complétée ensuite dans Clients.",
              "last_name": "Nom du contact",
              "more": "Plus d’informations (facultatif)",
              "phone": "Téléphone",
              "postal_code": "Code postal",
              "siret": "SIRET",
              "submit": "Créer et sélectionner",
              "title": "Nouveau client"
            },
            "notes": {
              "customer_note": "Note pour le client",
              "customer_note_placeholder": "Apparaît sur le devis envoyé.",
              "help": "Une note pour le client, une note interne ou des documents.",
              "internal_note": "Note interne",
              "internal_note_placeholder": "Visible uniquement par l’équipe.",
              "locked": "Disponible une fois les informations générales validées."
            },
            "recap": {
              "customer": "Client",
              "grid": "Grille tarifaire",
              "label": "Récapitulatif du devis",
              "payment_hint": "Repris de la fiche client une fois le client choisi."
            },
            "save_errors": {
              "allocation_below_personalized_piece": "%{group} : la pièce %{piece} de la taille %{size} de %{textile} est personnalisée, gardez au moins %{piece} pièces",
              "allocation_exceeds_size": {
                "one": "%{group} : %{count} pièce sur la taille %{size} de %{textile}, qui n’en a que %{limit}",
                "other": "%{group} : %{count} pièces sur la taille %{size} de %{textile}, qui n’en a que %{limit}"
              },
              "estimate": "Devis",
              "fallback": "Devis : une donnée saisie ne peut pas être enregistrée",
              "generic": "%{group} : %{message}",
              "no_size": "non renseignée",
              "section": "Section %{number} · %{name}",
              "size_below_markings": {
                "one": "%{group} : %{count} pièce y est marquée, la quantité ne peut pas descendre en dessous",
                "other": "%{group} : %{count} pièces y sont marquées, la quantité ne peut pas descendre en dessous"
              },
              "size_of": "%{textile} · taille %{size}",
              "unknown_textile": "Textile inconnu",
              "unnamed": "sans nom"
            },
            "save_state": {
              "error": "Enregistrement impossible",
              "modified": "Modifications non enregistrées",
              "saved": "Enregistré",
              "saving": "Enregistrement…"
            },
            "textiles": {
              "help": "Ajoutez les textiles du devis. Les prix tiennent compte de la grille du client.",
              "locked": "Validez d’abord les informations générales : les prix dépendent du client."
            }
          },
          "form": {
            "add_section": "Ajouter une section",
            "add_textile": "Ajouter un textile",
            "already_marked": "Produit déjà marqué",
            "applied_tier": "Palier appliqué :",
            "artwork_missing": "Fichier non reçu",
            "artwork_pending_from_customer": "Visuel à fournir par le client",
            "artwork_pending_from_customer_hint": "Cochez cette case si le client doit encore transmettre le visuel après l’établissement du devis.",
            "artwork_version": "Révision du fichier de marquage",
            "artwork_version_hint": "Numéro interne du visuel reçu. Incrémentez-le lorsque le fichier client est remplacé afin de conserver la traçabilité du devis envoyé.",
            "billing_address": "Adresse de facturation",
            "cancel": "Annuler",
            "change_product": "changer",
            "columns": {
              "reference": "Référence",
              "sizes": "Tailles & qté"
            },
            "compatibility_check_pending": "À vérifier",
            "complimentary_marking": "Marquage offert",
            "complimentary_textile": "Textile offert",
            "custom_marking_zone_approval": "Une zone personnalisée nécessite une approbation avant envoi.",
            "custom_marking_zone_placeholder": "Ex. Bas du dos, côté droit",
            "customer": "Client",
            "customer_files": "Fichiers client",
            "customer_main_address": "Adresse principale du client",
            "delete_line": "Supprimer la ligne",
            "delete_section": "Supprimer la section",
            "description": "Description",
            "dimension": "Dimension",
            "discount_amount": "Remise (€)",
            "discount_amount_per_piece": "Remise par pièce (€)",
            "discount_applied": "Remise appliquée",
            "discount_percentage": "Remise (%)",
            "discount_type": "Type de remise",
            "documents": "Documents",
            "edit_line": "Modifier la ligne",
            "erp_extras_hint": "Sélectionnez les frais applicables ; ils seront calculés une seule fois selon leur règle ERP.",
            "erp_extras_title": "Frais et options de marquage",
            "erp_fee": "Frais ERP — %{code}",
            "erp_only_source": "Source ERP",
            "extra_inactive": "Option désactivée dans l’ERP",
            "extra_names": {
              "perso_coeur": "Personnalisation cœur",
              "perso_dos": "Personnalisation dos",
              "personnalisation": "Personnalisation",
              "personnalisation_piece": "Personnalisation par pièce, petit emplacement",
              "personnalisation_piece_grand": "Personnalisation par pièce, grand emplacement"
            },
            "extra_price_fixed": "%{price} par série",
            "extra_price_missing": "Tarif ERP manquant",
            "extra_price_per_piece": "%{price} par pièce",
            "extra_price_percentage": "%{percentage} % du marquage",
            "extra_wrong_customer_type": "Cette option ne correspond plus au type de client sélectionné ; retirez-la ou rétablissez le client.",
            "extra_wrong_technique": "Cette option ne correspond plus à la technique sélectionnée ; retirez-la ou rétablissez la technique.",
            "force_compatibility": "Forcer une incompatibilité",
            "force_compatibility_hint": "À utiliser uniquement après validation technique ; une approbation sera requise.",
            "force_price": "Forcer le prix",
            "global_discount": "Remise globale",
            "global_discount_fixed_legacy": "Remise fixe de %{amount} reprise d’un ancien devis. Saisissez un pourcentage pour la remplacer.",
            "global_discount_none": "Aucune",
            "global_discount_other": "Autre",
            "global_discount_other_hint": "Hors 5 et 10 %, la remise globale demande une approbation avant l’envoi.",
            "global_discount_other_input": "Remise globale (%)",
            "items_subtotal": "Sous-total articles",
            "legacy_allocations_hint": "Ces associations utilisent encore l'ancien format. Répartissez-les par taille pour débloquer la tarification ERP.",
            "linked_textiles_section": "Textiles concernés",
            "manual_price_approval": "Un prix manuel nécessite une approbation avant envoi.",
            "manual_price_reason": "Motif du prix manuel",
            "margin_rate": "Coefficient",
            "marking_discount": "Remise sur ce marquage",
            "marking_position": "Emplacement",
            "marking_quantity": "Quantité marquée",
            "marking_quantity_hint": "Calculée depuis les textiles associés.",
            "marking_untyped": "Marquage",
            "markings_need_textiles": "Ajoutez d'abord des textiles pour y appliquer un marquage.",
            "new_line": "Nouvelle ligne",
            "no_erp_extras": "Aucun frais ERP actif pour cette technique et ce type de client.",
            "no_marking_discount": "Aucune remise",
            "no_markings": "Aucun marquage",
            "over_attached": "Quantité supérieure à celle du textile",
            "override_reason": "Motif du forçage",
            "payment_method": "Mode de paiement",
            "payment_method_from_customer": "Par défaut sur la fiche client : %{method}",
            "piece_count": {
              "one": "1 pièce",
              "other": "%{count} pièces"
            },
            "pieces": {
              "one": "%{count} pce",
              "other": "%{count} pcs"
            },
            "pricing_adjustments": "Ajustements facultatifs · TVA, remise, exceptions",
            "pricing_blocked_marking_title": "Tarification bloquée pour %{marking}",
            "pricing_blocked_title": "Tarification bloquée",
            "pricing_blocking_reason_details": {
              "above_maximum": "ce marquage contient %{quantity} ; le dernier palier s’arrête à %{maximum}. Ajoutez un palier dans la grille ERP ou activez « Forcer le prix ».",
              "below_minimum": "ce marquage contient %{quantity} ; le premier palier commence à %{minimum}. Augmentez la quantité marquée à %{minimum} ou activez « Forcer le prix ».",
              "stale": "ce marquage contient %{quantity}. La grille ERP a changé depuis ce calcul ; enregistrez le devis pour vérifier le palier actuel ou activez « Forcer le prix »."
            },
            "pricing_blocking_reasons": {
              "above_maximum": "Quantité supérieure au dernier palier. Ajoutez un palier supérieur ou forcez le prix avec un motif.",
              "ambiguous_grid": "Plusieurs tarifs ERP actifs correspondent à cette combinaison. Désactivez les grilles en doublon avant de recalculer.",
              "below_minimum": "Quantité inférieure au premier palier. Augmentez la quantité ou forcez le prix avec un motif.",
              "customer_supplied_requires_approval": "Textile fourni par le client non approuvé. Demandez puis faites valider cette exception dans la section Approbations.",
              "inconsistent_subgroup_brackets": "Paliers blanc et couleur incohérents. Alignez les bornes des deux sous-groupes dans la grille ERP.",
              "invalid_margin_rate": "Coefficient textile invalide (minimum 1). Saisissez une valeur supérieure ou égale à 1.",
              "invalid_price": "Prix négatif dans la grille ERP. Corrigez ce montant dans la grille puis recalculez le devis.",
              "manual_price_requires_approval": "Prix manuel non approuvé. Renseignez son motif puis faites valider cette exception dans la section Approbations.",
              "missing_customer": "Client manquant. Sélectionnez le client du devis avant de calculer les tarifs.",
              "missing_dimensions": "Paramètre de grille manquant. Sélectionnez le nombre de couleurs, le format ou le nombre de points demandé par la technique.",
              "missing_margin_rate": "Coefficient client absent. Renseignez le coefficient textile dans la fiche client ou sur cette ligne.",
              "missing_price": "Tarif absent dans la grille ERP. Renseignez le prix du palier correspondant puis recalculez le devis.",
              "missing_quantity": "Aucune quantité allouée. Associez le marquage à au moins une taille avec une quantité supérieure à zéro.",
              "missing_supplier_cost": "Coût fournisseur absent. Renseignez ou rafraîchissez le coût fournisseur du textile.",
              "missing_textile_classification": "Classification blanc ou couleur manquante. Classez le coloris dans le catalogue ou corrigez le textile sélectionné.",
              "missing_tier": "Aucun palier ne couvre cette quantité. Ajoutez un palier dans la grille ERP ou forcez le prix avec un motif.",
              "mixed_catalogue_prices": "Prix catalogue différents entre les tailles. Séparez ces variantes en lignes distinctes.",
              "mixed_supplier_costs": "Coûts fournisseur incohérents entre les tailles. Séparez les tailles dans des lignes tarifaires distinctes ou harmonisez leurs coûts.",
              "no_grid": "Grille tarifaire introuvable. Créez ou activez une grille correspondant à la technique et au type de client, ou forcez le prix avec un motif.",
              "pricing_not_calculated": "Tarification non calculée. Enregistrez le devis pour appliquer la grille ERP actuelle.",
              "quote_required": "Tarif configuré sur devis. Forcez le prix avec un motif après avoir obtenu le chiffrage nécessaire.",
              "size_allocations_required": "Répartition par taille requise. Ouvrez « Textiles associés » et allouez chaque quantité aux tailles concernées.",
              "zero_net_requires_complimentary": "Total net nul après remise. Déclarez la ligne offerte ou réduisez la remise.",
              "zero_price_requires_complimentary": "Prix nul non autorisé. Déclarez la ligne offerte ou saisissez un prix strictement positif."
            },
            "pricing_calculate_button": "Calculer le tarif",
            "pricing_calculate_hint": "Enregistre le devis et applique la grille ERP actuelle.",
            "pricing_choice": "Choix tarifaire",
            "pricing_choice_empty": "Choisissez d’abord une technique pour voir les tarifs.",
            "pricing_choice_hint": "Nombre de couleurs, format ou points selon la technique.",
            "pricing_choice_none": "Aucun paramètre",
            "pricing_choice_prototype": "Prototype",
            "pricing_choice_standard": "Standard",
            "pricing_color_plural": "couleurs",
            "pricing_color_singular": "couleur",
            "pricing_dimension": "Paramètre de grille ERP",
            "pricing_extra_blocking_reason": "Option %{code} : %{reason}",
            "pricing_extra_blocking_reasons": {
              "inactive": "désactivée dans l’ERP. Retirez cette option du marquage ou réactivez-la dans les grilles tarifaires.",
              "invalid_price": "montant négatif dans l’ERP. Renseignez un montant strictement positif, ou déclarez le marquage offert si cette option doit rester à zéro.",
              "missing": "absente des grilles tarifaires pour cette technique. Ajoutez-la dans la grille correspondante, ou retirez les pièces personnalisées du marquage.",
              "missing_percentage": "pourcentage absent dans l’ERP. Renseignez le pourcentage de cette option dans la grille correspondante.",
              "missing_price": "tarif absent dans l’ERP. Renseignez le montant de cette option dans la grille correspondante.",
              "wrong_customer_type": "indisponible pour ce type de client. Retirez cette option ou corrigez son périmètre client dans les grilles tarifaires.",
              "wrong_technique": "incompatible avec la technique sélectionnée. Retirez cette option ou rétablissez la technique pour laquelle elle a été configurée.",
              "zero_price_requires_complimentary": "prix nul. Déclarez le marquage offert ou renseignez un montant strictement positif."
            },
            "pricing_pending_hint": "Enregistrez le devis pour calculer le palier, les sous-groupes et les frais depuis les grilles ERP.",
            "pricing_recalculate_short": "À recalculer",
            "pricing_section": "Prix",
            "pricing_stale_error_link": "Voir l’erreur",
            "pricing_stale_on_conflict": "Tarif en attente : le devis a été enregistré ailleurs entre-temps.",
            "pricing_stale_on_error": "Tarif en attente : corrigez d’abord l’erreur.",
            "pricing_stale_on_save": "Tarif recalculé à l’enregistrement.",
            "pricing_stale_reload": "Recharger la dernière version",
            "pricing_statuses": {
              "blocked": "Bloqué",
              "complimentary": "Offert",
              "pending": "À calculer",
              "priced": "Tarif ERP appliqué"
            },
            "pricing_stitch_unit": "points",
            "pricing_subgroups": {
              "all": "Tous textiles",
              "colored": "Textile couleur",
              "white": "Textile blanc"
            },
            "pricing_total": "Total marquage et frais",
            "pricing_unavailable": "Tarif indisponible",
            "pricing_vat_short": "TVA",
            "product": "Produit",
            "quantity": "Quantité",
            "quantity_stepper": {
              "decrement": "Retirer une pièce, __FIELD__",
              "increment": "Ajouter une pièce, __FIELD__"
            },
            "refresh_supplier_price": "Rafraîchir depuis Imbretex",
            "remove_file": "Retirer %{filename}",
            "replace_textile": "Remplacer",
            "responsible": "Commercial",
            "save": "Enregistrer",
            "save_textiles_before_allocating": "Enregistrez d'abord le devis pour pouvoir allouer ces tailles.",
            "search_product": "Rechercher par nom ou référence...",
            "section_name": "Nom de la section",
            "select_all_textiles": "Tout sélectionner",
            "select_payment_method": "Sélectionner...",
            "select_template": "Sélectionner un modèle (optionnel)",
            "settings": "Paramètres",
            "shipping_address": "Adresse de livraison",
            "size_breakdown_required": "Ajoutez des tailles à ce textile avant de lui associer un marquage.",
            "size_quantity_label": "Quantité textile, taille %{size}",
            "size_quantity_template_label": "Quantité textile par taille",
            "sizes_hint": "La quantité de la ligne est la somme des tailles.",
            "sizes_section": "Tailles & quantités",
            "stale_update": "Ce devis a été modifié dans un autre onglet ou par un autre utilisateur. Rechargez la page avant de poursuivre.",
            "sub_technique": "Procédé DTF",
            "sub_technique_hint": "Variante de production utilisée pour sélectionner la grille tarifaire DTF, DST ou FLEX.",
            "subtotal_ht": "Total HT",
            "summary": "Récapitulatif",
            "supplier_price": "Prix fournisseur (€)",
            "supplier_price_unknown": "Tarif fournisseur inconnu — à rafraîchir ou à saisir.",
            "tabs": {
              "documents": "Notes & documents",
              "markings": "Marquages",
              "textiles": "Textiles"
            },
            "tariffs_changed_since_save": "Les tarifs ERP ont changé depuis la dernière sauvegarde. Enregistrez le devis pour actualiser les montants affichés.",
            "technique": "Technique",
            "template": "Modèle",
            "textile_price": "Prix textile (€)",
            "title": "Titre",
            "total_ttc": "Total TTC",
            "unit": "Unité",
            "unit_price_erp_hint": "Calculé depuis la grille ERP, sauf prix forcé.",
            "unit_price_ht": "Prix unitaire HT",
            "validity_date": "Date de validité",
            "vat": "TVA",
            "vat_rate": "Taux TVA"
          },
          "garment_types": {
            "autre": "Autre",
            "casquette": "Casquette",
            "polo": "Polo",
            "sac": "Sac",
            "sweat": "Sweat",
            "tshirt": "T-shirt",
            "veste": "Veste"
          },
          "index": {
            "card": {
              "actions": {
                "accept": "Marquer comme accepté",
                "complete": "Compléter",
                "delete": "Supprimer",
                "duplicate": "Dupliquer",
                "edit": "Modifier",
                "lose": "Marquer comme perdu",
                "new_version": "Créer une nouvelle version",
                "open": "Ouvrir le devis",
                "open_short": "Ouvrir",
                "pdf": "Télécharger le PDF",
                "proof": "Voir le BAT",
                "reopen": "Rouvrir le devis",
                "resume": "Reprendre",
                "send": "Envoyer la V%{number}",
                "update": "Mettre à jour"
              },
              "amount": {
                "discount_amount": "remise %{value}",
                "discount_percentage": "remise %{value} %",
                "excluding_tax": "HT",
                "lines_without_price": {
                  "one": "%{count} ligne sans tarif",
                  "other": "%{count} lignes sans tarif"
                },
                "margin": "marge %{value} %",
                "missing": "Prix à compléter",
                "valid_until": "valable jusqu’au %{date}",
                "viewed": "vu par le client"
              },
              "confirm": {
                "delete": {
                  "accept": "Supprimer",
                  "text": "%{reference} · Le brouillon et ses lignes seront supprimés définitivement.",
                  "title": "Supprimer ce brouillon ?"
                }
              },
              "events": {
                "created": "créé le %{date}",
                "design": "en conception depuis le %{date}",
                "lost": "perdu le %{date}",
                "sent": "envoyé le %{date}",
                "won": "validé le %{date}"
              },
              "menu": {
                "advance": "Faire avancer",
                "consult": "Consulter",
                "label": "Plus d’actions pour %{reference}"
              },
              "pieces": {
                "one": "%{count} pc",
                "other": "%{count} pcs"
              },
              "tags": {
                "draft_revision": "V%{number} en brouillon",
                "expired": "Validité dépassée",
                "price_missing": "Prix manquant"
              }
            },
            "columns": {
              "date": "Date",
              "denomination": "Client",
              "reference": "N° devis",
              "responsible": "Responsable",
              "status": "État",
              "title": "Intitulé"
            },
            "duplicate": "Dupliquer un devis",
            "duplicate_dialog": {
              "action": "Dupliquer",
              "action_for": "Dupliquer %{reference}",
              "empty": "Aucun devis ne correspond à cette recherche.",
              "intro": "Cherchez le devis à reprendre. La copie s’ouvre en brouillon, à votre nom.",
              "results": "Devis à dupliquer",
              "search_placeholder": "Rechercher un n°, un client, un intitulé…"
            },
            "empty": {
              "filtered": "Aucun devis ne correspond à ces filtres.",
              "none": "Aucun devis pour le moment. Lancez le premier.",
              "title": "Aucun devis"
            },
            "filters": {
              "all_periods": "Toutes les périodes",
              "all_responsibles": "Tous les responsables",
              "mine": "Mes devis",
              "periods": {
                "last_month": "Mois dernier",
                "last_year": "Année dernière",
                "this_month": "Ce mois",
                "this_quarter": "Ce trimestre",
                "this_year": "Cette année"
              },
              "reset": "Réinitialiser",
              "search_placeholder": "Rechercher un n°, un client, un intitulé…"
            },
            "footer": {
              "drafts": {
                "one": "%{count} brouillon",
                "other": "%{count} brouillons",
                "zero": "aucun brouillon"
              },
              "estimates": {
                "one": "%{count} devis",
                "other": "%{count} devis"
              }
            },
            "groups": {
              "meta": "%{count} devis · %{amount} HT",
              "this_week": "Cette semaine"
            },
            "kpis": {
              "awaiting_customer": "En attente client",
              "awaiting_customer_hint": {
                "one": "%{count} devis envoyé · HT",
                "other": "%{count} devis envoyés · HT",
                "zero": "Aucun devis envoyé"
              },
              "conversion": "Taux de transformation",
              "conversion_hint": "sur les 90 derniers jours",
              "conversion_none": "—",
              "conversion_value": "%{rate} %",
              "drafts": "Brouillons",
              "drafts_hint": "dont %{count} à compléter",
              "expiring_soon": "Expirent sous 7 jours",
              "expiring_soon_hint": "à relancer",
              "label": "Indicateurs"
            },
            "lost_reasons": {
              "label": "Motifs de perte",
              "none": "Sans motif"
            },
            "new": "Nouveau devis",
            "statuses": {
              "design": "En conception",
              "draft": "Brouillon",
              "lost": "Perdu",
              "pending": "Non validé",
              "sent": "En cours",
              "won": "Affaire validée"
            },
            "subtitle": "Suivez vos devis, reprenez un brouillon ou lancez-en un nouveau.",
            "tabs": {
              "all": "Tous",
              "design": "En conception",
              "draft": "Brouillons",
              "label": "Filtrer par statut",
              "lost": "Perdus",
              "pending": "Non validés",
              "sent": "En cours",
              "won": "Affaires"
            },
            "title": "Devis",
            "todo": {
              "ctas": {
                "approvals": "Examiner",
                "expired": "Mettre à jour",
                "price_missing": "Compléter"
              },
              "meta": "%{title} · créé le %{date}",
              "reasons": {
                "approvals": {
                  "one": "%{count} approbation en attente",
                  "other": "%{count} approbations en attente"
                },
                "expired": "Validité dépassée depuis le %{date}",
                "price_missing": "Prix manquant sur une ligne"
              },
              "title": "À traiter"
            }
          },
          "lose": {
            "comment_required": "Précisez le motif dans le commentaire.",
            "reason_required": "Choisissez le motif de la perte."
          },
          "lose_dialog": {
            "comment": "Commentaire",
            "comment_hint": "Obligatoire avec « Autre motif ».",
            "confirm": "Marquer comme perdu",
            "intro": "%{reference} · Le devis sort des devis en cours. Vous pourrez annuler pendant une heure.",
            "reason": "Motif",
            "title": "Affaire perdue"
          },
          "lost_reasons": {
            "competitor": "Offre d’un concurrent retenue",
            "lead_time": "Délai trop long",
            "other": "Autre motif",
            "price": "Prix trop élevé",
            "project_abandoned": "Projet abandonné"
          },
          "markings": {
            "block": {
              "add": "Ajouter un marquage",
              "empty_text": "En 4 étapes : la technique, l’emplacement, le logo, puis les textiles concernés.",
              "empty_title": "Aucun marquage pour l’instant",
              "locked": "Ajoutez d’abord un textile : chaque marquage s’applique à un ou plusieurs textiles."
            },
            "card": {
              "actions": {
                "delete": "Supprimer le marquage : %{name}",
                "duplicate": "Dupliquer le marquage : %{name}",
                "edit": "Modifier le marquage : %{name}",
                "more_actions": "Actions secondaires : %{name}",
                "pricing": "Tarif du marquage : %{name}"
              },
              "artwork_pending": "Visuel à fournir",
              "custom_zone": "Zone à faire valider",
              "delete_confirm": {
                "accept": "Supprimer",
                "text": "Le marquage, ses affectations aux textiles et ses personnalisations sont retirés du devis.",
                "title": "Supprimer ce marquage ?"
              },
              "dimensions": "%{width} × %{height} mm",
              "edit": "Modifier",
              "no_textile": "Aucun textile associé",
              "personalized_pieces": "· %{pieces} pcs personnalisées",
              "pieces_html": "%{pieces} pcs",
              "pricing": "Tarif",
              "textile_chip": "%{textile} · %{pieces} pcs",
              "underbase": "+ sous-couche"
            },
            "wizard": {
              "artwork": {
                "drop": "Déposer le logo ici",
                "drop_hint": "ou cliquer pour choisir · AI, SVG ou PDF de préférence (PNG ou JPG en haute définition)",
                "intro": "Saisissez le texte à marquer ou déposez le fichier du client. S’il doit encore fournir le visuel, cochez la case ci-dessous.",
                "library": "Depuis les documents du devis",
                "notes": "Consignes pour l’atelier",
                "notes_placeholder": "Ex. logo en blanc sur les textiles foncés",
                "optional": "facultatif",
                "personalized_pieces": "Pièces personnalisées",
                "personalized_pieces_hint": "Chacune ajoute le supplément de personnalisation des grilles tarifaires, selon l’emplacement : petit (cœur, manches) ou grand (poitrine, dos, emplacement personnalisé). Broderie, transfert et PAP appliquent leurs propres options de personnalisation. Noms, prénoms et tailles se recueillent au BAT.",
                "personalized_pieces_max": "/ %{pieces}",
                "remove_pending": "Retirer %{filename}",
                "text": "Texte à marquer",
                "text_hint": "Le texte peut être utilisé seul ou avec un logo. La mise en forme se précise au BAT.",
                "text_placeholder": "Ex. STAFF",
                "title": "Le visuel à marquer",
                "use": "Utiliser",
                "use_label": "Utiliser %{name} comme logo"
              },
              "close": "Fermer",
              "next": "Suivant",
              "placement": {
                "advised": "Conseillé",
                "custom": "Ou un emplacement personnalisé",
                "format": "Format du marquage",
                "format_examples": {
                  "A3": "Dos, grand visuel",
                  "A4": "Poitrine, logo moyen",
                  "A6": "Cœur, manches, petit logo"
                },
                "format_size": "%{width} × %{height} mm",
                "intro": "Choisissez l’emplacement, puis l’un des trois formats si la technique en demande un (la sérigraphie et la broderie n’en ont pas). Le format conseillé pour l’emplacement est signalé.",
                "title": "Où placer le marquage, et à quel format ?",
                "zone": "Emplacement",
                "zone_names": {
                  "left_sleeve": "Épaule / manche gauche",
                  "right_sleeve": "Épaule / manche droite"
                }
              },
              "previous": "Précédent",
              "steps": {
                "artwork": "Logo",
                "placement": "Emplacement",
                "technique": "Technique",
                "textiles": "Textiles"
              },
              "steps_label": "Étapes du marquage",
              "technique": {
                "colours": "Nombre de couleurs du logo",
                "colours_hint": "Chaque couleur demande un écran : c’est ce qui fixe le prix. Sur textile de couleur, la sous-couche est ajoutée d’office.",
                "help": {
                  "dtf": {
                    "description": "Transfert imprimé puis pressé à chaud. Toutes les couleurs, dès une pièce.",
                    "tips": [
                      "Idéal petites séries, prénoms et numéros",
                      "Accepte photos et dégradés"
                    ]
                  },
                  "dtg": {
                    "description": "Impression numérique directe sur le textile, comme une imprimante.",
                    "tips": [
                      "Idéal pour visuels photo sur coton",
                      "Meilleur rendu sur textile clair"
                    ]
                  },
                  "embroidery": {
                    "description": "Logo cousu au fil dans le textile. Rendu haut de gamme et durable.",
                    "tips": [
                      "Idéal côté cœur, casquettes, polos, sweats",
                      "Petits formats, pas de dégradés"
                    ]
                  },
                  "other": {
                    "description": "Personnalisation PAP, transfert ou autre technique.",
                    "tips": [
                      "Précisez la technique ci-dessous"
                    ]
                  },
                  "screen_print": {
                    "description": "Encre déposée à travers un écran. Couleurs vives et très résistantes.",
                    "tips": [
                      "Idéal pour les séries et les logos en aplats",
                      "Prix selon le nombre de couleurs"
                    ]
                  }
                },
                "intro": "Chaque technique a ses points forts. En cas de doute, la description vous aide à choisir.",
                "other": "Autre technique",
                "required": "obligatoire",
                "title": "Quelle technique de marquage ?"
              },
              "textiles": {
                "all": "Tous les textiles, toutes les tailles",
                "all_hint": "Chaque taille jusqu’à sa quantité sur le devis",
                "intro": "Tout est coché par défaut. Ajustez les quantités taille par taille si seule une partie des pièces est marquée (ex. 10 des 20 M).",
                "item_checkbox": "Marquer : %{textile}",
                "size_quantity": "%{textile} %{size}, sur %{max}",
                "title": "Sur quels textiles ?"
              },
              "title_edit": "Modifier le marquage",
              "title_new": "Ajouter un marquage"
            }
          },
          "new": {
            "title": "Nouveau devis"
          },
          "pdf_viewer": {
            "new_tab": "Nouvel onglet",
            "new_tab_title": "Ouvrir l’aperçu PDF dans un nouvel onglet",
            "open": "Aperçu PDF",
            "title": "Aperçu du devis"
          },
          "personalizations": {
            "all_markings": "Tous les marquages",
            "all_textiles": "Tous les textiles",
            "count": {
              "one": "%{count} pièce",
              "other": "%{count} pièces"
            },
            "empty": "Aucune pièce ne correspond à ces filtres.",
            "errors_only": "Erreurs uniquement",
            "export": "Exporter CSV",
            "filter": "Filtrer",
            "filters": "Filtres",
            "go_to_errors": "Accéder directement aux erreurs",
            "import": "Importer CSV",
            "imported": {
              "one": "%{count} ligne importée",
              "other": "%{count} lignes importées"
            },
            "intro": "Six pièces sont affichées par page. Les erreurs restent filtrables et bloquent l'envoi du devis.",
            "marking": "Marquage",
            "mobile_notice": "Consultation mobile : l'import, les filtres avancés et la modification des personnalisations sont disponibles sur tablette ou ordinateur.",
            "page": "Page %{page}",
            "saved": "Personnalisations enregistrées",
            "textile_size": "Textile et taille",
            "title": "Personnalisation variable"
          },
          "proof_approval": {
            "locked": "Le BAT est déjà parti chez le client ; la case ne peut plus changer.",
            "no_proof": "Ce devis n’a pas de BAT."
          },
          "revisions": {
            "accepted": "V%{number} acceptée",
            "after": "Maintenant",
            "before": "Avant",
            "changes": "Changements V%{before}/V%{after}",
            "draft": "Brouillon V%{number}",
            "families": {
              "approvals": "Approbations",
              "documents": "Documents",
              "general": "Informations générales",
              "markings": "Marquages",
              "textiles": "Textiles",
              "totals": "Totaux"
            },
            "no_changes": "Aucun changement depuis la dernière version envoyée.",
            "rejected": "V%{number} refusée",
            "sent": "V%{number} envoyée",
            "title": "Révisions"
          },
          "send_dialog": {
            "blocked": "Envoi bloqué tant que ces points ne sont pas corrigés",
            "confirm": "Envoyer le devis",
            "current_total": "Montant TTC envoyé",
            "draft_reference": "recevra sa référence au premier envoi",
            "frozen_revision": "Ce renvoi utilisera la révision déjà envoyée, sans nouveau calcul tarifaire.",
            "intro": "Le devis %{reference} va être envoyé par email.",
            "no_email": "Aucun email n'est renseigné pour ce client — saisissez-en un pour envoyer.",
            "pricing_updated": "Les tarifs ont changé depuis la dernière sauvegarde ; ce montant sera appliqué à l'envoi.",
            "recipients": "Destinataires",
            "recipients_hint": "Cochés d'office : les contacts « devis par défaut », à défaut le contact principal. Chaque adresse reçoit son propre email.",
            "saved_total": "Montant enregistré : %{amount}.",
            "title": "Envoyer le devis au client"
          },
          "show": {
            "acceptance_comment": "Commentaire du client",
            "actions": {
              "lose": "Marquer comme perdu",
              "revert": "Annuler la dernière action",
              "send_to_pao": "Passer en affaire",
              "start_production": "Démarrer la production",
              "validate_estimate": "Affaire gagnée",
              "validate_production": "Valider la production"
            },
            "artwork_missing": "Fichier non reçu",
            "artwork_pending_from_customer": "Visuel à fournir par le client",
            "color_swatch_label": "Coloris : %{colors}",
            "confirm": {
              "revert": {
                "text": "Le devis revient à son statut précédent.",
                "title": "Annuler cette action ?"
              },
              "send_to_pao": {
                "text": "L’affaire part en conception pour préparer le BAT.",
                "title": "Passer ce devis en affaire ?"
              },
              "start_production": {
                "text": "Le BAT est approuvé ; l’atelier peut lancer la production.",
                "title": "Démarrer la production de cette affaire ?"
              },
              "validate_estimate": {
                "text": "Le devis devient une affaire validée.",
                "title": "Valider ce devis ?"
              },
              "validate_production": {
                "text": "L’affaire est marquée comme terminée.",
                "title": "Valider la production de ce devis ?"
              }
            },
            "confirm_duplicate": "Dupliquer ce devis ?",
            "discount": "remise %{value}",
            "documents": "Documents joints",
            "edit": "Modifier",
            "expired": "validité dépassée",
            "global_discount": "Remise globale",
            "global_discount_percentage": "Remise globale (%{value} %)",
            "loading": "Chargement…",
            "lost_at": "Perdu le",
            "margin": "Marge",
            "markings": "Marquages",
            "new_version": "Nouvelle version",
            "no_items": "Aucun textile",
            "payment_delay_days": {
              "one": "%{count} jour",
              "other": "%{count} jours"
            },
            "payment_method": "Paiement",
            "payment_terms": "Conditions de paiement",
            "production_validated_at": "Production validée le",
            "proof": {
              "approval": {
                "approve": "Approuver et envoyer",
                "approve_confirm": "Envoyer ce BAT au client (%{email}) ?",
                "approved": "Approuvé et envoyé par %{name} le %{date}",
                "approver": "Approbateur prévu",
                "files": "Fichiers du BAT",
                "information": "Pour information",
                "internal_note": "Note de la PAO",
                "pending": "À approuver avant l’envoi au client",
                "return": "Renvoyer à la PAO",
                "return_dialog": {
                  "comment": "Ce qu’il faut reprendre",
                  "confirm": "Renvoyer à la PAO",
                  "intro": "Le BAT v%{version} redevient modifiable, sans nouvelle version : le client n’a rien reçu.",
                  "title": "Renvoyer le BAT à la PAO"
                },
                "returned": "Renvoyé à la PAO par %{name} le %{date}",
                "submitted": "Soumis par %{name} le %{date}",
                "waiting_for": "En attente de l’approbation de %{name}."
              },
              "none": "Aucun BAT préparé pour l’instant.",
              "open": "Voir le BAT",
              "prepare": "Préparer le BAT",
              "requirement": {
                "hint": "La PAO soumet le BAT au commercial, qui l’approuve et l’envoie au client.",
                "label": "BAT soumis à mon approbation avant envoi",
                "locked_on": "Le BAT de ce devis est soumis à l’approbation du commercial.",
                "save": "Enregistrer"
              },
              "responded_at": "Réponse du client le %{date}",
              "sent_at": "Envoyé le %{date}",
              "statuses": {
                "approved": "approuvé par le client",
                "draft": "en préparation",
                "pending_approval": "en attente de votre approbation",
                "revision_requested": "modifications demandées",
                "sent": "envoyé au client"
              },
              "title": "BAT"
            },
            "resend": "Renvoyer",
            "send": "Envoyer",
            "sent_at": "Envoyé le",
            "sent_count": {
              "one": "%{count} envoi",
              "other": "%{count} envois"
            },
            "sent_to_pao_at": "Passé en affaire le",
            "subtotal": "Sous-total HT",
            "supply": "Approvisionnement",
            "textile_image_missing": "Aucune image textile",
            "textiles": "Textiles",
            "tracking": {
              "description": "Scannez ce code pour ouvrir la fiche du dossier. Une connexion ERP est nécessaire.",
              "download": "Télécharger le QR",
              "image_alt": "QR de suivi du dossier %{reference}",
              "title": "Suivi interne du dossier"
            },
            "untyped_marking": "Marquage",
            "validated_at": "Validé le"
          },
          "textiles": {
            "block": {
              "add_catalogue": "Textile du catalogue",
              "add_customer": "Fourni par le client",
              "add_section": "Ajouter une section",
              "empty_text": "Ajoutez un textile du catalogue, avec le stock et le tarif du client, ou un textile apporté par le client.",
              "empty_title": "Aucun textile pour l’instant"
            },
            "card": {
              "add_marking": "Ajouter un marquage à : %{name}",
              "add_marking_short": "+ Marquage",
              "already_marked": "Déjà marqué",
              "copy_markings": "Reprendre les marquages d’un autre textile : %{name}",
              "copy_placeholder": "Mêmes marquages que…",
              "customer_price": "Tarif client",
              "customer_supplied": "Fourni par le client",
              "delete": "Supprimer la ligne : %{name}",
              "delete_confirm": {
                "accept": "Supprimer",
                "text": "Le textile et ses quantités sont retirés du devis, ainsi que leurs affectations aux marquages.",
                "title": "Supprimer cette ligne ?"
              },
              "duplicate": "Dupliquer la ligne : %{name}",
              "edit": "Modifier",
              "edit_label": "Modifier : %{name}",
              "more_actions": "Actions secondaires : %{name}",
              "no_colour": "Couleur non précisée",
              "no_textile_price": "pas de prix textile",
              "plan": "Plan de marquage",
              "replace": "Remplacer le textile",
              "unit_part_html": "× %{price} HT"
            },
            "picker": {
              "add": "Ajouter au devis",
              "all_categories": "Toutes les catégories",
              "all_suppliers": "Tous les fournisseurs",
              "already_marked": "Produit déjà marqué, sans marquage à ajouter",
              "cancel": "Annuler",
              "category": "Catégorie",
              "color": "Couleur",
              "color_placeholder": "Ex. Blanc, Noir, Gris chiné…",
              "comment": "Marque / commentaire",
              "comment_placeholder": "Ex. Gildan 64000, tailles mélangées…",
              "customer_notice": "Le client apporte ses propres textiles. La ligne apparaît comme un textile standard et peut recevoir des marquages.",
              "garment_type": "Type de vêtement",
              "grid_applied": "%{grid} appliqué",
              "origin": "Origine du textile",
              "placeholder_text": "Ses coloris, tailles, stocks et le prix pour ce client s’afficheront ici.",
              "placeholder_title": "Choisissez un produit",
              "results": "Produits",
              "search_label": "Rechercher un produit",
              "search_placeholder": "Référence, nom, marque…",
              "size_quantity": "Taille %{size}",
              "sizes": "Quantités par taille",
              "supplier": "Fournisseur",
              "tabs": {
                "catalogue": "Catalogue",
                "customer": "Fourni par le client",
                "manual": "Saisie manuelle"
              },
              "title": "Ajouter un textile"
            }
          },
          "units": {
            "kg": "Kg",
            "lot": "Lot",
            "m": "Mètre",
            "pce": "Pièce"
          },
          "vat_rates": {
            "vat_10": "10%",
            "vat_20": "20%",
            "vat_5_5": "5,5%"
          }
        },
        "js": {
          "autosave": {
            "close_discard_confirm": "Fermer sans enregistrer ?\n\nOK = Fermer sans enregistrer\nAnnuler = Rester sur le devis",
            "close_save_confirm": "Attention — ce devis comporte des modifications non sauvegardées. Souhaitez-vous enregistrer avant de fermer ?\n\nOK = Enregistrer et fermer\nAnnuler = Voir les autres options",
            "conflict": "Version du devis obsolète",
            "conflict_reload_confirm": "Recharger la version la plus récente ? Vos modifications locales non enregistrées seront perdues.",
            "leave_confirm": "Quitter cette page et perdre les modifications non enregistrées ?",
            "modified": "Modifié — à enregistrer",
            "reload": "Recharger",
            "remove_file": "Retirer %{filename}",
            "save_blocked": {
              "one": "Enregistrement impossible : %{count} point à corriger",
              "other": "Enregistrement impossible : %{count} points à corriger"
            },
            "save_blocked_others": {
              "one": "Voir l’autre point",
              "other": "Voir les %{count} autres points"
            },
            "save_error": "Erreur de sauvegarde",
            "saved": "Enregistré",
            "saved_at": "Enregistré à %{timestamp}",
            "saving": "Enregistrement...",
            "structural_queued": "Enregistrement... action en attente",
            "validation_error": "Vérifiez le champ signalé avant d’enregistrer."
          },
          "dropzone": {
            "bytes": "%{size} o",
            "error": "Erreur",
            "file_too_large": "Fichier trop volumineux (maximum %{size})",
            "kilobytes": "%{size} Ko",
            "megabytes": "%{size} Mo",
            "remove_file": "Retirer %{filename}",
            "unsupported_type": "Format de fichier non autorisé",
            "upload_complete": "%{total} fichier(s) — envoi terminé",
            "upload_errors": "%{done}/%{total} — %{errors} erreur(s)",
            "upload_failed": "Échec de l'envoi",
            "uploading": "%{done}/%{total} — envoi en cours…"
          },
          "estimate_editor": {
            "allocation_item_label": "Marquer : %{textile}",
            "allocation_label": "%{textile} %{size}, sur %{max}",
            "new_line": "Nouvelle ligne",
            "over_stock": {
              "one": "%{count} taille au-delà du stock · délai à confirmer",
              "other": "%{count} tailles au-delà du stock · délai à confirmer"
            },
            "pieces": {
              "one": "%{count} pce",
              "other": "%{count} pcs"
            },
            "pricing_unavailable": "Tarif indisponible",
            "replace_allocated_accept": "Remplacer",
            "replace_allocated_confirm": "Il est utilisé par des marquages. Les allocations et personnalisations des tailles identiques sont conservées ; celles des tailles retirées sont supprimées.",
            "replace_allocated_title": "Remplacer ce textile ?",
            "reprice_required": "À recalculer",
            "size_quantity": "Quantité textile, taille %{size}"
          },
          "inline_edit": {
            "save_error": "Erreur de sauvegarde — cliquez pour réessayer"
          },
          "item_pricing": {
            "margin_rate_invalid": "Coefficient textile invalide : saisissez au moins 1.",
            "network_error": "Erreur réseau",
            "no_variant": "Aucune variante sélectionnée",
            "refresh_failed": "Erreur lors de la mise à jour",
            "refreshed": "Prix mis à jour",
            "refreshing": "Mise à jour…",
            "supplier_price_unknown": "Tarif fournisseur inconnu — à rafraîchir ou à saisir."
          },
          "marking_form": {
            "above_maximum": "Sur devis : quantité au-delà du dernier palier (%{count}).",
            "ambiguous_grid": "Plusieurs grilles actives couvrent cette combinaison : faites corriger les tarifs ERP.",
            "below_minimum": "Sur devis : quantité minimale %{count} pour cette technique.",
            "compatibility": {
              "custom_zone": "Zone personnalisée ; approbation requise.",
              "customer_supplied": "Textile fourni par le client ; approbation requise.",
              "dimensions_exceeded": "Les dimensions dépassent la capacité déclarée.",
              "inherited": "Règle produit héritée pour ce coloris",
              "max_dimensions": "Maximum : %{width} × %{height} mm",
              "select_definition": "Sélectionnez une technique et une zone.",
              "status": {
                "allowed": "Autorisé",
                "approval_required": "Approbation requise",
                "incompatible": "Incompatible",
                "unspecified": "Non renseigné"
              },
              "unspecified": "Aucune règle produit × zone × technique n’est renseignée."
            },
            "invalid_price": "Prix négatif dans la grille ERP : faites corriger ce tarif.",
            "missing_dimensions": "Aucun tarif pour cette combinaison de dimensions.",
            "missing_tier": "Aucun palier tarifaire ne couvre cette quantité.",
            "no_grid": "Aucune grille tarifaire pour cette technique et ce type de client.",
            "pieces_of": "%{marked} / %{total} pcs",
            "quote_required": "Sur devis.",
            "recalculate_required": "À recalculer",
            "unavailable": "indisponible dans la grille actuelle"
          },
          "marking_plan": {
            "all": "Tout",
            "all_label": "%{marking} : toutes les pièces",
            "cell_label": "%{marking}, taille %{size}, sur %{count}",
            "copied": {
              "one": "%{count} marquage repris de %{textile} sur toutes les pièces : ajustez dans le plan si besoin.",
              "other": "%{count} marquages repris de %{textile} sur toutes les pièces : ajustez dans le plan si besoin."
            },
            "copy_from": "Reprendre les marquages de",
            "copy_placeholder": "Choisir un textile…",
            "hide": "Masquer le plan de marquage",
            "none": "Aucun",
            "none_label": "%{marking} : aucune pièce",
            "nothing_to_copy": "Aucun marquage compatible à reprendre.",
            "pieces": {
              "one": "%{count} pce",
              "other": "%{count} pcs"
            },
            "result": "Ce que ça donne",
            "result_hint": "Sur une même taille, les pièces se cumulent : les 10 à l’épaule font partie des 20 au dos.",
            "show": "Plan de marquage",
            "size": "Taille",
            "table_label": "Plan de marquage : %{textile}",
            "unmarked": "sans marquage",
            "untyped": "Marquage"
          },
          "marking_wizard": {
            "add": "Ajouter le marquage",
            "artwork_pending": "À fournir par le client",
            "artwork_text": "Texte à marquer",
            "artwork_to_provide": "À fournir",
            "colours": {
              "one": "%{count} couleur",
              "other": "%{count} couleurs"
            },
            "dimensions": "%{width} × %{height} mm",
            "files": {
              "one": "%{count} fichier",
              "other": "%{count} fichiers"
            },
            "format_advised": "Pour « %{zone} », le format %{format} est conseillé.",
            "impossible_everywhere": "Impossible sur les textiles du devis",
            "impossible_on": "Impossible sur : %{textiles}",
            "marked_pieces": {
              "one": "%{count} pce marquée",
              "other": "%{count} pcs marquées"
            },
            "missing": "Il manque : %{what}.",
            "missing_artwork": "le texte ou le logo (ou cochez « Visuel à fournir par le client »)",
            "missing_colours": "le nombre de couleurs",
            "missing_format": "le format",
            "missing_technique": "la technique",
            "missing_textiles": "au moins un textile",
            "missing_zone": "l’emplacement",
            "next": "Suivant",
            "pieces": {
              "one": "%{count} pce",
              "other": "%{count} pcs"
            },
            "size_kb": "%{size} Ko",
            "size_mb": "%{size} Mo",
            "step_ok": "Étape %{step} sur %{total}",
            "step_ok_done": "c’est bon",
            "text_and_files": {
              "one": "Texte et 1 fichier",
              "other": "Texte et %{count} fichiers"
            },
            "to_choose": "À choisir",
            "update": "Mettre à jour le marquage",
            "zone_first": "Choisissez d’abord un emplacement."
          },
          "textile_picker": {
            "add": "Ajouter au devis",
            "add_title": "Ajouter un textile",
            "article": "Article",
            "catalogue_summary": "%{pieces} · %{colours} · %{unit} HT / pce · %{total} HT",
            "choose_product": "Choisissez un produit dans la liste.",
            "client_price": "%{price} € HT",
            "colours": {
              "one": "%{count} coloris",
              "other": "%{count} coloris"
            },
            "colourway": "Coloris",
            "compatibility": {
              "allowed": "%{count} autorisée(s)",
              "approval_required": "%{count} avec approbation",
              "incompatible": "%{count} incompatible(s)",
              "unspecified": "%{count} non renseignée(s)"
            },
            "compatibility_status": {
              "allowed": "Autorisé",
              "approval_required": "Approbation requise",
              "incompatible": "Incompatible",
              "unspecified": "Non renseigné"
            },
            "compatibility_title": "Marquages possibles sur ce produit",
            "customer_summary": "%{pieces} fournies par le client · pas de prix textile",
            "fill_quantities": "Renseignez au moins une quantité.",
            "inherited_rule": "Règle produit héritée",
            "legend_over": "au-delà du stock",
            "legend_unmapped": "taille non reliée",
            "load_error": "Impossible de charger les données. Réessayez.",
            "loading": "Chargement du produit…",
            "manual_failed": "L’article n’a pas pu être enregistré.",
            "manual_hint": "Enregistrez l’article pour choisir les quantités.",
            "manual_no_sizes": "Sélectionnez au moins une taille.",
            "manual_quantity_for": "Quantité pour %{article}",
            "manual_saving": "Enregistrement dans le catalogue…",
            "manual_stock": "Stock à confirmer auprès du fournisseur",
            "matrix_scroll_region": "Coloris et tailles du produit. Faites défiler horizontalement pour voir toutes les tailles.",
            "max_dimensions": "Max. %{width} × %{height} mm",
            "missing": "Il manque : %{fields}.",
            "missing_garment_type": "le type de vêtement",
            "missing_quantity": "au moins une quantité",
            "no_filled_colour": "Aucun coloris saisi.",
            "no_filtered_results": "Aucun produit pour ces filtres.",
            "no_results": "Aucun produit pour « %{query} ». Essayez la référence fournisseur, un mot du nom ou la marque.",
            "no_variants": "Aucune variante disponible pour ce produit.",
            "object_summary": "%{pieces} · %{unit} HT / pce · %{total} HT",
            "only_filled": "Seulement les coloris saisis",
            "ordered_group": "Déjà commandés par ce client",
            "out_of_stock": "rupture",
            "over_stock_item": "%{colour} %{size} (%{quantity} pour %{stock} en stock)",
            "over_stock_text": "Vous pouvez l’ajouter quand même : le délai de réapprovisionnement sera à confirmer au client.",
            "over_stock_title": {
              "one": "%{count} taille au-delà du stock :",
              "other": "%{count} tailles au-delà du stock :"
            },
            "per_piece": "par pièce · prix client",
            "pieces": {
              "one": "%{count} pce",
              "other": "%{count} pcs"
            },
            "price_unavailable": "Tarif indisponible",
            "price_varies": "Prix selon la taille",
            "quantity_for": "%{colour}, taille %{size}, stock %{stock}",
            "replace": "Remplacer",
            "replace_title": "Remplacer le textile",
            "results_group": {
              "one": "%{count} résultat",
              "other": "%{count} résultats"
            },
            "select_customer_first": "Choisir un client",
            "select_customer_hint": "Sélectionnez d’abord un client : les tarifs dépendent de sa marge textile.",
            "select_one_colourway": "Sélectionnez un seul coloris et tarif pour remplacer cette ligne.",
            "size_ambiguous": "Taille ambiguë",
            "size_ambiguous_hint": "Taille « %{size} » reliée à plusieurs tailles du catalogue : à confirmer avant de la commander.",
            "size_unmapped": "à relier",
            "size_unmapped_hint": "Taille « %{size} » non reliée au catalogue du fournisseur : elle ne peut pas être commandée.",
            "stock": "stock %{count}",
            "stock_as_of": "Stock au %{date}",
            "type_more": "Tapez au moins deux caractères ou choisissez un filtre.",
            "unmapped_all_text": "Ses tailles ne sont pas encore reliées au catalogue du fournisseur. Choisissez un autre produit.",
            "unmapped_all_title": "Ce produit ne peut pas être commandé pour l’instant.",
            "unmapped_some": "Les tailles %{sizes} ne sont pas encore reliées au fournisseur et ne peuvent pas être commandées.",
            "variants": {
              "one": "%{count} variante",
              "other": "%{count} variantes"
            }
          }
        },
        "manual_articles": {
          "below_cost": "doit être au moins égal au prix d’achat",
          "colors_hint": "Une couleur par ligne",
          "create_and_select": "Enregistrer et choisir les quantités",
          "duplicate": "Cet article existe déjà pour ce fournisseur.",
          "edit": "Modifier l’article manuel",
          "fields": {
            "colors": "Couleurs *",
            "details": "Caractéristiques / description libre",
            "enabled": "Disponible dans le catalogue",
            "kind": "Type d’article",
            "name": "Dénomination *",
            "purchase_price": "Prix d’achat HT (€) *",
            "reference": "Code article *",
            "sale_price": "Prix de vente HT (€) *",
            "sizes": "Tailles canoniques *",
            "supplier": "Fournisseur *"
          },
          "kinds": {
            "object": "Objet",
            "textile": "Textile"
          },
          "new": "Nouvel article manuel",
          "notice": "L’article sera enregistré dans le catalogue et réutilisable dans vos prochains devis.",
          "reactivate_existing": "Ouvrir la fiche de l’article désactivé pour le réactiver",
          "saved": "Article manuel enregistré dans le catalogue.",
          "stock_unknown": "Stock à confirmer",
          "unit": "Quantité",
          "use_existing": "Choisir l’article déjà présent dans le catalogue"
        },
        "marking_catalogue": {
          "active": "Actif",
          "code": "Code stable",
          "intro": "Les techniques et zones sont globales et partagées avec Production. Désactivez une entrée pour la retirer des nouveaux devis sans casser l'historique.",
          "name": "Libellé",
          "position": "Ordre",
          "techniques": "Techniques",
          "title": "Référentiel de marquage",
          "zones": "Zones"
        },
        "pdf": {
          "already_marked": "Produit déjà marqué",
          "artwork_pending_from_customer": "Visuel à fournir par le client",
          "artwork_text": "Texte à marquer : %{text}",
          "banner": "DEVIS",
          "contact": "Contact : %{name}",
          "customer_label": "CLIENT",
          "customer_number": "Client n°",
          "date": "Date",
          "dimension_2": "Tissu",
          "dimension_colors_count": "Nombre de couleurs",
          "dimension_format": "Format",
          "dimension_stitches_count": "Nombre de points",
          "dimension_type": "Type",
          "draft_reference": "Brouillon",
          "erp_fee": "Frais de marquage",
          "estimate_number": "Devis n°",
          "global_discount": "Remise globale",
          "global_discount_with_pct": "Remise globale (%{percentage}%)",
          "header_description": "Désignation",
          "header_quantity": "Quantité",
          "header_ref": "Référence",
          "header_total": "Montant HT",
          "header_unit_price": "PU HT",
          "issuer_address": "13 ZA de Bel Air\n29700 PLUGUFFAN\nFrance\nsofidial@sofidial.fr",
          "issuer_name": "SOFIDIAL SAS",
          "legal": "SOFIDIAL SAS - 13 ZA de Bel Air - 29700 PLUGUFFAN · RCS QUIMPER 792456618 - SAS au capital de 60 000 euros · N° TVA FR67792456618 - CODE NAF : 1330Z",
          "line_discount": "Remise : %{discount}",
          "marking": "Marquage",
          "marking_dimensions": "Dimensions",
          "marking_files": "Fichier(s)",
          "marking_textiles": "Textile(s) associé(s)",
          "markings_total": "Total marquages HT",
          "no_lines": "Aucun article.",
          "notes": "Notes",
          "payment_delay": "Délai de paiement",
          "payment_delay_value": "%{days} jours",
          "payment_method": "Mode de paiement",
          "payment_terms": "Conditions de paiement",
          "sales_rep_line": "Commercial : %{name}",
          "sign_date": "Date",
          "sign_function": "Fonction",
          "sign_name": "Nom",
          "sign_stamp": "Signature et cachet",
          "sign_title": "BON POUR ACCORD",
          "sizes": "Tailles : %{sizes}",
          "subject": "Objet",
          "subtotal": "Total HT",
          "textiles_total": "Total textiles HT",
          "total": "Total TTC",
          "underbase": "+ sous-couche",
          "validity": "Validité",
          "vat": "TVA",
          "version": "Version",
          "watermark": "BROUILLON"
        },
        "printing_price_grids": {
          "history": {
            "changed_from": "de",
            "changed_to": "à",
            "columns": {
              "change": "Modification",
              "date": "Date",
              "entry": "Tarif",
              "user": "Utilisateur"
            },
            "no_changes": "Aucune modification enregistrée",
            "on_quote": "Devis",
            "system_user": "Système",
            "title": "Historique des modifications"
          },
          "index": {
            "active": "Active",
            "direct": "Direct",
            "entries_count": {
              "one": "%{count} entrée",
              "other": "%{count} entrées"
            },
            "inactive": "Inactive",
            "no_grids": "Aucune grille tarifaire",
            "reseller": "Revendeur",
            "seed_hint": "Exécutez : rake printing_prices:seed",
            "standalone_extra_columns": {
              "code": "Code",
              "customer_type": "Type de client",
              "name": "Nom",
              "price": "Tarif",
              "price_type": "Mode",
              "technique": "Technique"
            },
            "standalone_extras": "Suppléments sans grille active",
            "standalone_extras_hint": "Ces frais restent proposés dans les devis selon la technique et le type de client.",
            "techniques": {
              "dtf": "DTF / Numérique",
              "dtg": "Impression numérique",
              "embroidery": "Broderie",
              "engraving": "Gravure",
              "laser": "Laser",
              "misc": "Divers",
              "personalisation_pap": "Personnalisation PAP",
              "personalisation_transfert": "Personnalisation Transfert",
              "screen_print": "Sérigraphie",
              "sublimation": "Sublimation",
              "transfer": "Transfert"
            },
            "title": "Grilles tarifaires"
          },
          "show": {
            "active": "Active",
            "add_extra": "Ajouter un supplément",
            "add_row": "Ajouter une ligne",
            "choose_dimension": "Choisir une dimension",
            "confirm_delete_extra": "Supprimer ce supplément ?",
            "confirm_delete_row": "Supprimer cette ligne de la grille ?",
            "delete_extra": "Supprimer ce supplément",
            "delete_row": "Supprimer cette ligne",
            "dimension_scope": "Dimension",
            "direct": "Direct",
            "entries_count": {
              "one": "%{count} entrée",
              "other": "%{count} entrées"
            },
            "extras": "Suppléments",
            "extras_columns": {
              "code": "Code",
              "name": "Nom",
              "price": "Prix",
              "type": "Type"
            },
            "fixed": "Forfaitaire",
            "inactive": "Inactive",
            "invalid_quantity": "Quantité invalide : saisissez un nombre entier positif ou zéro.",
            "no_extras": "Aucun supplément",
            "on_quote": "Sur devis",
            "per_piece": "Par pièce",
            "percentage": "Pourcentage",
            "price_will_reset": "Le prix sera réinitialisé",
            "prices": "Tarifs",
            "quantity_max": "Qté max",
            "quantity_min": "Qté min",
            "reseller": "Revendeur",
            "save": "Enregistrer",
            "standard_dimension": "Standard",
            "unsaved_changes": "Modifications non enregistrées"
          }
        },
        "products": {
          "capabilities": {
            "cell_height": "Hauteur maximale (%{cell})",
            "cell_note": "Note opérateur (%{cell})",
            "cell_status": "Statut (%{cell})",
            "cell_width": "Largeur maximale (%{cell})",
            "colorway_scope_help": "Hérite de la règle produit, sauf exception explicite par cellule",
            "complete_override": "Remplace entièrement la règle produit",
            "dimensions": "%{width} × %{height} mm",
            "height": "Hauteur max",
            "inherit": "Hériter — %{status}",
            "inherited": "Hérité de la règle produit",
            "intro": "La règle produit s'applique à tous les coloris. Ouvrez un coloris pour définir une exception complète sur une cellule technique × zone.",
            "manage_catalogue": "Gérer les techniques et zones",
            "matrix_region": "Matrice de compatibilité, %{label}. Faites défiler horizontalement pour voir toutes les zones.",
            "open_matrix": "Ouvrir la matrice",
            "operator_note": "Note opérateur",
            "product_rule": "Règle produit",
            "size_aliases": {
              "ambiguous": "Correspondance ambiguë — confirmation manuelle requise",
              "confirm": "Confirmer les correspondances",
              "hint": "Ces correspondances s’appliquent à tous les produits %{supplier}. Une taille non mappée bloque son ajout au devis.",
              "summary": "%{mapped}/%{total} tailles mappées",
              "title": "Correspondance des tailles fournisseur",
              "unmapped": "Non mappée"
            },
            "statuses": {
              "allowed": "Autorisé",
              "approval_required": "Approbation requise",
              "incompatible": "Incompatible",
              "unspecified": "Non renseigné"
            },
            "summary": {
              "one": "1 cellule renseignée",
              "other": "%{count} cellules renseignées"
            },
            "technique": "Technique",
            "title": "Compatibilités de marquage",
            "width": "Largeur max"
          },
          "colorway_unassigned": "Coloris non renseigné",
          "edit": {
            "title": "Modifier le produit"
          },
          "form": {
            "brand": "Marque",
            "category": "Catégorie",
            "description": "Description",
            "enabled": "Produit activé",
            "grammage": "Grammage (g/m²)",
            "images": "Images",
            "information": "Informations",
            "mode": "Mode",
            "name": "Nom",
            "reference": "Référence",
            "status": "Statut",
            "supplier": "Fournisseur",
            "tags": "Tags",
            "tags_placeholder": "Séparez vos tags par une virgule",
            "vat_rate": "TVA",
            "weight": "Poids (g)"
          },
          "index": {
            "add_to_estimate": "Ajouter au devis",
            "all_categories": "Toutes les catégories",
            "all_suppliers": "Tous les fournisseurs",
            "columns": {
              "actions": "Actions",
              "category": "Catégorie",
              "name": "Nom",
              "reference": "Référence",
              "supplier": "Fournisseur"
            },
            "footer": {
              "products": {
                "one": "1 produit",
                "other": "%{count} produits",
                "zero": "Aucun produit"
              }
            },
            "no_products": "Aucun produit trouvé",
            "reset": "Réinitialiser",
            "search_placeholder": "Rechercher un produit...",
            "title": "Produits"
          },
          "show": {
            "edit": "Modifier",
            "fields": {
              "brand": "Marque",
              "category": "Catégorie",
              "grammage": "Grammage",
              "mode": "Mode",
              "reference": "Référence",
              "supplier": "Fournisseur",
              "variants_count": "Nb variantes",
              "vat_rate": "TVA",
              "weight": "Poids"
            },
            "no_description": "Aucune description",
            "no_stores": "Aucune boutique associée",
            "sections": {
              "description": "Description",
              "details": "Détails produit",
              "stores": "Boutiques",
              "variants": "Variantes"
            },
            "variants": {
              "name": "Nom",
              "no_variants": "Aucune variante",
              "price": "Prix",
              "reference": "Référence",
              "size": "Taille",
              "stock": "Stock",
              "supplier_price": "Prix fournisseur"
            }
          }
        },
        "suppliers": {
          "index": {
            "columns": {
              "actions": "Actions",
              "name": "Fournisseur",
              "products_count": "Nb produits"
            },
            "footer": {
              "suppliers": {
                "one": "1 fournisseur",
                "other": "%{count} fournisseurs",
                "zero": "Aucun fournisseur"
              }
            },
            "no_suppliers": "Aucun fournisseur trouvé",
            "reset": "Réinitialiser",
            "search_placeholder": "Rechercher un fournisseur...",
            "see_products": "Voir les produits",
            "title": "Fournisseurs"
          },
          "show": {
            "back": "Retour",
            "footer": {
              "products": {
                "one": "1 produit",
                "other": "%{count} produits",
                "zero": "Aucun produit"
              }
            },
            "no_products": "Aucun produit trouvé",
            "reset": "Réinitialiser"
          }
        }
      },
      "shared": {
        "header": {
          "account": "Mon compte : %{name}",
          "breadcrumb": "Fil d’Ariane",
          "open_navigation": "Ouvrir la navigation"
        },
        "pagination": {
          "info": "%{from}–%{to} sur %{count}",
          "label": "Pagination",
          "next": "Page suivante",
          "previous": "Page précédente"
        },
        "toast": {
          "close": "Fermer"
        }
      },
      "table": {
        "action_button_component": {
          "delete": "Supprimer",
          "download": "Télécharger",
          "edit": "Modifier",
          "settings": "Paramètres",
          "view": "Voir"
        },
        "scroll_region": "Tableau de données défilant horizontalement"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "doit être accepté(e)",
        "already_confirmed": "a déjà été validé(e), veuillez essayer de vous connecter",
        "aspect_ratio_invalid": "a un rapport hauteur / largeur invalide",
        "aspect_ratio_is_not": "doit avoir un rapport hauteur / largeur de %{aspect_ratio}",
        "aspect_ratio_not_landscape": "doit être une image en format paysage",
        "aspect_ratio_not_portrait": "doit être une image en format portrait",
        "aspect_ratio_not_square": "doit être une image en format carrée",
        "blank": "doit être rempli(e)",
        "confirmation": "ne concorde pas avec %{attribute}",
        "confirmation_period_expired": "à confirmer dans les %{period}, merci de faire une nouvelle demande",
        "content_type_invalid": "a un type de contenu non valide",
        "dimension_height_equal_to": "la hauteur doit être égale à %{length} pixels",
        "dimension_height_greater_than_or_equal_to": "la hauteur doit être supérieure ou égale à %{length} pixels",
        "dimension_height_inclusion": "la hauteur n'est pas comprise entre %{min} et %{max} pixels",
        "dimension_height_less_than_or_equal_to": "la hauteur doit être inférieure ou égale à %{length} pixels",
        "dimension_max_inclusion": "doit être inférieur ou égal à %{width} x %{height} pixels",
        "dimension_min_inclusion": "doit être supérieur ou égal à %{width} x %{height} pixels",
        "dimension_width_equal_to": "la largeur doit être égale à %{length} pixels",
        "dimension_width_greater_than_or_equal_to": "la largeur doit être supérieure ou égale à %{length} pixels",
        "dimension_width_inclusion": "la largeur n'est pas comprise entre %{min} et %{max} pixels",
        "dimension_width_less_than_or_equal_to": "la largeur doit être inférieure ou égale à %{length} pixels",
        "empty": "doit être rempli(e)",
        "equal_to": "doit être égal à %{count}",
        "even": "doit être pair",
        "exclusion": "n'est pas disponible",
        "expired": "a expiré, merci d'en faire une nouvelle demande",
        "file_size_not_between": "la taille du fichier doit être comprise entre %{min_size} et %{max_size} (la taille actuelle est %{file_size})",
        "file_size_not_greater_than": "la taille du fichier doit être supérieure à %{min_size} (la taille actuelle est %{file_size})",
        "file_size_not_greater_than_or_equal_to": "la taille du fichier doit être supérieure ou égale à %{min_size} (la taille actuelle est %{file_size})",
        "file_size_not_less_than": "la taille du fichier doit être inférieure à %{max_size} (la taille actuelle est %{file_size})",
        "file_size_not_less_than_or_equal_to": "la taille du fichier doit être inférieure ou égale à %{max_size} (la taille actuelle est %{file_size})",
        "greater_than": "doit être supérieur à %{count}",
        "greater_than_or_equal_to": "doit être supérieur ou égal à %{count}",
        "image_metadata_missing": "n'est pas une image valide",
        "image_not_processable": "n'est pas une image valide",
        "in": "doit être dans l'intervalle %{count}",
        "inclusion": "n'est pas inclus(e) dans la liste",
        "invalid": "n'est pas valide",
        "less_than": "doit être inférieur à %{count}",
        "less_than_or_equal_to": "doit être inférieur ou égal à %{count}",
        "limit_out_of_range": "le nombre total est hors limites",
        "model_invalid": "Validation échouée : %{errors}",
        "not_a_number": "n'est pas un nombre",
        "not_an_integer": "doit être un nombre entier",
        "not_found": "n'a pas été trouvé(e)",
        "not_locked": "n'était pas verrouillé(e)",
        "not_saved": {
          "one": "1 erreur a empêché ce(tte) %{resource} d'être sauvegardé(e) :",
          "other": "%{count} erreurs ont empêché ce(tte) %{resource} d'être sauvegardé(e) :"
        },
        "odd": "doit être impair",
        "other_than": "doit être différent de %{count}",
        "present": "doit être vide",
        "required": "doit exister",
        "spoofed_content_type": "a un type de contenu qui n'est pas celui déclaré via son contenu, son nom de fichier et son extension",
        "taken": "est déjà utilisé(e)",
        "too_long": {
          "one": "est trop long (pas plus d'un caractère)",
          "other": "est trop long (pas plus de %{count} caractères)"
        },
        "too_short": {
          "one": "est trop court (au moins un caractère)",
          "other": "est trop court (au moins %{count} caractères)"
        },
        "total_file_size_not_between": "la taille totale des fichiers doit être comprise entre %{min_size} et %{max_size} (la taille actuelle est %{total_file_size})",
        "total_file_size_not_greater_than": "la taille totale des fichiers doit être supérieure à %{min_size} (la taille actuelle est %{total_file_size})",
        "total_file_size_not_greater_than_or_equal_to": "la taille totale des fichiers doit être supérieure ou égale à %{min_size} (la taille actuelle est %{total_file_size})",
        "total_file_size_not_less_than": "la taille totale des fichiers doit être inférieure à %{max_size} (la taille actuelle est %{total_file_size})",
        "total_file_size_not_less_than_or_equal_to": "la taille totale des fichiers doit être inférieure ou égale à %{max_size} (la taille actuelle est %{total_file_size})",
        "wrong_length": {
          "one": "ne fait pas la bonne longueur (doit comporter un seul caractère)",
          "other": "ne fait pas la bonne longueur (doit comporter %{count} caractères)"
        }
      },
      "template": {
        "body": "Veuillez vérifier les champs suivants : ",
        "header": {
          "one": "Impossible d'enregistrer ce(tte) %{model} : %{count} erreur",
          "other": "Impossible d'enregistrer ce(tte) %{model} : %{count} erreurs"
        }
      }
    },
    "export": "Exporter",
    "favorites": {
      "favorite": {
        "add_to_cart": "Ajouter au panier"
      },
      "index": {
        "title": "Mes favoris"
      }
    },
    "filter": "Filtrer :",
    "filters": {
      "periods": {
        "all_time": "Depuis toujours",
        "this_month": "Ce mois",
        "this_week": "Cette semaine",
        "this_year": "Cette année",
        "today": "Aujourd'hui"
      }
    },
    "helpers": {
      "select": {
        "prompt": "Veuillez sélectionner"
      },
      "submit": {
        "address": {
          "create": "Créer l'%{model}",
          "update": "Modifier l'%{model}"
        },
        "create": "Créer un(e) %{model}",
        "product": {
          "create": "Créer le %{model}",
          "update": "Modifier le %{model}"
        },
        "product_category": {
          "create": "Créer la %{model}",
          "update": "Modifier la %{model}"
        },
        "product_color": {
          "create": "Créer la %{model}",
          "update": "Modifier la %{model}"
        },
        "product_variant": {
          "create": "Créer la %{model}",
          "update": "Modifier la %{model}"
        },
        "promo_code": null,
        "store": {
          "create": "Créer la %{model}",
          "update": "Modifier la %{model}"
        },
        "submit": "Enregistrer ce(tte) %{model}",
        "update": "Modifier ce(tte) %{model}",
        "user": {
          "create": "Créer l'%{model}",
          "update": "Modifier l'%{model}"
        }
      }
    },
    "home": "Accueil",
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      },
      "transliterate": {
        "rule": {
          "À": "A",
          "Â": "A",
          "Æ": "Ae",
          "Ç": "C",
          "È": "E",
          "É": "E",
          "Ê": "E",
          "Ë": "E",
          "Î": "I",
          "Ï": "I",
          "Ô": "O",
          "Ù": "U",
          "Û": "U",
          "Ü": "U",
          "à": "a",
          "â": "a",
          "æ": "ae",
          "ç": "c",
          "è": "e",
          "é": "e",
          "ê": "e",
          "ë": "e",
          "î": "i",
          "ï": "i",
          "ô": "o",
          "ù": "u",
          "û": "u",
          "ü": "u",
          "ÿ": "y",
          "Œ": "Oe",
          "œ": "oe",
          "Ÿ": "Y"
        }
      }
    },
    "ice_cube": {
      "array": {
        "last_word_connector": ", et ",
        "two_words_connector": " et ",
        "words_connector": ", "
      },
      "at_hours_of_the_day": {
        "one": "à %{segments}h",
        "other": "aux %{segments} heures de la journée"
      },
      "at_seconds_of_minute": {
        "one": "à la %{segments} seconde",
        "other": "aux %{segments} secondes"
      },
      "date": {
        "day_names": [
          "dimanche",
          "lundi",
          "mardi",
          "mercredi",
          "jeudi",
          "vendredi",
          "samedi"
        ],
        "formats": {
          "default": "%d %B %Y"
        },
        "month_names": [
          null,
          "janvier",
          "février",
          "mars",
          "avril",
          "mai",
          "juin",
          "juillet",
          "août",
          "septembre",
          "octobre",
          "novembre",
          "décembre"
        ]
      },
      "days_of_month": {
        "one": "%{segments} jours du mois",
        "other": "%{segments} jours du mois"
      },
      "days_of_week": "%{segments} %{day}",
      "days_of_year": {
        "one": "%{segments} jours de l'année",
        "other": "%{segments} jours de l'année"
      },
      "days_on": [
        "dimanches",
        "lundis",
        "mardis",
        "mercredis",
        "jeudis",
        "vendredis",
        "samedis"
      ],
      "each_day": {
        "one": "Quotidien",
        "other": "Tous les %{count} jours"
      },
      "each_hour": {
        "one": "Toutes les heures",
        "other": "Toutes les %{count} heures"
      },
      "each_minute": {
        "one": "Toutes les minutes",
        "other": "Toutes les %{count} minutes"
      },
      "each_month": {
        "one": "Mensuel",
        "other": "Tous les %{count} mois"
      },
      "each_second": {
        "one": "Toutes les secondes",
        "other": "Toutes les %{count} secondes"
      },
      "each_week": {
        "one": "Hebdomadaire",
        "other": "Toutes les %{count} semaines"
      },
      "each_year": {
        "one": "Annuel",
        "other": "Tous les %{count} ans"
      },
      "in": "en %{target}",
      "integer": {
        "literal_ordinals": {
          "-1": "derniers",
          "-2": "avant-derniers"
        },
        "negative": "%{ordinal} depuis la fin",
        "ordinal": "%{number}%{ordinal}",
        "ordinals": {
          "1": "°",
          "default": "°"
        }
      },
      "not": "pas %{target}",
      "not_on": "pas durant %{target}",
      "on": "les %{sentence}",
      "on_days": "les %{days}",
      "on_minutes_of_hour": {
        "one": "à la %{segments} minute de l'heure",
        "other": "aux %{segments} minutes de l'heure"
      },
      "on_seconds_of_minute": {
        "one": "à la %{segments} seconde de la minute",
        "other": "aux %{segments} secondes de la minute"
      },
      "on_weekdays": "pendant les jours ouvrés",
      "on_weekends": "pendant les weekends",
      "pieces_connector": " / ",
      "string": {
        "format": {
          "count": "%{rest} %{current}",
          "day": "%{rest} %{current}",
          "day_of_month": "%{rest} %{current}",
          "day_of_week": "%{rest} %{current}",
          "day_of_year": "%{rest} %{current}",
          "default": "%{rest} %{current}",
          "hour_of_day": "%{rest} %{current}",
          "minute_of_hour": "%{rest} %{current}",
          "until": "%{rest} %{current}"
        }
      },
      "times": {
        "one": "%{count} fois",
        "other": "%{count} fois"
      },
      "until": "jusqu'au %{date}"
    },
    "layouts": {
      "admin": {
        "all_stores": "Toutes les boutiques",
        "commissions": "Commissions",
        "configuration": "Configuration",
        "dashboard": "Tableau de bord",
        "erp": "Accéder à l'ERP",
        "jobs": "Tâches",
        "monitoring": "Surveillance",
        "orders": "Commandes",
        "product_categories": "Catégories produits",
        "product_colors": "Couleurs produits",
        "products": "Produits",
        "promo_codes": "Codes promo",
        "statistics": "Statistiques",
        "storage": "Stockage",
        "stores": "Boutiques",
        "users": "Utilisateurs",
        "your_profile": "Votre profil"
      },
      "application": {
        "legal": "Mentions légales",
        "privacy": "Politique de confidentialité",
        "terms": "Conditions générales de vente"
      },
      "erp": {
        "modules": {
          "accounting": {
            "description": "Gestion financière et facturation",
            "name": "Comptabilité"
          },
          "administration": {
            "description": "Direction et pilotage stratégique",
            "name": "Administration"
          },
          "design": {
            "description": "Création et validation des visuels",
            "name": "Graphisme"
          },
          "inventory": {
            "description": "Gestion des stocks et approvisionnements",
            "name": "Inventaire"
          },
          "logistics": {
            "description": "Expéditions et livraisons",
            "name": "Logistique"
          },
          "production": {
            "description": "Fabrication et suivi de production",
            "name": "Production"
          },
          "sales": {
            "description": "Relation client et ventes",
            "name": "Commercial"
          },
          "stores": {
            "description": "Création et suivi des boutiques clients",
            "name": "Boutiques"
          }
        },
        "nav": {
          "access": "Accéder",
          "customers": "Clients",
          "dashboard": "Pilotage",
          "estimate_templates": "Modèles de devis",
          "estimates": "Devis",
          "pricing_grids": "Grilles tarifaires",
          "products": "Produits",
          "search": "Rechercher",
          "suppliers": "Fournisseurs"
        },
        "search": {
          "customers": "Clients",
          "estimates": "Devis",
          "min_chars": "Tapez au moins 2 caractères",
          "no_results": "Aucun résultat",
          "placeholder": "Rechercher clients, devis, produits...",
          "products": "Produits"
        }
      },
      "store_admin": {
        "all_my_stores": "Toutes mes boutiques",
        "configuration": "Configuration",
        "dashboard": "Tableau de bord",
        "orders": "Commandes",
        "products": "Produits",
        "promo_codes": "Codes promo",
        "statistics": "Statistiques",
        "stores": "Boutiques",
        "your_profile": "Votre profil"
      }
    },
    "missing": "Manquant(e)",
    "no_data": "Aucune donnée à afficher 🥲",
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 3,
        "round_mode": "default",
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "milliard",
            "million": "million",
            "quadrillion": "million de milliards",
            "thousand": "millier",
            "trillion": "billion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "octet",
              "other": "octets"
            },
            "eb": "Eo",
            "gb": "Go",
            "kb": "ko",
            "mb": "Mo",
            "pb": "Po",
            "tb": "To"
          }
        }
      },
      "nth": {},
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "open": "Ouvrir",
    "order_items": {
      "order_item": {
        "color": "Couleur",
        "quantity": "Quantité",
        "size": "Taille"
      }
    },
    "orders": {
      "delivery": {
        "account": "Compte",
        "additional_information": "Informations complémentaires",
        "address_save_failed": "Impossible d'enregistrer l'adresse. Corrigez les champs signalés et réessayez.",
        "billing_address": "Adresse de facturation",
        "billing_addresses": "Utiliser une adresse de facturation",
        "free": "Gratuit",
        "multiple_deliveries_help": "Les articles en stock seront expédiés immédiatement et le reste plus tard. Si vous optez pour la livraison, vous paierez deux fois les frais de port.",
        "my_order": "Ma commande",
        "next": "Suivant",
        "processing": "Traitement...",
        "shipping_address": "Adresse de livraison",
        "shipping_addresses": "Utiliser une adresse de livraison",
        "stock_warning": "Nous n'avons pas l'intégralité de vos articles en stock. Vous pouvez opter pour une expédition des articles en stock suivi d'une seconde livraison avec le reste des articles lors que nous les aurons.",
        "title": "Livraison",
        "use_shipping_address": "Identique livraison"
      },
      "failure": {
        "error_occured": "Une erreur est survenue pendant la validation de votre commande dans la boutique %{store}.",
        "failure": "Commande non validée. 👎",
        "my_order": "Ma commande",
        "retry": "Réessayer",
        "title": "Commande annulée"
      },
      "index": {
        "my_orders": "Mes commandes",
        "signout": "Déconnexion",
        "title": "Commandes"
      },
      "invoice": {
        "delivery": "Frais de port HT",
        "delivery_address": "Adresse de livraison",
        "discount": "Remise HT",
        "invoiced_at": "Date de facture",
        "item": {
          "name": "Article",
          "quantity": "Quantité",
          "total": "Total HT",
          "total_with_vat": "Total TTC",
          "unit_price": "Prix unitaire HT",
          "vat": "TVA"
        },
        "order_reference": "Référence de la commande",
        "store_name": "Boutique",
        "subtotal": "Sous-total HT",
        "title": "Facture %{reference}",
        "total": "Total HT",
        "total_with_vat": "Total TTC",
        "vat": "TVA"
      },
      "order": {
        "delivery": "Expédition : %{type}",
        "paid_at": "Payée le : %{date}",
        "total": "Total : %{amount}"
      },
      "order_information": {
        "delivery": "Livraison",
        "discount": "Remise",
        "free": "Gratuite",
        "to_be_defined": "à définir",
        "total": "Total",
        "total_items": {
          "one": "1 article",
          "other": "%{count} articles",
          "zero": "Aucun article"
        },
        "vat_rounding_adjustment": "Arrondi TVA"
      },
      "payment": {
        "next": "Suivant",
        "title": "Paiement"
      },
      "show": {
        "invoice": "Facture %{reference}",
        "my_orders": "Mes commandes",
        "state": "État de la commande :",
        "title": "Commande %{reference}"
      },
      "success": {
        "my_order": "Ma commande",
        "next": "Suivant",
        "success": "Commande validée ! 👍",
        "thank_you_for_your_order": "Merci pour votre commande dans la boutique %{store}.",
        "title": "Commande validée"
      }
    },
    "pages": {
      "home": {
        "title": "Accueil"
      }
    },
    "product_variants": {
      "designer": {
        "back": "Arrière",
        "base": "Base",
        "front": "Avant"
      }
    },
    "products": {
      "product": {
        "add_to_cart": "Ajouter"
      },
      "search": {
        "accessories": "Accessoires",
        "all_products": "Tous nos produits",
        "clothing": "Vêtements",
        "filter_color": "Couleurs",
        "filter_mode": "Mode",
        "filter_products": "Catégorie de produits",
        "filter_size": "Tailles",
        "pagy_product": {
          "one": "produit",
          "other": "produits",
          "zero": "produit"
        },
        "search_products": "Rechercher des produits",
        "title": "Résultats de recherche"
      },
      "show": {
        "add_to_cart": "Ajouter au panier",
        "back_customization": "Dos (%{price})",
        "chest_customization": "Poitrine (%{price})",
        "close": "Fermer",
        "colors": "Couleurs",
        "customization_saved": "Personnalisation enregistrée et ajoutée au panier",
        "customize": "Personnaliser",
        "customize_your_product": "Personnalisez votre produit",
        "description": "Description",
        "heart_customization": "Coeur (%{price})",
        "left_sleeve_customization": "Manche gauche (%{price})",
        "out_of_stock": "Nous n'avons plus cet article en stock.",
        "quantity": "Quantité",
        "right_sleeve_customization": "Manche droite (%{price})",
        "save_customization": "Enregistrer la personnalisation",
        "similar_products": "Produits similaires",
        "sizes": "Tailles",
        "sizes_guide": "Guide des tailles",
        "title": "Produit %{product}"
      }
    },
    "profiles": {
      "edit": {
        "account": "Compte",
        "leave_blank_if_you_dont_want_to_change_it": "(laissez vide si vous ne souhaitez pas le changer)",
        "minimum_password_length": "Minimum de %{count} caractères",
        "my_information": "Mon compte",
        "save": "Sauvegarder",
        "signout": "Déconnexion",
        "title": "Mon compte",
        "waiting_confirmation": "En attente de confirmation pour %{email}"
      }
    },
    "proof_approval_mailer": {
      "details": {
        "approver": "Approbateur prévu : %{email}",
        "information": "Pour information : %{emails}",
        "internal_note": "Note de la PAO : %{note}",
        "submitted": "Soumis par %{name} le %{date}"
      },
      "greeting": "Bonjour %{name},",
      "reminder": {
        "body": "Le BAT v%{version} de l'affaire %{reference} (%{customer}), soumis le %{date}, attend toujours votre approbation : le client ne l'a pas encore reçu.",
        "subject": "Rappel : BAT v%{version} de l'affaire %{reference} à approuver"
      },
      "requested": {
        "actions": "Depuis la page du devis, approuvez-le pour l'envoyer au client, ou renvoyez-le à la PAO avec un commentaire.",
        "body": "Le BAT v%{version} de l'affaire %{reference} (%{customer}) attend votre approbation avant de partir chez le client.",
        "cta": "Voir le BAT dans l'ERP",
        "subject": "BAT v%{version} de l'affaire %{reference} à approuver"
      },
      "returned": {
        "body": "%{name} vous renvoie le BAT v%{version} de l'affaire %{reference} (%{customer}) avant l'envoi au client :",
        "cta": "Reprendre le BAT",
        "subject": "BAT v%{version} de l'affaire %{reference} renvoyé à la PAO"
      }
    },
    "search": {
      "result": {
        "created_at": "Créé(e) il y a %{time}",
        "updated_at": "Mis(e) à jour il y a %{time}"
      }
    },
    "search_placeholder": "Rechercher...",
    "shared": {
      "account_navigation": {
        "addresses": "Adresses",
        "orders": "Commandes",
        "profile": "Profile"
      },
      "flashes": {
        "close": "Fermer"
      },
      "form_errors": {
        "save_error": "Erreur lors de la sauvegarde"
      },
      "funnel_steps": {
        "cart": "Panier",
        "delivery": "Livraison",
        "summary": "Récapitulatif",
        "summary_short": "Récap"
      }
    },
    "show": "Afficher",
    "store_admin": {
      "dashboard": {
        "index": {
          "last_month_orders": "Commandes du mois dernier par jour",
          "title": "Statistiques"
        }
      },
      "orders": {
        "index": {
          "title": "Commandes"
        },
        "order": {
          "delivery": "Expédition : %{type}",
          "paid_at": "Payée le : %{date}",
          "total": "Total : %{amount}"
        },
        "show": {
          "actions": "Actions disponibles",
          "billing_address": "Adresse de facturation",
          "cancel": "Annuler",
          "cancel_confirmation": "Annuler la commande %{order} ?",
          "customer": "Client",
          "delivery_to_store": "📦 Livraison à la boutique %{store}",
          "invoices": "Factures",
          "items": "Articles",
          "multiple_deliveries": "Expédition multiple",
          "no_customer": "Aucun client",
          "order": "Commande",
          "parcels": "Colis",
          "shipping_address": "Adresse de livraison",
          "summary": "Résumé",
          "title": "Commande %{order}"
        }
      },
      "product_variants": {
        "edit": {
          "title": "Modification de la variante %{product_variant}"
        },
        "form": {
          "base_variant": "Il s'agit de la variante de base importée depuis le fournisseur et n'étant pas liée à une boutique.",
          "batch_create": "Création en lot",
          "batch_update": "Mise à jour en lot",
          "create_other_product_variants_help": "Si activé, le variant sera dupliqué pour toutes les tailles du produit.",
          "images": "Images",
          "information": "Informations générales",
          "no_images": "Aucune image",
          "no_primary_image": "Aucune image principale",
          "pricing": "Tarification",
          "product_variant_enabled_help": "Les variantes de produits inactives ne sont pas achetables et restent cachés.",
          "store": "Boutique",
          "store_variant": "Il s'agit d'une variante liée à la boutique %{store}.",
          "supplier": "Informations fournisseur (%{supplier})",
          "update_other_product_variants_help": "Si activé, le nom et le prix de cette variante seront appliqués aux autres variantes de ce produit. Les images des variantes de taille différente, mais avec les mêmes couleurs, seront également mises à jour."
        },
        "image": {
          "delete": "Supprimer",
          "delete_confirmation": "Supprimer cette image ?"
        },
        "index": {
          "title": "Variantes de %{product}"
        },
        "new": {
          "title": "Nouvelle variante pour %{product}"
        },
        "product_variant": {
          "delete_confirmation": "Supprimer la variante %{product_variant} ?",
          "global": "Commun à toutes les boutiques",
          "price": "Prix : %{price}",
          "size": "Taille : %{size}",
          "specific_to_store": "Spécifique à %{store}"
        },
        "show": {
          "title": "Variante %{product_variant}"
        },
        "update": {
          "title": "Modification de la variante %{product_variant}"
        }
      },
      "products": {
        "edit": {
          "title": "Modification du produit %{product}"
        },
        "form": {
          "base_product": "Il s'agit du produit de base importé depuis le fournisseur et n'étant pas liée à une boutique.",
          "images": "Images",
          "information": "Informations générales",
          "no_images": "Aucune image",
          "no_sizes_guide": "Aucun guide de tailles disponible",
          "open_sizes_guide": "Voir le guide",
          "pricing": "Tarification",
          "product_enabled_help": "Les produits inactifs ne sont pas achetables et restent cachés.",
          "store": "Boutique",
          "store_product": "Il s'agit d'un produit lié à la boutique %{store}.",
          "supplier": "Fournisseur",
          "tags_placeholder": "Séparez vos tags par un espace"
        },
        "image": {
          "delete": "Supprimer",
          "delete_confirmation": "Supprimer cette image ?"
        },
        "index": {
          "title": "Mes produits"
        },
        "new": {
          "title": "Nouveau produit"
        },
        "product": {
          "created_at": "Créé le : %{date}",
          "delete_confirmation": "Supprimer le produit %{product} ?",
          "global": "Commun à toutes les boutiques",
          "reference": "Référence : %{reference}",
          "specific_to_store": "Spécifique à %{store}",
          "supplier": "Fournisseur : %{supplier}"
        },
        "show": {
          "add_product_variant": "Ajouter un variant",
          "disable_all": "Désactiver tout",
          "disable_color_confirmation": "Désactiver toutes les variantes de la couleur %{color} ?",
          "duplicate_for_store": "Dupliquer pour %{store}",
          "duplicate_for_store_confirmation": "Dupliquer le produit et tous ses variants pour la boutique %{store} ?",
          "enable_all": "Activer tout",
          "enable_color_confirmation": "Activer toutes les variantes de la couleur %{color} ?",
          "title": "Produit %{product}",
          "variants": "Variantes"
        },
        "update": {
          "title": "Modification du produit %{product}"
        }
      },
      "promo_codes": {
        "edit": {
          "title": "Modification du code promo %{promo_code}"
        },
        "form": {
          "information": "Informations générales",
          "promo_code_enabled_help": "Les codes promo inactifs ne sont pas utilisables sur les boutiques.",
          "select_a_store": "Sélectionnez une boutique"
        },
        "index": {
          "contact_support": "Veuillez contacter le support SOFIDIAL pour créer un code promo ou gérer les codes promo existants.",
          "title": "Codes promo"
        },
        "new": {
          "title": "Nouveau code promo"
        },
        "promo_code": {
          "code_type": "Type : %{type}",
          "created_at": "Créé le : %{date}",
          "delete_confirmation": "Supprimer le code promo %{promo_code} ?",
          "utilizations": "Utilisations : %{value}",
          "value": "Valeur : %{value}"
        },
        "show": {
          "title": "Code promo %{promo_code}"
        }
      },
      "search": {
        "index": {
          "search_results": "Résultats de recherche pour %{query}",
          "title": "Résultats de recherche pour %{query}"
        }
      },
      "stores": {
        "edit": {
          "title": "Modification de la boutique %{store}"
        },
        "form": {
          "add_field": "Ajouter un champ",
          "billing_address": "Adresse facturation",
          "custom_fields": "Champs personnalisés",
          "delete_banner": "Supprimer la bannière",
          "delete_banner_confirmation": "Supprimer la bannière de la boutique ?",
          "delete_mobile_banner": "Supprimer la bannière mobile",
          "delete_mobile_banner_confirmation": "Supprimer la bannière mobile de la boutique ?",
          "dns_setup_documentation_html": "Créez un enregistrement <code>CNAME</code> pointant vers <code>%{target}<c/ode> dans la zone DNS de votre domaine.",
          "information": "Informations générales",
          "mobile_banner_help": "Image affichée uniquement sur mobile, remplaçant le message texte de la bannière.",
          "payment_and_billing": "Paiement et facturation",
          "remove_field": "Retirer",
          "shipping_address": "Adresse de livraison",
          "store_enabled_help": "Les boutiques inactives restent cachées.",
          "urls": "URLs",
          "use_shipping_address": "Identique livraison"
        },
        "index": {
          "title": "Mes boutiques"
        },
        "product": {
          "delete_confirmation": "Désactiver le produit %{product} de la boutique ?",
          "deleting": "Désactivation en cours...",
          "product_since": "Depuis le %{date}",
          "store_product": "Spécifique à %{store}",
          "variants": {
            "one": "1 variante",
            "other": "%{count} variantes",
            "zero": "Aucune variante"
          }
        },
        "show": {
          "add_admin": "Ajouter",
          "add_product": "Ajouter",
          "no_matching_products": "Aucun produit ne correspond à votre recherche.",
          "products": "Produits",
          "search_products": "Rechercher un produit par nom ou référence",
          "select_a_new_admin": "Sélectionnez un nouvel administrateur",
          "select_a_new_product": "Sélectionnez un nouveau produit",
          "sort": "Trier",
          "store_admins": "Administrateurs",
          "store_products": "Produits actifs",
          "title": "Boutique %{store}"
        },
        "sort_products": {
          "title": "Trier les produits"
        },
        "user": {
          "admin_since": "Depuis le %{date}"
        }
      }
    },
    "stores": {
      "show": {
        "accessories": "Accessoires",
        "all_products": "Tous nos produits",
        "clothing": "Vêtements",
        "filter_color": "Couleurs",
        "filter_mode": "Mode",
        "filter_products": "Catégorie de produits",
        "filter_size": "Tailles",
        "filter_tag": "Thèmes",
        "pagy_product": {
          "one": "produit",
          "other": "produits",
          "zero": "produit"
        },
        "search_products": "Rechercher des produits",
        "title": "Tous nos produits"
      }
    },
    "support": {
      "array": {
        "last_word_connector": " et ",
        "two_words_connector": " et ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%d %B %Y %Hh %Mmin %Ss",
        "long": "%A %d %B %Y %Hh%M",
        "short": "%d %b %Hh%M",
        "time": "%H:%M"
      },
      "pm": "pm"
    }
  }
});
i18n.locale = window.Sofidial.locale;
export default i18n;
